import * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export const SignatureRequestFragmentDoc = gql`
    fragment SignatureRequest on SignatureRequestObject {
  id
  provider
  externalId
  allSignedDocument {
    fileName
    url
  }
}
    `;
export const InputFormatFragmentDoc = gql`
    fragment InputFormat on InputFormatObject {
  type
  options {
    precision
    formatString
    currencySymbol
  }
}
    `;
export const BoundingBoxFragmentDoc = gql`
    fragment BoundingBox on BoundingBoxObject {
  left
  top
  right
  bottom
}
    `;
export const DocumentVersionFieldFragmentDoc = gql`
    fragment DocumentVersionField on DocumentVersionFieldObject {
  id
  align
  pageNumber
  fontFamily
  fontSize
  label
  inputFormat {
    ...InputFormat
  }
  boundingBox {
    ...BoundingBox
  }
  readOnly
  width
  height
  x
  y
  mappingKey
  fieldType
  labelBoundingBox {
    ...BoundingBox
  }
  labelField {
    height
    width
    x
    y
  }
}
    ${InputFormatFragmentDoc}
${BoundingBoxFragmentDoc}`;
export const FieldFragmentDoc = gql`
    fragment Field on FieldObject {
  id
  group
  label
  displayLabel
  mappingKey
  fieldType
  isComputed
  isHidden
  readOnly
  aiExtract
  aiInterpret
  comparisonType
  inputFormat {
    ...InputFormat
  }
}
    ${InputFormatFragmentDoc}`;
export const VariableFieldFragmentDoc = gql`
    fragment VariableField on VariableFieldObject {
  key
  type
  source
}
    `;
export const AutofillFragmentDoc = gql`
    fragment Autofill on AutofillObject {
  id
  variableSources
  formula
  variableField {
    ...VariableField
  }
  formulaVariableFields {
    ...VariableField
  }
  formulaTestCases {
    values
    expected
    llmOutput
  }
  documents {
    id
    name
    description
    documentCategory
    documentType
    form
    usState
  }
}
    ${VariableFieldFragmentDoc}`;
export const RuleFragmentDoc = gql`
    fragment Rule on RuleObject {
  id
  message
  contextForLLMJudge
  ruleType
  autofill {
    ...Autofill
  }
}
    ${AutofillFragmentDoc}`;
export const ContractDetailFragmentDoc = gql`
    fragment ContractDetail on ContractObject {
  id
  fieldValues
  signatureRequests {
    ...SignatureRequest
  }
  extractedValues @include(if: $extractedValues) {
    values
    mappedValuesBBox
    signatureInitialsBBox
    repositionedDocumentVersionFields {
      ...DocumentVersionField
      field {
        ...Field
      }
    }
  }
  documentML @include(if: $documentML) {
    id
    pdfFileUrl
    documentClassification
    documentFile {
      fileName
      url
    }
  }
  contractDocuments {
    id
    order
    file {
      fileName
      url
    }
    externalDocumentName
    externalDocumentType
    documentVersion {
      id
      document {
        id
        form
        name
        documentType
      }
      file @include(if: $documentVersionFile) {
        fileName
        url
      }
      documentVersionFields @include(if: $documentVersionFields) {
        ...DocumentVersionField
        autofill @include(if: $autofill) {
          ...Autofill
        }
        rules @include(if: $autofill) {
          ...Rule
        }
        field {
          ...Field
          readOnly
          defaultRules @include(if: $autofill) {
            ...Rule
          }
          autofill @include(if: $autofill) {
            ...Autofill
          }
        }
      }
    }
  }
}
    ${SignatureRequestFragmentDoc}
${DocumentVersionFieldFragmentDoc}
${FieldFragmentDoc}
${AutofillFragmentDoc}
${RuleFragmentDoc}`;
export const ContractDocumentForContractFragmentDoc = gql`
    fragment ContractDocumentForContract on ContractDocumentObject {
  id
  order
  documentVersion {
    id
    document {
      id
      name
      form
      documentType
    }
    mappingKeys
    version
  }
  file {
    fileName
    url
  }
  externalDocumentType
  externalDocumentName
}
    `;
export const ContractValidationFragmentDoc = gql`
    fragment ContractValidation on ContractValidationObject {
  field {
    id
    mappingKey
    fieldType
    label
    displayLabel
    group
    inputFormat {
      type
      options {
        precision
        formatString
        currencySymbol
      }
    }
  }
  documentVersionField {
    id
    mappingKey
    fieldType
    label
    displayLabel
    inputFormat {
      type
      options {
        precision
        formatString
        currencySymbol
      }
    }
  }
  results {
    inputValue
    message
    validationValue
    rule {
      id
      ruleType
    }
  }
}
    `;
export const ClassificationAlternativeCandidateFragmentDoc = gql`
    fragment ClassificationAlternativeCandidate on BasePagePrediction {
  formName
  usState
  version
  searchRegex
  documentCategory
  documentType
  score
  humanLabeled
  pageNumber
  containment
  formOrVersionMatch
}
    `;
export const DocumentClassificationEvaluationFragmentDoc = gql`
    fragment DocumentClassificationEvaluation on DocumentClassificationEvaluationObject {
  id
  createdAt
  updatedAt
  file {
    fileName
    url
  }
  expectedCategory
  expectedDocumentType
  expectedUsState
  expectedValues
  extractedValues
  extractedAiValues
  combinedExtractedValues
  mappedValuesBBox
  isBlankDocument
  lowConfidenceFields
  filteredOutItems {
    text
    mappingKey
    pageNumber
    boundingBox
    fieldType
    filterReason
    confidence
    targetConfidence
    intersectionOverArea
    targetIntersection
  }
  lastExtractedAt
  classification {
    pageNumber
    formName
    version
    searchRegex
    humanLabeled
    usState
    documentCategory
    documentType
    score
    containment
    classificationMethod
    formOrVersionMatch
    alternativeCandidates {
      ...ClassificationAlternativeCandidate
    }
    candidateDocumentCategories {
      documentCategory
      score
    }
  }
}
    ${ClassificationAlternativeCandidateFragmentDoc}`;
export const ExtractSchemaFragmentDoc = gql`
    fragment ExtractSchema on LLMExtractSchemaObject {
  key
  description
  outputType
  enumValues
}
    `;
export const DocumentLlmExampleFragmentDoc = gql`
    fragment DocumentLLMExample on DocumentLLMExampleObject {
  id
  file {
    fileName
    url
  }
}
    `;
export const DocumentLlmFragmentDoc = gql`
    fragment DocumentLLM on DocumentLLMObject {
  id
  documentCategory
  context @include(if: $isDetail)
  extractSchema @include(if: $isDetail) {
    ...ExtractSchema
  }
  pages @include(if: $isDetail)
  documents {
    id
    name
    form
    usState
    documentType
  }
  examples @include(if: $isDetail) {
    ...DocumentLLMExample
  }
}
    ${ExtractSchemaFragmentDoc}
${DocumentLlmExampleFragmentDoc}`;
export const DocumentLlmEvaluationFragmentDoc = gql`
    fragment DocumentLLMEvaluation on DocumentLLMEvaluationObject {
  id
  file {
    fileName
    url
  }
  expectedOutput
  document {
    id
    name
    form
  }
  documentLLM {
    id
  }
}
    `;
export const PageInfoFragmentDoc = gql`
    fragment PageInfo on PageInfoObject {
  totalCount
  hasNextPage
  hasPrevPage
  nextCursor
  prevCursor
}
    `;
export const SignatureFormFieldFragmentDoc = gql`
    fragment SignatureFormField on SignatureFormFieldObject {
  id
  documentIndex
  x
  y
  height
  isRequired
  name
  page
  signerId
  type
  width
  x
}
    `;
export const DetectFormFieldsFragmentDoc = gql`
    fragment DetectFormFields on DocumentVersionFieldObject {
  ...DocumentVersionField
  field {
    id
    fieldType
    mappingKey
    label
  }
}
    ${DocumentVersionFieldFragmentDoc}`;
export const ExtractContractMutationFragmentDoc = gql`
    fragment ExtractContractMutation on ExtractContractPayload {
  contract {
    id
    fieldValues
    contractDocuments {
      id
      documentVersion {
        id
      }
    }
  }
  extracted {
    formName
    documentType
    usState
    values
  }
}
    `;
export const GenericRuleValidationFragmentDoc = gql`
    fragment GenericRuleValidation on GenericRuleValidationObject {
  rule {
    ...Rule
  }
  message
  isEnabled
  isDisabled
  hasError
  hasWarning
  passedRequirement
  output
  inputValues {
    value
    fieldKey
  }
}
    ${RuleFragmentDoc}`;
export const DocumentValidationResultFragmentDoc = gql`
    fragment DocumentValidationResult on DocumentValidationResult {
  contractDocumentId
  documentVersionId
  documentName
  documentForm
  documentCategory
  ingestionDocumentId
  validations {
    field {
      id
      label
      mappingKey
      fieldType
      displayLabel
    }
    documentVersionField {
      id
      fieldType
      displayLabel
      label
      mappingKey
      pageNumber
      x
      y
      width
      height
    }
    results {
      ...GenericRuleValidation
    }
  }
}
    ${GenericRuleValidationFragmentDoc}`;
export const PipelineValidationResultFragmentDoc = gql`
    fragment PipelineValidationResult on PipelineValidationResult {
  contractDocumentId
  documentCategory
  documentForm
  documentName
  operator
  children {
    contractDocumentId
    documentCategory
    documentForm
    documentName
    operator
    results {
      ...GenericRuleValidation
    }
    requiredDocument {
      isRequired
      isMissing
      message
    }
  }
  results {
    ...GenericRuleValidation
  }
  requiredDocument {
    isRequired
    isMissing
    message
  }
}
    ${GenericRuleValidationFragmentDoc}`;
export const FieldsToColumnFragmentDoc = gql`
    fragment FieldsToColumn on FieldsToColumnObject {
  id
  columnName
  visibility
  fieldType
  documentCategory
  fields {
    ...Field
  }
  transformAutofill {
    ...Autofill
  }
}
    ${FieldFragmentDoc}
${AutofillFragmentDoc}`;
export const ComplianceKeyTermSectionFieldFragmentDoc = gql`
    fragment ComplianceKeyTermSectionField on ComplianceKeyTermSectionFieldObject {
  id
  order
  helpText
  fieldsToColumn {
    ...FieldsToColumn
  }
}
    ${FieldsToColumnFragmentDoc}`;
export const ComplianceKeyTermSectionFragmentDoc = gql`
    fragment ComplianceKeyTermSection on ComplianceKeyTermSectionObject {
  id
  title
  description
  order
  documentSectionType
  category
  organizationUuid
  complianceKeyTermSectionFields {
    ...ComplianceKeyTermSectionField
  }
}
    ${ComplianceKeyTermSectionFieldFragmentDoc}`;
export const ComplianceKeyTermSectionListFragmentDoc = gql`
    fragment ComplianceKeyTermSectionList on ComplianceKeyTermSectionObject {
  ...ComplianceKeyTermSection
  parent {
    id
    title
    description
  }
}
    ${ComplianceKeyTermSectionFragmentDoc}`;
export const ContractFieldValuesFragmentDoc = gql`
    fragment ContractFieldValues on ContractObject {
  id
  fieldValues
}
    `;
export const DocumentFragmentDoc = gql`
    fragment Document on DocumentObject {
  id
  documentType
  documentCategory
  name
  description
  form
  usState
  includeInOfferIngestion
  llmExtraction
  updatedAt
}
    `;
export const DocumentVersionFragmentDoc = gql`
    fragment DocumentVersion on DocumentVersionObject {
  id
  status
  searchRegex
  version
  file {
    fileName
    url
  }
}
    `;
export const DefaultSecondaryDocumentFragmentDoc = gql`
    fragment DefaultSecondaryDocument on DefaultSecondaryDocumentObject {
  id
  ordering
  mappingKey
  defaultRules {
    ...Rule
  }
  secondaryDocument {
    id
    documentType
    form
    name
    usState
  }
}
    ${RuleFragmentDoc}`;
export const FieldDetailFragmentDoc = gql`
    fragment FieldDetail on FieldObject {
  id
  autofill {
    ...Autofill
  }
  optionsAutofill {
    ...Autofill
  }
  helpTextAutofill {
    ...Autofill
  }
  defaultRules {
    ...Rule
  }
}
    ${AutofillFragmentDoc}
${RuleFragmentDoc}`;
export const DocumentListFragmentDoc = gql`
    fragment DocumentList on DocumentObject {
  ...Document
  hasUnmappedFields
  subsetOfDocument @include(if: $includeSubsetOfDocument) {
    id
    name
    form
    usState
  }
  documentVersions @include(if: $includeDocumentVersions) {
    ...DocumentVersion
    documentVersionFieldsCount
  }
  defaultSecondaryDocuments @include(if: $includeDefaultSecondaryDocuments) {
    ...DefaultSecondaryDocument
  }
  activeDocumentVersion @include(if: $includeActiveDocumentVersion) {
    ...DocumentVersion
    documentVersionFields {
      ...DocumentVersionField
      field {
        ...Field
        ...FieldDetail
      }
    }
  }
}
    ${DocumentFragmentDoc}
${DocumentVersionFragmentDoc}
${DefaultSecondaryDocumentFragmentDoc}
${DocumentVersionFieldFragmentDoc}
${FieldFragmentDoc}
${FieldDetailFragmentDoc}`;
export const DocumentAssetFileFragmentDoc = gql`
    fragment DocumentAssetFile on AssetFileObject {
  id
  ordering
  file {
    url
  }
}
    `;
export const PublicDocumentForOfferFlowFragmentDoc = gql`
    fragment PublicDocumentForOfferFlow on PublicDocumentObject {
  id
  description
  form
  name
  documentType
  defaultSecondaryDocuments @include(if: $defaultSecondaryDocuments) {
    id
    mappingKey
    ordering
    secondaryDocument {
      id
      name
      form
      activeDocumentVersion {
        id
      }
    }
  }
  activeDocumentVersion @include(if: $activeDocumentVersion) {
    id
    previewImages: hiddenPreviewImages {
      ...DocumentAssetFile
    }
  }
}
    ${DocumentAssetFileFragmentDoc}`;
export const DocumentForOfferFlowFragmentDoc = gql`
    fragment DocumentForOfferFlow on DocumentObject {
  id
  description
  form
  name
  documentType
  defaultSecondaryDocuments @include(if: $defaultSecondaryDocuments) {
    id
    mappingKey
    ordering
    secondaryDocument {
      id
      name
      form
    }
  }
  activeDocumentVersion @include(if: $activeDocumentVersion) {
    id
    previewImages {
      ...DocumentAssetFile
    }
  }
}
    ${DocumentAssetFileFragmentDoc}`;
export const DocumentSectionFragmentDoc = gql`
    fragment DocumentSection on DocumentSectionObject {
  id
  description
  documentSectionDisplayType
  documentSectionType
  documentSectionCategory
  documentSectionModuleType
  title
  order
  documentSectionFields {
    id
    order
    field {
      ...Field
      ...FieldDetail
    }
  }
}
    ${FieldFragmentDoc}
${FieldDetailFragmentDoc}`;
export const DocumentSectionListFragmentDoc = gql`
    fragment DocumentSectionList on DocumentSectionObject {
  ...DocumentSection
  parent {
    id
    description
  }
}
    ${DocumentSectionFragmentDoc}`;
export const PublicFieldFragmentDoc = gql`
    fragment PublicField on PublicFieldObject {
  id
  group
  label
  mappingKey
  fieldType
  isComputed
  isHidden
  readOnly
  comparisonType
  inputFormat {
    ...InputFormat
  }
  autofill {
    id
    formulaVariableFields {
      key
      source
      type
    }
    variableField {
      key
      source
      type
    }
  }
}
    ${InputFormatFragmentDoc}`;
export const DocumentSectionListForOfferFlowFieldFragmentDoc = gql`
    fragment DocumentSectionListForOfferFlowField on PublicDocumentSectionFieldObject {
  id
  order
  field {
    ...PublicField
  }
}
    ${PublicFieldFragmentDoc}`;
export const DocumentSectionListForOfferFlowFragmentDoc = gql`
    fragment DocumentSectionListForOfferFlow on PublicDocumentSectionObject {
  id
  title
  description
  documentSectionType
  documentSectionDisplayType
  documentSectionCategory
  documentSectionModuleType
  order
  document {
    id
    usState
  }
  parent {
    id
    description
  }
  documentSectionFields {
    ...DocumentSectionListForOfferFlowField
  }
}
    ${DocumentSectionListForOfferFlowFieldFragmentDoc}`;
export const DocumentVersionListFieldFragmentDoc = gql`
    fragment DocumentVersionListField on DocumentVersionFieldObject {
  ...DocumentVersionField
  autofill {
    ...Autofill
  }
  field {
    ...Field
    autofill {
      ...Autofill
    }
  }
}
    ${DocumentVersionFieldFragmentDoc}
${AutofillFragmentDoc}
${FieldFragmentDoc}`;
export const SecondaryDocumentVersionFragmentDoc = gql`
    fragment SecondaryDocumentVersion on SecondaryDocumentVersionObject {
  id
  ordering
  rules {
    ...Rule
    autofill {
      ...Autofill
    }
  }
  secondaryDocumentVersion {
    id
    version
    status
    searchRegex
    file {
      fileName
      url
    }
    document {
      ...Document
    }
  }
}
    ${RuleFragmentDoc}
${AutofillFragmentDoc}
${DocumentFragmentDoc}`;
export const DocumentVersionListFragmentDoc = gql`
    fragment DocumentVersionList on DocumentVersionObject {
  ...DocumentVersion
  document @include(if: $document) {
    ...Document
  }
  documentVersionFields @include(if: $fields) {
    ...DocumentVersionListField
  }
  secondaryDocumentVersions @include(if: $secondaryDocumentVersions) {
    ...SecondaryDocumentVersion
  }
}
    ${DocumentVersionFragmentDoc}
${DocumentFragmentDoc}
${DocumentVersionListFieldFragmentDoc}
${SecondaryDocumentVersionFragmentDoc}`;
export const PublicDocumentVersionFieldFragmentDoc = gql`
    fragment PublicDocumentVersionField on PublicDocumentVersionFieldObject {
  id
  align
  pageNumber
  fontFamily
  fontSize
  label
  inputFormat {
    ...InputFormat
  }
  boundingBox {
    ...BoundingBox
  }
  readOnly
  width
  height
  x
  y
  mappingKey
  fieldType
}
    ${InputFormatFragmentDoc}
${BoundingBoxFragmentDoc}`;
export const PublicDocumentVersionForOfferFlowFragmentDoc = gql`
    fragment PublicDocumentVersionForOfferFlow on PublicDocumentVersionObject {
  id
  previewImages: hiddenPreviewImages @include(if: $previewImages) {
    ...DocumentAssetFile
  }
  documentVersionFields {
    ...PublicDocumentVersionField
    field {
      ...PublicField
    }
  }
  document {
    id
  }
  secondaryVersions @skip(if: $skipSecondaryVersions) {
    id
    mappingKeys
    previewImages: hiddenPreviewImages @include(if: $previewImages) {
      ...DocumentAssetFile
    }
    documentVersionFields @include(if: $documentVersionFields) {
      ...PublicDocumentVersionField
      field {
        ...PublicField
      }
    }
    document {
      id
      name
      usState
      form
    }
  }
}
    ${DocumentAssetFileFragmentDoc}
${PublicDocumentVersionFieldFragmentDoc}
${PublicFieldFragmentDoc}`;
export const DocumentVersionForOfferFlowFragmentDoc = gql`
    fragment DocumentVersionForOfferFlow on DocumentVersionObject {
  id
  status
  version
  file {
    fileName
    url
  }
  documentVersionFields {
    ...DocumentVersionField
    field {
      ...Field
    }
  }
  document {
    id
  }
  secondaryVersions @skip(if: $skipSecondaryVersions) {
    id
    status
    version
    file {
      fileName
      url
    }
    mappingKeys
    previewImages @include(if: $previewImages) {
      id
    }
    documentVersionFields @include(if: $documentVersionFields) {
      ...DocumentVersionField
      field {
        ...Field
      }
    }
    document {
      id
      name
      usState
      form
    }
  }
}
    ${DocumentVersionFieldFragmentDoc}
${FieldFragmentDoc}`;
export const EmbeddedSignatureRequestSecondaryDocumentFragmentDoc = gql`
    fragment EmbeddedSignatureRequestSecondaryDocument on DocumentObject {
  id
  name
  activeDocumentVersion {
    id
    file {
      fileName
      url
    }
  }
}
    `;
export const EmbeddedSignatureRequestFragmentDoc = gql`
    fragment EmbeddedSignatureRequest on ContractEmbeddedSignatureRequestPayload {
  isExpired
  contract {
    id
    fieldValues
  }
  primaryDocument {
    id
    documentType
    name
    defaultSecondaryDocuments {
      id
      secondaryDocument {
        ...EmbeddedSignatureRequestSecondaryDocument
      }
    }
  }
  signer {
    id
    signedAt
    fullName
  }
  signatureRequest {
    id
    requester {
      id
      firstName
      lastName
      fullName
      profilePicture {
        fileName
        url
      }
    }
  }
}
    ${EmbeddedSignatureRequestSecondaryDocumentFragmentDoc}`;
export const ExternalIngestionFolderMlsListingFragmentDoc = gql`
    fragment ExternalIngestionFolderMLSListing on MLSListingObject {
  id
  mlsId
  listingId
  mls {
    originatingSystemName
    statusText
    logoUrl
  }
  address {
    full
    unit
    city
    state
    postalCode
  }
  property {
    type
    subType
    subTypeText
  }
}
    `;
export const MlsListingSelectionInfoFragmentDoc = gql`
    fragment MLSListingSelectionInfo on MLSListingObject {
  ...ExternalIngestionFolderMLSListing
  addressFull
  listDate
  listPrice
}
    ${ExternalIngestionFolderMlsListingFragmentDoc}`;
export const ExternalDarwinPropertyFieldsFragmentDoc = gql`
    fragment ExternalDarwinPropertyFields on DarwinPropertyObject {
  propertyId
  propertyAddress
  mlsNumber1
  statusId
  status
  companyID
  ourList
  ourSell
  sellingPrice
  commissionPrice
  pendingDate
  estimatedClosingDate
  listingPrice
  listDate
  typeCode
  typeCodeName
  propertyUseId
  propertyTypeId
  propertyTypeName
  classificationId
  classificationName
  createdBy
  sellCommRate
  sellCommission
  isFlatCommission
  listCommRate
  listCommission
  cobrokeCommRate
  cobrokeCommission
  streetNumber
  streetDirection
  streetName
  streetDesignation
  streetSuffix
  suiteAptNumber
  city
  state
  zip
  mlsListing {
    ...MLSListingSelectionInfo
  }
}
    ${MlsListingSelectionInfoFragmentDoc}`;
export const IngestionFolderFragmentDoc = gql`
    fragment IngestionFolder on IngestionFolderObject {
  id
  platform
  organizationUuid
  folderId
  folderName
  transactionSide
  status
  normalizedStatus
  stage
  activeMlsListingId
  metadata
  createdAt
  organization {
    id
    name
  }
}
    `;
export const TransactionPipelineFragmentDoc = gql`
    fragment TransactionPipeline on TransactionPipelineObject {
  id
  clientType
  usState
  transactionPropertyType
}
    `;
export const IngestionDocumentFragmentDoc = gql`
    fragment IngestionDocument on IngestionDocumentObject {
  id
  documentId
  documentName
  documentCreatedAt
  documentUpdatedAt
  isBlank
  s3Bucket
  s3Key
  fileUrl
}
    `;
export const IngestionDocumentWithContractsFragmentDoc = gql`
    fragment IngestionDocumentWithContracts on IngestionDocumentObject {
  ...IngestionDocument
  contractDocuments {
    id
    order
    file {
      fileName
      url
    }
    externalDocumentType
    externalDocumentName
    documentCategory
    documentVersion {
      id
      document {
        id
        name
        form
        documentType
      }
      version
    }
  }
  fields @include(if: $includeRepositionedFields)
  contractDocumentPages
}
    ${IngestionDocumentFragmentDoc}`;
export const IngestionFolderListFragmentDoc = gql`
    fragment IngestionFolderList on IngestionFolderObject {
  ...IngestionFolder
  transactionPipeline @include(if: $includeTransactionPipeline) {
    ...TransactionPipeline
  }
  ingestionDocuments @include(if: $includeIngestionDocuments) {
    ...IngestionDocumentWithContracts
  }
}
    ${IngestionFolderFragmentDoc}
${TransactionPipelineFragmentDoc}
${IngestionDocumentWithContractsFragmentDoc}`;
export const IngestionFolderForPipelineViewFragmentDoc = gql`
    fragment IngestionFolderForPipelineView on IngestionFolderObject {
  ...IngestionFolder
  txPipelineNeedsInvestigationReason @include(if: $includeInvestigationReason)
}
    ${IngestionFolderFragmentDoc}`;
export const TransactionStageFragmentDoc = gql`
    fragment TransactionStage on TransactionStageObject {
  id
  stage
  sortOrder
}
    `;
export const RuleCompactFragmentDoc = gql`
    fragment RuleCompact on RuleObject {
  id
  message
  ruleType
}
    `;
export const TransactionRuleFragmentDoc = gql`
    fragment TransactionRule on TransactionRuleObject {
  id
  organizationUuid
  targetDocumentCategory
  isRequiredDocument
  logicalOperator
  updatedAt
  targetDocument {
    ...Document
  }
  parent {
    id
  }
  offerIngestionRule {
    ...RuleCompact
  }
  children {
    organizationUuid
    id
    targetDocumentCategory
    logicalOperator
    updatedAt
    isRequiredDocument
    offerIngestionRule {
      ...RuleCompact
    }
    parent {
      id
    }
    targetDocument {
      ...Document
    }
    rules {
      ...RuleCompact
    }
  }
  rules {
    ...RuleCompact
  }
}
    ${DocumentFragmentDoc}
${RuleCompactFragmentDoc}`;
export const TransactionPipelineListFragmentDoc = gql`
    fragment TransactionPipelineList on TransactionPipelineObject {
  ...TransactionPipeline
  rule @include(if: $includeRule) {
    ...Rule
  }
  stages @include(if: $includeStages) {
    ...TransactionStage
    stageRequirementRules @include(if: $includeTransactionRules) {
      ...TransactionRule
    }
    validationRules @include(if: $includeTransactionRules) {
      ...TransactionRule
    }
  }
}
    ${TransactionPipelineFragmentDoc}
${RuleFragmentDoc}
${TransactionStageFragmentDoc}
${TransactionRuleFragmentDoc}`;
export const IngestionDocumentValidationFragmentDoc = gql`
    fragment IngestionDocumentValidation on IngestionDocumentValidationObject {
  id
  isCurrent
  version
  errorCount
  warningCount
  aiErrorCount
  aiWarningCount
  validationResults
  aiValidationResults
  aiAnalysis
  createdAt
  updatedAt
  ingestionDocument {
    id
  }
}
    `;
export const IngestionFolderValidationFragmentDoc = gql`
    fragment IngestionFolderValidation on IngestionFolderValidationObject {
  id
  isCurrent
  version
  errorCount
  validationResults
  createdAt
  validatedAt
  updatedAt
  ingestionFolder {
    id
  }
}
    `;
export const IngestionFolderPropertyFragmentDoc = gql`
    fragment IngestionFolderProperty on DocumentPropertyObject {
  id
  slug
  streetAddress
  unit
  city
  state
  zipCode
  zipCodePlus4
  county
  countyFips
  msa
  lot
  block
  platBook
  platBookPage
  subdivision
  parcelId
  yearBuilt
  otherLegalDescription
  geo {
    lat
    lng
  }
}
    `;
export const IngestionFolderAutofillDataFragmentDoc = gql`
    fragment IngestionFolderAutofillData on OfferIngestionAutofillObject {
  ingestion {
    transactionSide
    metadata {
      agent_name
      folder_name
      participants {
        buyerAgentNames
        listingAgentNames
        buyerNames
        sellerNames
        otherTeamMemberNames
      }
      folder_id
      office_id
      office_name
      transaction_closing_date
    }
  }
}
    `;
export const ExternalValidationReportDataFragmentDoc = gql`
    fragment ExternalValidationReportData on ValidationReportDataObject {
  documentValidations {
    ...IngestionDocumentValidation
  }
  folderValidation {
    ...IngestionFolderValidation
  }
  keyTerms
  property {
    ...IngestionFolderProperty
  }
  autofillData {
    ...IngestionFolderAutofillData
  }
}
    ${IngestionDocumentValidationFragmentDoc}
${IngestionFolderValidationFragmentDoc}
${IngestionFolderPropertyFragmentDoc}
${IngestionFolderAutofillDataFragmentDoc}`;
export const InternalValidationReportDataFragmentDoc = gql`
    fragment InternalValidationReportData on ValidationReportDataObject {
  ...ExternalValidationReportData
}
    ${ExternalValidationReportDataFragmentDoc}`;
export const ExternalIngestionDocumentFragmentDoc = gql`
    fragment ExternalIngestionDocument on IngestionDocumentObject {
  id
  documentId
  documentName
  documentCreatedAt
  documentUpdatedAt
  fileUrl
  isBlank
  needsReview
  isArchived
  isClassified
  version
  complianceStatus
  complianceGroupId
  complianceStatusId
  folderName
  folderId
  contractDocuments {
    id
    order
    documentCategory
    externalDocumentName
    documentVersion {
      id
      document {
        id
        name
        form
        documentType
      }
    }
    file {
      url
    }
  }
  contractDocumentPages
}
    `;
export const InternalIngestionDocumentFragmentDoc = gql`
    fragment InternalIngestionDocument on IngestionDocumentObject {
  ...ExternalIngestionDocument
}
    ${ExternalIngestionDocumentFragmentDoc}`;
export const GetIngestionDocumentFragmentDoc = gql`
    fragment GetIngestionDocument on IngestionDocumentObject {
  id
  fields
  fileUrl
  documentName
  documentId
  documentUpdatedAt
  s3Bucket
  s3Key
  isArchived
  isBlank
  isClassified
  needsReview
  version
  complianceStatus
  complianceGroupId
  complianceStatusId
  contractDocuments {
    id
    documentCategory
    file {
      url
      fileName
    }
    documentVersion {
      id
      documentVersionFields {
        id
        boundingBox {
          top
          left
          bottom
          right
        }
        field {
          id
          label
          mappingKey
        }
      }
      document {
        id
        documentType
        documentCategory
        name
        form
      }
    }
  }
  docPageErrorMessage
}
    `;
export const InternalGetIngestionDocumentFragmentDoc = gql`
    fragment InternalGetIngestionDocument on IngestionDocumentObject {
  ...GetIngestionDocument
  documentML {
    id
    documentClassification
    updatedAt
  }
  contractDocuments {
    id
    documentCategory
    ingestionFieldValues
    aiIngestionFieldValues
    interpretedFieldValues
    mergedFieldValues
    file {
      url
      fileName
    }
    documentVersion {
      id
      status
      version
      searchRegex
      document {
        id
        documentType
        documentCategory
        name
        form
        usState
      }
      documentVersionFields {
        id
        boundingBox {
          top
          left
          bottom
          right
        }
        field {
          id
          label
          mappingKey
          aiInterpret
          defaultRules {
            id
            message
            ruleType
          }
        }
        rules {
          id
          message
          ruleType
        }
      }
    }
  }
  isValidDocumentMessageForExtraction
}
    ${GetIngestionDocumentFragmentDoc}`;
export const KeyTermFieldFragmentDoc = gql`
    fragment KeyTermField on KeyTermField {
  fieldLabel
  fieldType
  key
  isEditable
  fieldFormat {
    type
    options {
      precision
      formatString
      currencySymbol
    }
  }
  value
  values {
    value
    timestamp
    source
    sourceLabel
    validationError
    metadata {
      ... on KeyTermCalculatedMetadata {
        ingestionDocumentId
        contractDocumentId
      }
      ... on KeyTermUserOverrideMetadata {
        overriddenBy {
          id
          email
          firstName
          lastName
        }
      }
    }
  }
}
    `;
export const KeyTermChildSectionFragmentDoc = gql`
    fragment KeyTermChildSection on KeyTermSection {
  title
  description
  fields {
    ...KeyTermField
  }
}
    ${KeyTermFieldFragmentDoc}`;
export const KeyTermsSectionFragmentDoc = gql`
    fragment KeyTermsSection on KeyTermSection {
  title
  description
  fields {
    ...KeyTermField
  }
  children {
    ...KeyTermChildSection
  }
}
    ${KeyTermFieldFragmentDoc}
${KeyTermChildSectionFragmentDoc}`;
export const ClientParticipantFragmentDoc = gql`
    fragment ClientParticipant on ClientParticipant {
  email
  name
  phoneNumber
}
    `;
export const AgentParticipantFragmentDoc = gql`
    fragment AgentParticipant on AgentParticipant {
  email
  name
  phoneNumber
  officeName
  officeId
  mlsAgentId
}
    `;
export const ParticipantsFragmentDoc = gql`
    fragment Participants on Participants {
  buyers {
    ...ClientParticipant
  }
  sellers {
    ...ClientParticipant
  }
  buyersAgents {
    ...AgentParticipant
  }
  listingAgents {
    ...AgentParticipant
  }
  transactionCoordinators {
    ...ClientParticipant
  }
}
    ${ClientParticipantFragmentDoc}
${AgentParticipantFragmentDoc}`;
export const SyncSnapshotFragmentDoc = gql`
    fragment SyncSnapshot on SyncSnapshotObject {
  hasSynced
  documentCount
  documentVersionHash
  lastDocumentUpdatedAt
}
    `;
export const ExternalIngestionFolderFragmentDoc = gql`
    fragment ExternalIngestionFolder on IngestionFolderObject {
  id
  organizationUuid
  folderId
  folderName
  transactionSide
  status
  normalizedStatus
  stage
  activeMlsListingId
  metadata
  platform
  folderUpdatedAt
  keyTerms @include(if: $includeKeyTerms) {
    ...KeyTermsSection
  }
  participants {
    ...Participants
  }
  normalizedFieldValues
  validationErrorCount
  dotloopProfileId
  syncSnapshot {
    ...SyncSnapshot
  }
  transactionPipeline @include(if: $includeTransactionPipeline) {
    id
    clientType
    usState
    transactionPropertyType
  }
  mlsListing {
    ...ExternalIngestionFolderMLSListing
  }
}
    ${KeyTermsSectionFragmentDoc}
${ParticipantsFragmentDoc}
${SyncSnapshotFragmentDoc}
${ExternalIngestionFolderMlsListingFragmentDoc}`;
export const InternalIngestionFolderFragmentDoc = gql`
    fragment InternalIngestionFolder on IngestionFolderObject {
  ...ExternalIngestionFolder
  transactionPipeline @include(if: $includeTransactionPipeline) {
    id
    clientType
    usState
    transactionPropertyType
    stages {
      id
      stage
      sortOrder
      validationRules {
        id
        isRequiredDocument
        targetDocument {
          id
          form
        }
        rules {
          id
          ruleType
        }
        children {
          id
          isRequiredDocument
          targetDocument {
            id
            form
          }
          rules {
            id
            ruleType
          }
        }
      }
    }
  }
  aiValidationErrorCount
  regularValidationErrorCount
  fullyReprocessedAt
  txPipelineMatchedBy
  txPipelineUpdatedAt
  txPipelineCandidates {
    pipelineUuid
    pipelineName
    clientType
    usState
    transactionPropertyType
    matchedBy
    ruleMatchFormula
  }
  txPipelineNeedsInvestigationReason
}
    ${ExternalIngestionFolderFragmentDoc}`;
export const IngestionFolderValidationFeedbackFragmentDoc = gql`
    fragment IngestionFolderValidationFeedback on IngestionFolderValidationFeedbackObject {
  id
  feedbackType
  source
  comment
  createdByUserUuid
  updatedByUserUuid
  createdAt
  updatedAt
  ingestionFolderValidation {
    id
  }
}
    `;
export const IngestionDocumentValidationFeedbackFragmentDoc = gql`
    fragment IngestionDocumentValidationFeedback on IngestionDocumentValidationFeedbackObject {
  id
  feedbackType
  source
  comment
  createdByUserUuid
  updatedByUserUuid
  createdAt
  updatedAt
  ruleUuid
  contractDocumentUuid
  ingestionDocumentValidation {
    id
  }
}
    `;
export const FieldsToColumnListDocument = gql`
    query fieldsToColumnList($filters: FieldsToColumnListFilterArgs, $cursor: String, $orderBy: String = "-id", $perPage: Int = 20) {
  fieldsToColumnList(
    filters: $filters
    cursor: $cursor
    orderBy: $orderBy
    perPage: $perPage
  ) {
    pageInfo {
      ...PageInfo
    }
    results {
      ...FieldsToColumn
    }
  }
}
    ${PageInfoFragmentDoc}
${FieldsToColumnFragmentDoc}`;

/**
 * __useFieldsToColumnListQuery__
 *
 * To run a query within a React component, call `useFieldsToColumnListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldsToColumnListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFieldsToColumnListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      cursor: // value for 'cursor'
 *      orderBy: // value for 'orderBy'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useFieldsToColumnListQuery(baseOptions?: Apollo.QueryHookOptions<Types.FieldsToColumnListQuery, Types.FieldsToColumnListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FieldsToColumnListQuery, Types.FieldsToColumnListQueryVariables>(FieldsToColumnListDocument, options);
      }
export function useFieldsToColumnListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FieldsToColumnListQuery, Types.FieldsToColumnListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FieldsToColumnListQuery, Types.FieldsToColumnListQueryVariables>(FieldsToColumnListDocument, options);
        }
export type FieldsToColumnListQueryHookResult = ReturnType<typeof useFieldsToColumnListQuery>;
export type FieldsToColumnListLazyQueryHookResult = ReturnType<typeof useFieldsToColumnListLazyQuery>;
export type FieldsToColumnListQueryResult = Apollo.QueryResult<Types.FieldsToColumnListQuery, Types.FieldsToColumnListQueryVariables>;
export const AddOrUpdateDisclosureContractDocumentsDocument = gql`
    mutation AddOrUpdateDisclosureContractDocuments($input: AddOrUpdateDisclosureContractDocumentsInput!) {
  addOrUpdateDisclosureContractDocuments(input: $input) {
    contract {
      id
      contractDocuments {
        ...ContractDocumentForContract
      }
    }
  }
}
    ${ContractDocumentForContractFragmentDoc}`;
export type AddOrUpdateDisclosureContractDocumentsMutationFn = Apollo.MutationFunction<Types.AddOrUpdateDisclosureContractDocumentsMutation, Types.AddOrUpdateDisclosureContractDocumentsMutationVariables>;

/**
 * __useAddOrUpdateDisclosureContractDocumentsMutation__
 *
 * To run a mutation, you first call `useAddOrUpdateDisclosureContractDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrUpdateDisclosureContractDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrUpdateDisclosureContractDocumentsMutation, { data, loading, error }] = useAddOrUpdateDisclosureContractDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrUpdateDisclosureContractDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddOrUpdateDisclosureContractDocumentsMutation, Types.AddOrUpdateDisclosureContractDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddOrUpdateDisclosureContractDocumentsMutation, Types.AddOrUpdateDisclosureContractDocumentsMutationVariables>(AddOrUpdateDisclosureContractDocumentsDocument, options);
      }
export type AddOrUpdateDisclosureContractDocumentsMutationHookResult = ReturnType<typeof useAddOrUpdateDisclosureContractDocumentsMutation>;
export type AddOrUpdateDisclosureContractDocumentsMutationResult = Apollo.MutationResult<Types.AddOrUpdateDisclosureContractDocumentsMutation>;
export type AddOrUpdateDisclosureContractDocumentsMutationOptions = Apollo.BaseMutationOptions<Types.AddOrUpdateDisclosureContractDocumentsMutation, Types.AddOrUpdateDisclosureContractDocumentsMutationVariables>;
export const AddOrUpdatePreapprovalContractDocumentDocument = gql`
    mutation AddOrUpdatePreapprovalContractDocument($input: AddOrUpdatePreapprovalContractDocumentInput!) {
  addOrUpdatePreapprovalContractDocument(input: $input) {
    contract {
      id
    }
  }
}
    `;
export type AddOrUpdatePreapprovalContractDocumentMutationFn = Apollo.MutationFunction<Types.AddOrUpdatePreapprovalContractDocumentMutation, Types.AddOrUpdatePreapprovalContractDocumentMutationVariables>;

/**
 * __useAddOrUpdatePreapprovalContractDocumentMutation__
 *
 * To run a mutation, you first call `useAddOrUpdatePreapprovalContractDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOrUpdatePreapprovalContractDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOrUpdatePreapprovalContractDocumentMutation, { data, loading, error }] = useAddOrUpdatePreapprovalContractDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddOrUpdatePreapprovalContractDocumentMutation(baseOptions?: Apollo.MutationHookOptions<Types.AddOrUpdatePreapprovalContractDocumentMutation, Types.AddOrUpdatePreapprovalContractDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.AddOrUpdatePreapprovalContractDocumentMutation, Types.AddOrUpdatePreapprovalContractDocumentMutationVariables>(AddOrUpdatePreapprovalContractDocumentDocument, options);
      }
export type AddOrUpdatePreapprovalContractDocumentMutationHookResult = ReturnType<typeof useAddOrUpdatePreapprovalContractDocumentMutation>;
export type AddOrUpdatePreapprovalContractDocumentMutationResult = Apollo.MutationResult<Types.AddOrUpdatePreapprovalContractDocumentMutation>;
export type AddOrUpdatePreapprovalContractDocumentMutationOptions = Apollo.BaseMutationOptions<Types.AddOrUpdatePreapprovalContractDocumentMutation, Types.AddOrUpdatePreapprovalContractDocumentMutationVariables>;
export const CopyComplianceKeyTermSectionsDocument = gql`
    mutation copyComplianceKeyTermSections($input: CopyComplianceKeyTermSectionsInput!) {
  copyComplianceKeyTermSections(input: $input)
}
    `;
export type CopyComplianceKeyTermSectionsMutationFn = Apollo.MutationFunction<Types.CopyComplianceKeyTermSectionsMutation, Types.CopyComplianceKeyTermSectionsMutationVariables>;

/**
 * __useCopyComplianceKeyTermSectionsMutation__
 *
 * To run a mutation, you first call `useCopyComplianceKeyTermSectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyComplianceKeyTermSectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyComplianceKeyTermSectionsMutation, { data, loading, error }] = useCopyComplianceKeyTermSectionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyComplianceKeyTermSectionsMutation(baseOptions?: Apollo.MutationHookOptions<Types.CopyComplianceKeyTermSectionsMutation, Types.CopyComplianceKeyTermSectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CopyComplianceKeyTermSectionsMutation, Types.CopyComplianceKeyTermSectionsMutationVariables>(CopyComplianceKeyTermSectionsDocument, options);
      }
export type CopyComplianceKeyTermSectionsMutationHookResult = ReturnType<typeof useCopyComplianceKeyTermSectionsMutation>;
export type CopyComplianceKeyTermSectionsMutationResult = Apollo.MutationResult<Types.CopyComplianceKeyTermSectionsMutation>;
export type CopyComplianceKeyTermSectionsMutationOptions = Apollo.BaseMutationOptions<Types.CopyComplianceKeyTermSectionsMutation, Types.CopyComplianceKeyTermSectionsMutationVariables>;
export const CopyFieldsFromPreviousVersionDocument = gql`
    mutation copyFieldsFromPreviousVersion($input: CopyFieldsFromPreviousVersionInput!) {
  copyFieldsFromPreviousVersion(input: $input) {
    documentVersion {
      ...DocumentVersion
      documentVersionFieldsCount
      documentVersionFields {
        ...DocumentVersionField
      }
    }
  }
}
    ${DocumentVersionFragmentDoc}
${DocumentVersionFieldFragmentDoc}`;
export type CopyFieldsFromPreviousVersionMutationFn = Apollo.MutationFunction<Types.CopyFieldsFromPreviousVersionMutation, Types.CopyFieldsFromPreviousVersionMutationVariables>;

/**
 * __useCopyFieldsFromPreviousVersionMutation__
 *
 * To run a mutation, you first call `useCopyFieldsFromPreviousVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyFieldsFromPreviousVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyFieldsFromPreviousVersionMutation, { data, loading, error }] = useCopyFieldsFromPreviousVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyFieldsFromPreviousVersionMutation(baseOptions?: Apollo.MutationHookOptions<Types.CopyFieldsFromPreviousVersionMutation, Types.CopyFieldsFromPreviousVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CopyFieldsFromPreviousVersionMutation, Types.CopyFieldsFromPreviousVersionMutationVariables>(CopyFieldsFromPreviousVersionDocument, options);
      }
export type CopyFieldsFromPreviousVersionMutationHookResult = ReturnType<typeof useCopyFieldsFromPreviousVersionMutation>;
export type CopyFieldsFromPreviousVersionMutationResult = Apollo.MutationResult<Types.CopyFieldsFromPreviousVersionMutation>;
export type CopyFieldsFromPreviousVersionMutationOptions = Apollo.BaseMutationOptions<Types.CopyFieldsFromPreviousVersionMutation, Types.CopyFieldsFromPreviousVersionMutationVariables>;
export const CopyTransactionRulesDocument = gql`
    mutation copyTransactionRules($input: CopyTransactionRulesInput!) {
  copyTransactionRules(input: $input)
}
    `;
export type CopyTransactionRulesMutationFn = Apollo.MutationFunction<Types.CopyTransactionRulesMutation, Types.CopyTransactionRulesMutationVariables>;

/**
 * __useCopyTransactionRulesMutation__
 *
 * To run a mutation, you first call `useCopyTransactionRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyTransactionRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyTransactionRulesMutation, { data, loading, error }] = useCopyTransactionRulesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCopyTransactionRulesMutation(baseOptions?: Apollo.MutationHookOptions<Types.CopyTransactionRulesMutation, Types.CopyTransactionRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CopyTransactionRulesMutation, Types.CopyTransactionRulesMutationVariables>(CopyTransactionRulesDocument, options);
      }
export type CopyTransactionRulesMutationHookResult = ReturnType<typeof useCopyTransactionRulesMutation>;
export type CopyTransactionRulesMutationResult = Apollo.MutationResult<Types.CopyTransactionRulesMutation>;
export type CopyTransactionRulesMutationOptions = Apollo.BaseMutationOptions<Types.CopyTransactionRulesMutation, Types.CopyTransactionRulesMutationVariables>;
export const CreateAutofillDocument = gql`
    mutation createAutofill($input: CreateAutofillInput!) {
  createAutofill(input: $input) {
    autofill {
      id
      field {
        id
        autofill {
          ...Autofill
        }
      }
      rule {
        id
        autofill {
          ...Autofill
        }
      }
      optionsField {
        id
        autofill {
          ...Autofill
        }
      }
      helpTextField {
        id
        autofill {
          ...Autofill
        }
      }
      documentVersionField {
        id
        autofill {
          ...Autofill
        }
      }
      optionsDocumentVersionField {
        id
        autofill {
          ...Autofill
        }
      }
      helpTextDocumentVersionField {
        id
        autofill {
          ...Autofill
        }
      }
    }
  }
}
    ${AutofillFragmentDoc}`;
export type CreateAutofillMutationFn = Apollo.MutationFunction<Types.CreateAutofillMutation, Types.CreateAutofillMutationVariables>;

/**
 * __useCreateAutofillMutation__
 *
 * To run a mutation, you first call `useCreateAutofillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAutofillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAutofillMutation, { data, loading, error }] = useCreateAutofillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAutofillMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateAutofillMutation, Types.CreateAutofillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateAutofillMutation, Types.CreateAutofillMutationVariables>(CreateAutofillDocument, options);
      }
export type CreateAutofillMutationHookResult = ReturnType<typeof useCreateAutofillMutation>;
export type CreateAutofillMutationResult = Apollo.MutationResult<Types.CreateAutofillMutation>;
export type CreateAutofillMutationOptions = Apollo.BaseMutationOptions<Types.CreateAutofillMutation, Types.CreateAutofillMutationVariables>;
export const CreateClassificationEvalFromIngestionDocumentDocument = gql`
    mutation createClassificationEvalFromIngestionDocument($input: CreateClassificationEvalFromIngestionDocumentInput!) {
  createClassificationEvalFromIngestionDocument(input: $input) {
    id
    file {
      fileName
      url
    }
    expectedCategory
    expectedDocumentType
    expectedUsState
    expectedValues
    classification {
      formName
      documentCategory
      documentType
      usState
      score
      pageNumber
      classificationMethod
    }
  }
}
    `;
export type CreateClassificationEvalFromIngestionDocumentMutationFn = Apollo.MutationFunction<Types.CreateClassificationEvalFromIngestionDocumentMutation, Types.CreateClassificationEvalFromIngestionDocumentMutationVariables>;

/**
 * __useCreateClassificationEvalFromIngestionDocumentMutation__
 *
 * To run a mutation, you first call `useCreateClassificationEvalFromIngestionDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClassificationEvalFromIngestionDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClassificationEvalFromIngestionDocumentMutation, { data, loading, error }] = useCreateClassificationEvalFromIngestionDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClassificationEvalFromIngestionDocumentMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateClassificationEvalFromIngestionDocumentMutation, Types.CreateClassificationEvalFromIngestionDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateClassificationEvalFromIngestionDocumentMutation, Types.CreateClassificationEvalFromIngestionDocumentMutationVariables>(CreateClassificationEvalFromIngestionDocumentDocument, options);
      }
export type CreateClassificationEvalFromIngestionDocumentMutationHookResult = ReturnType<typeof useCreateClassificationEvalFromIngestionDocumentMutation>;
export type CreateClassificationEvalFromIngestionDocumentMutationResult = Apollo.MutationResult<Types.CreateClassificationEvalFromIngestionDocumentMutation>;
export type CreateClassificationEvalFromIngestionDocumentMutationOptions = Apollo.BaseMutationOptions<Types.CreateClassificationEvalFromIngestionDocumentMutation, Types.CreateClassificationEvalFromIngestionDocumentMutationVariables>;
export const CreateComplianceKeyTermSectionDocument = gql`
    mutation createComplianceKeyTermSection($input: CreateComplianceKeyTermSectionInput!) {
  createComplianceKeyTermSection(input: $input) {
    complianceKeyTermSection {
      ...ComplianceKeyTermSectionList
    }
  }
}
    ${ComplianceKeyTermSectionListFragmentDoc}`;
export type CreateComplianceKeyTermSectionMutationFn = Apollo.MutationFunction<Types.CreateComplianceKeyTermSectionMutation, Types.CreateComplianceKeyTermSectionMutationVariables>;

/**
 * __useCreateComplianceKeyTermSectionMutation__
 *
 * To run a mutation, you first call `useCreateComplianceKeyTermSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateComplianceKeyTermSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createComplianceKeyTermSectionMutation, { data, loading, error }] = useCreateComplianceKeyTermSectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateComplianceKeyTermSectionMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateComplianceKeyTermSectionMutation, Types.CreateComplianceKeyTermSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateComplianceKeyTermSectionMutation, Types.CreateComplianceKeyTermSectionMutationVariables>(CreateComplianceKeyTermSectionDocument, options);
      }
export type CreateComplianceKeyTermSectionMutationHookResult = ReturnType<typeof useCreateComplianceKeyTermSectionMutation>;
export type CreateComplianceKeyTermSectionMutationResult = Apollo.MutationResult<Types.CreateComplianceKeyTermSectionMutation>;
export type CreateComplianceKeyTermSectionMutationOptions = Apollo.BaseMutationOptions<Types.CreateComplianceKeyTermSectionMutation, Types.CreateComplianceKeyTermSectionMutationVariables>;
export const CreateContractDocument = gql`
    mutation createContract($input: CreateContractInput) {
  createContract(input: $input) {
    contract {
      id
    }
  }
}
    `;
export type CreateContractMutationFn = Apollo.MutationFunction<Types.CreateContractMutation, Types.CreateContractMutationVariables>;

/**
 * __useCreateContractMutation__
 *
 * To run a mutation, you first call `useCreateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractMutation, { data, loading, error }] = useCreateContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContractMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateContractMutation, Types.CreateContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateContractMutation, Types.CreateContractMutationVariables>(CreateContractDocument, options);
      }
export type CreateContractMutationHookResult = ReturnType<typeof useCreateContractMutation>;
export type CreateContractMutationResult = Apollo.MutationResult<Types.CreateContractMutation>;
export type CreateContractMutationOptions = Apollo.BaseMutationOptions<Types.CreateContractMutation, Types.CreateContractMutationVariables>;
export const CreateDefaultSecondaryDocumentDocument = gql`
    mutation createDefaultSecondaryDocument($input: CreateDefaultSecondaryDocumentInput!) {
  createDefaultSecondaryDocument(input: $input) {
    defaultSecondaryDocument {
      id
      document {
        id
        defaultSecondaryDocuments {
          ...DefaultSecondaryDocument
        }
      }
    }
  }
}
    ${DefaultSecondaryDocumentFragmentDoc}`;
export type CreateDefaultSecondaryDocumentMutationFn = Apollo.MutationFunction<Types.CreateDefaultSecondaryDocumentMutation, Types.CreateDefaultSecondaryDocumentMutationVariables>;

/**
 * __useCreateDefaultSecondaryDocumentMutation__
 *
 * To run a mutation, you first call `useCreateDefaultSecondaryDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDefaultSecondaryDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDefaultSecondaryDocumentMutation, { data, loading, error }] = useCreateDefaultSecondaryDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDefaultSecondaryDocumentMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateDefaultSecondaryDocumentMutation, Types.CreateDefaultSecondaryDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateDefaultSecondaryDocumentMutation, Types.CreateDefaultSecondaryDocumentMutationVariables>(CreateDefaultSecondaryDocumentDocument, options);
      }
export type CreateDefaultSecondaryDocumentMutationHookResult = ReturnType<typeof useCreateDefaultSecondaryDocumentMutation>;
export type CreateDefaultSecondaryDocumentMutationResult = Apollo.MutationResult<Types.CreateDefaultSecondaryDocumentMutation>;
export type CreateDefaultSecondaryDocumentMutationOptions = Apollo.BaseMutationOptions<Types.CreateDefaultSecondaryDocumentMutation, Types.CreateDefaultSecondaryDocumentMutationVariables>;
export const CreateDocumentDocument = gql`
    mutation createDocument($input: CreateDocumentInput!) {
  createDocument(input: $input) {
    document {
      ...Document
    }
  }
}
    ${DocumentFragmentDoc}`;
export type CreateDocumentMutationFn = Apollo.MutationFunction<Types.CreateDocumentMutation, Types.CreateDocumentMutationVariables>;

/**
 * __useCreateDocumentMutation__
 *
 * To run a mutation, you first call `useCreateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentMutation, { data, loading, error }] = useCreateDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateDocumentMutation, Types.CreateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateDocumentMutation, Types.CreateDocumentMutationVariables>(CreateDocumentDocument, options);
      }
export type CreateDocumentMutationHookResult = ReturnType<typeof useCreateDocumentMutation>;
export type CreateDocumentMutationResult = Apollo.MutationResult<Types.CreateDocumentMutation>;
export type CreateDocumentMutationOptions = Apollo.BaseMutationOptions<Types.CreateDocumentMutation, Types.CreateDocumentMutationVariables>;
export const CreateDocumentLlmDocument = gql`
    mutation CreateDocumentLLM($input: DocumentLLMInput!, $isDetail: Boolean! = true) {
  createDocumentLLM(input: $input) {
    ...DocumentLLM
  }
}
    ${DocumentLlmFragmentDoc}`;
export type CreateDocumentLlmMutationFn = Apollo.MutationFunction<Types.CreateDocumentLlmMutation, Types.CreateDocumentLlmMutationVariables>;

/**
 * __useCreateDocumentLlmMutation__
 *
 * To run a mutation, you first call `useCreateDocumentLlmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentLlmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentLlmMutation, { data, loading, error }] = useCreateDocumentLlmMutation({
 *   variables: {
 *      input: // value for 'input'
 *      isDetail: // value for 'isDetail'
 *   },
 * });
 */
export function useCreateDocumentLlmMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateDocumentLlmMutation, Types.CreateDocumentLlmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateDocumentLlmMutation, Types.CreateDocumentLlmMutationVariables>(CreateDocumentLlmDocument, options);
      }
export type CreateDocumentLlmMutationHookResult = ReturnType<typeof useCreateDocumentLlmMutation>;
export type CreateDocumentLlmMutationResult = Apollo.MutationResult<Types.CreateDocumentLlmMutation>;
export type CreateDocumentLlmMutationOptions = Apollo.BaseMutationOptions<Types.CreateDocumentLlmMutation, Types.CreateDocumentLlmMutationVariables>;
export const CreateDocumentLlmExampleDocument = gql`
    mutation CreateDocumentLLMExample($input: DocumentLLMExampleInput!) {
  createDocumentLLMExample(input: $input) {
    id
    file {
      fileName
      url
    }
    documentLLM {
      id
    }
  }
}
    `;
export type CreateDocumentLlmExampleMutationFn = Apollo.MutationFunction<Types.CreateDocumentLlmExampleMutation, Types.CreateDocumentLlmExampleMutationVariables>;

/**
 * __useCreateDocumentLlmExampleMutation__
 *
 * To run a mutation, you first call `useCreateDocumentLlmExampleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentLlmExampleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentLlmExampleMutation, { data, loading, error }] = useCreateDocumentLlmExampleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentLlmExampleMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateDocumentLlmExampleMutation, Types.CreateDocumentLlmExampleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateDocumentLlmExampleMutation, Types.CreateDocumentLlmExampleMutationVariables>(CreateDocumentLlmExampleDocument, options);
      }
export type CreateDocumentLlmExampleMutationHookResult = ReturnType<typeof useCreateDocumentLlmExampleMutation>;
export type CreateDocumentLlmExampleMutationResult = Apollo.MutationResult<Types.CreateDocumentLlmExampleMutation>;
export type CreateDocumentLlmExampleMutationOptions = Apollo.BaseMutationOptions<Types.CreateDocumentLlmExampleMutation, Types.CreateDocumentLlmExampleMutationVariables>;
export const CreateDocumentLlmExamplesDocument = gql`
    mutation CreateDocumentLLMExamples($input: DocumentLLMExamplesInput!) {
  createDocumentLLMExamples(input: $input) {
    id
    file {
      fileName
      url
    }
    documentLLM {
      id
    }
  }
}
    `;
export type CreateDocumentLlmExamplesMutationFn = Apollo.MutationFunction<Types.CreateDocumentLlmExamplesMutation, Types.CreateDocumentLlmExamplesMutationVariables>;

/**
 * __useCreateDocumentLlmExamplesMutation__
 *
 * To run a mutation, you first call `useCreateDocumentLlmExamplesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentLlmExamplesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentLlmExamplesMutation, { data, loading, error }] = useCreateDocumentLlmExamplesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentLlmExamplesMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateDocumentLlmExamplesMutation, Types.CreateDocumentLlmExamplesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateDocumentLlmExamplesMutation, Types.CreateDocumentLlmExamplesMutationVariables>(CreateDocumentLlmExamplesDocument, options);
      }
export type CreateDocumentLlmExamplesMutationHookResult = ReturnType<typeof useCreateDocumentLlmExamplesMutation>;
export type CreateDocumentLlmExamplesMutationResult = Apollo.MutationResult<Types.CreateDocumentLlmExamplesMutation>;
export type CreateDocumentLlmExamplesMutationOptions = Apollo.BaseMutationOptions<Types.CreateDocumentLlmExamplesMutation, Types.CreateDocumentLlmExamplesMutationVariables>;
export const CreateDocumentSectionDocument = gql`
    mutation createDocumentSection($input: CreateDocumentSectionInput!) {
  createDocumentSection(input: $input) {
    documentSection {
      ...DocumentSectionList
    }
  }
}
    ${DocumentSectionListFragmentDoc}`;
export type CreateDocumentSectionMutationFn = Apollo.MutationFunction<Types.CreateDocumentSectionMutation, Types.CreateDocumentSectionMutationVariables>;

/**
 * __useCreateDocumentSectionMutation__
 *
 * To run a mutation, you first call `useCreateDocumentSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentSectionMutation, { data, loading, error }] = useCreateDocumentSectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentSectionMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateDocumentSectionMutation, Types.CreateDocumentSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateDocumentSectionMutation, Types.CreateDocumentSectionMutationVariables>(CreateDocumentSectionDocument, options);
      }
export type CreateDocumentSectionMutationHookResult = ReturnType<typeof useCreateDocumentSectionMutation>;
export type CreateDocumentSectionMutationResult = Apollo.MutationResult<Types.CreateDocumentSectionMutation>;
export type CreateDocumentSectionMutationOptions = Apollo.BaseMutationOptions<Types.CreateDocumentSectionMutation, Types.CreateDocumentSectionMutationVariables>;
export const CreateDocumentVersionDocument = gql`
    mutation createDocumentVersion($input: CreateDocumentVersionInput!) {
  createDocumentVersion(input: $input) {
    documentVersion {
      ...DocumentVersion
      document {
        id
        documentVersions {
          id
        }
      }
    }
  }
}
    ${DocumentVersionFragmentDoc}`;
export type CreateDocumentVersionMutationFn = Apollo.MutationFunction<Types.CreateDocumentVersionMutation, Types.CreateDocumentVersionMutationVariables>;

/**
 * __useCreateDocumentVersionMutation__
 *
 * To run a mutation, you first call `useCreateDocumentVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentVersionMutation, { data, loading, error }] = useCreateDocumentVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentVersionMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateDocumentVersionMutation, Types.CreateDocumentVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateDocumentVersionMutation, Types.CreateDocumentVersionMutationVariables>(CreateDocumentVersionDocument, options);
      }
export type CreateDocumentVersionMutationHookResult = ReturnType<typeof useCreateDocumentVersionMutation>;
export type CreateDocumentVersionMutationResult = Apollo.MutationResult<Types.CreateDocumentVersionMutation>;
export type CreateDocumentVersionMutationOptions = Apollo.BaseMutationOptions<Types.CreateDocumentVersionMutation, Types.CreateDocumentVersionMutationVariables>;
export const CreateDocumentVersionFieldsDocument = gql`
    mutation createDocumentVersionFields($inputs: [CreateDocumentVersionFieldInput!]!) {
  createDocumentVersionFields(inputs: $inputs) {
    documentVersionFields {
      ...DocumentVersionField
    }
  }
}
    ${DocumentVersionFieldFragmentDoc}`;
export type CreateDocumentVersionFieldsMutationFn = Apollo.MutationFunction<Types.CreateDocumentVersionFieldsMutation, Types.CreateDocumentVersionFieldsMutationVariables>;

/**
 * __useCreateDocumentVersionFieldsMutation__
 *
 * To run a mutation, you first call `useCreateDocumentVersionFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentVersionFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentVersionFieldsMutation, { data, loading, error }] = useCreateDocumentVersionFieldsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useCreateDocumentVersionFieldsMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateDocumentVersionFieldsMutation, Types.CreateDocumentVersionFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateDocumentVersionFieldsMutation, Types.CreateDocumentVersionFieldsMutationVariables>(CreateDocumentVersionFieldsDocument, options);
      }
export type CreateDocumentVersionFieldsMutationHookResult = ReturnType<typeof useCreateDocumentVersionFieldsMutation>;
export type CreateDocumentVersionFieldsMutationResult = Apollo.MutationResult<Types.CreateDocumentVersionFieldsMutation>;
export type CreateDocumentVersionFieldsMutationOptions = Apollo.BaseMutationOptions<Types.CreateDocumentVersionFieldsMutation, Types.CreateDocumentVersionFieldsMutationVariables>;
export const CreateEmbeddedSignUrlDocument = gql`
    mutation createEmbeddedSignUrl($code: String!) {
  createEmbeddedSignUrl(code: $code)
}
    `;
export type CreateEmbeddedSignUrlMutationFn = Apollo.MutationFunction<Types.CreateEmbeddedSignUrlMutation, Types.CreateEmbeddedSignUrlMutationVariables>;

/**
 * __useCreateEmbeddedSignUrlMutation__
 *
 * To run a mutation, you first call `useCreateEmbeddedSignUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmbeddedSignUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmbeddedSignUrlMutation, { data, loading, error }] = useCreateEmbeddedSignUrlMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useCreateEmbeddedSignUrlMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateEmbeddedSignUrlMutation, Types.CreateEmbeddedSignUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateEmbeddedSignUrlMutation, Types.CreateEmbeddedSignUrlMutationVariables>(CreateEmbeddedSignUrlDocument, options);
      }
export type CreateEmbeddedSignUrlMutationHookResult = ReturnType<typeof useCreateEmbeddedSignUrlMutation>;
export type CreateEmbeddedSignUrlMutationResult = Apollo.MutationResult<Types.CreateEmbeddedSignUrlMutation>;
export type CreateEmbeddedSignUrlMutationOptions = Apollo.BaseMutationOptions<Types.CreateEmbeddedSignUrlMutation, Types.CreateEmbeddedSignUrlMutationVariables>;
export const CreateFallbackContractDocument = gql`
    mutation createFallbackContract($input: CreateFallbackContractInput!) {
  createFallbackContract(input: $input) {
    contract {
      id
    }
  }
}
    `;
export type CreateFallbackContractMutationFn = Apollo.MutationFunction<Types.CreateFallbackContractMutation, Types.CreateFallbackContractMutationVariables>;

/**
 * __useCreateFallbackContractMutation__
 *
 * To run a mutation, you first call `useCreateFallbackContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFallbackContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFallbackContractMutation, { data, loading, error }] = useCreateFallbackContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFallbackContractMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateFallbackContractMutation, Types.CreateFallbackContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateFallbackContractMutation, Types.CreateFallbackContractMutationVariables>(CreateFallbackContractDocument, options);
      }
export type CreateFallbackContractMutationHookResult = ReturnType<typeof useCreateFallbackContractMutation>;
export type CreateFallbackContractMutationResult = Apollo.MutationResult<Types.CreateFallbackContractMutation>;
export type CreateFallbackContractMutationOptions = Apollo.BaseMutationOptions<Types.CreateFallbackContractMutation, Types.CreateFallbackContractMutationVariables>;
export const CreateFieldDocument = gql`
    mutation createField($input: CreateFieldInput!) {
  createField(input: $input) {
    field {
      ...Field
      ...FieldDetail
    }
  }
}
    ${FieldFragmentDoc}
${FieldDetailFragmentDoc}`;
export type CreateFieldMutationFn = Apollo.MutationFunction<Types.CreateFieldMutation, Types.CreateFieldMutationVariables>;

/**
 * __useCreateFieldMutation__
 *
 * To run a mutation, you first call `useCreateFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFieldMutation, { data, loading, error }] = useCreateFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFieldMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateFieldMutation, Types.CreateFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateFieldMutation, Types.CreateFieldMutationVariables>(CreateFieldDocument, options);
      }
export type CreateFieldMutationHookResult = ReturnType<typeof useCreateFieldMutation>;
export type CreateFieldMutationResult = Apollo.MutationResult<Types.CreateFieldMutation>;
export type CreateFieldMutationOptions = Apollo.BaseMutationOptions<Types.CreateFieldMutation, Types.CreateFieldMutationVariables>;
export const CreateOrUpdateDocumentClassificationEvaluationDocument = gql`
    mutation CreateOrUpdateDocumentClassificationEvaluation($input: CreateOrUpdateDocumentClassificationEvaluationInput!) {
  createOrUpdateDocumentClassificationEvaluation(input: $input) {
    ...DocumentClassificationEvaluation
  }
}
    ${DocumentClassificationEvaluationFragmentDoc}`;
export type CreateOrUpdateDocumentClassificationEvaluationMutationFn = Apollo.MutationFunction<Types.CreateOrUpdateDocumentClassificationEvaluationMutation, Types.CreateOrUpdateDocumentClassificationEvaluationMutationVariables>;

/**
 * __useCreateOrUpdateDocumentClassificationEvaluationMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateDocumentClassificationEvaluationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateDocumentClassificationEvaluationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateDocumentClassificationEvaluationMutation, { data, loading, error }] = useCreateOrUpdateDocumentClassificationEvaluationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateDocumentClassificationEvaluationMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrUpdateDocumentClassificationEvaluationMutation, Types.CreateOrUpdateDocumentClassificationEvaluationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrUpdateDocumentClassificationEvaluationMutation, Types.CreateOrUpdateDocumentClassificationEvaluationMutationVariables>(CreateOrUpdateDocumentClassificationEvaluationDocument, options);
      }
export type CreateOrUpdateDocumentClassificationEvaluationMutationHookResult = ReturnType<typeof useCreateOrUpdateDocumentClassificationEvaluationMutation>;
export type CreateOrUpdateDocumentClassificationEvaluationMutationResult = Apollo.MutationResult<Types.CreateOrUpdateDocumentClassificationEvaluationMutation>;
export type CreateOrUpdateDocumentClassificationEvaluationMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrUpdateDocumentClassificationEvaluationMutation, Types.CreateOrUpdateDocumentClassificationEvaluationMutationVariables>;
export const DeleteDocumentClassificationEvaluationDocument = gql`
    mutation DeleteDocumentClassificationEvaluation($id: ID!) {
  deleteDocumentClassificationEvaluation(id: $id)
}
    `;
export type DeleteDocumentClassificationEvaluationMutationFn = Apollo.MutationFunction<Types.DeleteDocumentClassificationEvaluationMutation, Types.DeleteDocumentClassificationEvaluationMutationVariables>;

/**
 * __useDeleteDocumentClassificationEvaluationMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentClassificationEvaluationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentClassificationEvaluationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentClassificationEvaluationMutation, { data, loading, error }] = useDeleteDocumentClassificationEvaluationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDocumentClassificationEvaluationMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteDocumentClassificationEvaluationMutation, Types.DeleteDocumentClassificationEvaluationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteDocumentClassificationEvaluationMutation, Types.DeleteDocumentClassificationEvaluationMutationVariables>(DeleteDocumentClassificationEvaluationDocument, options);
      }
export type DeleteDocumentClassificationEvaluationMutationHookResult = ReturnType<typeof useDeleteDocumentClassificationEvaluationMutation>;
export type DeleteDocumentClassificationEvaluationMutationResult = Apollo.MutationResult<Types.DeleteDocumentClassificationEvaluationMutation>;
export type DeleteDocumentClassificationEvaluationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteDocumentClassificationEvaluationMutation, Types.DeleteDocumentClassificationEvaluationMutationVariables>;
export const EvaluateDocumentClassificationDocument = gql`
    mutation EvaluateDocumentClassification($evaluationId: ID!) {
  evaluateDocumentClassification(evaluationId: $evaluationId)
}
    `;
export type EvaluateDocumentClassificationMutationFn = Apollo.MutationFunction<Types.EvaluateDocumentClassificationMutation, Types.EvaluateDocumentClassificationMutationVariables>;

/**
 * __useEvaluateDocumentClassificationMutation__
 *
 * To run a mutation, you first call `useEvaluateDocumentClassificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEvaluateDocumentClassificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [evaluateDocumentClassificationMutation, { data, loading, error }] = useEvaluateDocumentClassificationMutation({
 *   variables: {
 *      evaluationId: // value for 'evaluationId'
 *   },
 * });
 */
export function useEvaluateDocumentClassificationMutation(baseOptions?: Apollo.MutationHookOptions<Types.EvaluateDocumentClassificationMutation, Types.EvaluateDocumentClassificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.EvaluateDocumentClassificationMutation, Types.EvaluateDocumentClassificationMutationVariables>(EvaluateDocumentClassificationDocument, options);
      }
export type EvaluateDocumentClassificationMutationHookResult = ReturnType<typeof useEvaluateDocumentClassificationMutation>;
export type EvaluateDocumentClassificationMutationResult = Apollo.MutationResult<Types.EvaluateDocumentClassificationMutation>;
export type EvaluateDocumentClassificationMutationOptions = Apollo.BaseMutationOptions<Types.EvaluateDocumentClassificationMutation, Types.EvaluateDocumentClassificationMutationVariables>;
export const PreviewExtractedFieldsFromEvaluationDocument = gql`
    mutation PreviewExtractedFieldsFromEvaluation($evaluationId: ID!) {
  previewExtractedFieldsFromEvaluation(evaluationId: $evaluationId)
}
    `;
export type PreviewExtractedFieldsFromEvaluationMutationFn = Apollo.MutationFunction<Types.PreviewExtractedFieldsFromEvaluationMutation, Types.PreviewExtractedFieldsFromEvaluationMutationVariables>;

/**
 * __usePreviewExtractedFieldsFromEvaluationMutation__
 *
 * To run a mutation, you first call `usePreviewExtractedFieldsFromEvaluationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewExtractedFieldsFromEvaluationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewExtractedFieldsFromEvaluationMutation, { data, loading, error }] = usePreviewExtractedFieldsFromEvaluationMutation({
 *   variables: {
 *      evaluationId: // value for 'evaluationId'
 *   },
 * });
 */
export function usePreviewExtractedFieldsFromEvaluationMutation(baseOptions?: Apollo.MutationHookOptions<Types.PreviewExtractedFieldsFromEvaluationMutation, Types.PreviewExtractedFieldsFromEvaluationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.PreviewExtractedFieldsFromEvaluationMutation, Types.PreviewExtractedFieldsFromEvaluationMutationVariables>(PreviewExtractedFieldsFromEvaluationDocument, options);
      }
export type PreviewExtractedFieldsFromEvaluationMutationHookResult = ReturnType<typeof usePreviewExtractedFieldsFromEvaluationMutation>;
export type PreviewExtractedFieldsFromEvaluationMutationResult = Apollo.MutationResult<Types.PreviewExtractedFieldsFromEvaluationMutation>;
export type PreviewExtractedFieldsFromEvaluationMutationOptions = Apollo.BaseMutationOptions<Types.PreviewExtractedFieldsFromEvaluationMutation, Types.PreviewExtractedFieldsFromEvaluationMutationVariables>;
export const SaveExtractedFieldsFromEvaluationDocument = gql`
    mutation SaveExtractedFieldsFromEvaluation($evaluationId: ID!) {
  saveExtractedFieldsFromEvaluation(evaluationId: $evaluationId)
}
    `;
export type SaveExtractedFieldsFromEvaluationMutationFn = Apollo.MutationFunction<Types.SaveExtractedFieldsFromEvaluationMutation, Types.SaveExtractedFieldsFromEvaluationMutationVariables>;

/**
 * __useSaveExtractedFieldsFromEvaluationMutation__
 *
 * To run a mutation, you first call `useSaveExtractedFieldsFromEvaluationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveExtractedFieldsFromEvaluationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveExtractedFieldsFromEvaluationMutation, { data, loading, error }] = useSaveExtractedFieldsFromEvaluationMutation({
 *   variables: {
 *      evaluationId: // value for 'evaluationId'
 *   },
 * });
 */
export function useSaveExtractedFieldsFromEvaluationMutation(baseOptions?: Apollo.MutationHookOptions<Types.SaveExtractedFieldsFromEvaluationMutation, Types.SaveExtractedFieldsFromEvaluationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SaveExtractedFieldsFromEvaluationMutation, Types.SaveExtractedFieldsFromEvaluationMutationVariables>(SaveExtractedFieldsFromEvaluationDocument, options);
      }
export type SaveExtractedFieldsFromEvaluationMutationHookResult = ReturnType<typeof useSaveExtractedFieldsFromEvaluationMutation>;
export type SaveExtractedFieldsFromEvaluationMutationResult = Apollo.MutationResult<Types.SaveExtractedFieldsFromEvaluationMutation>;
export type SaveExtractedFieldsFromEvaluationMutationOptions = Apollo.BaseMutationOptions<Types.SaveExtractedFieldsFromEvaluationMutation, Types.SaveExtractedFieldsFromEvaluationMutationVariables>;
export const BulkEvaluateDocumentClassificationsDocument = gql`
    mutation BulkEvaluateDocumentClassifications($evaluationIds: [ID!]!) {
  bulkEvaluateDocumentClassifications(evaluationIds: $evaluationIds)
}
    `;
export type BulkEvaluateDocumentClassificationsMutationFn = Apollo.MutationFunction<Types.BulkEvaluateDocumentClassificationsMutation, Types.BulkEvaluateDocumentClassificationsMutationVariables>;

/**
 * __useBulkEvaluateDocumentClassificationsMutation__
 *
 * To run a mutation, you first call `useBulkEvaluateDocumentClassificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkEvaluateDocumentClassificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkEvaluateDocumentClassificationsMutation, { data, loading, error }] = useBulkEvaluateDocumentClassificationsMutation({
 *   variables: {
 *      evaluationIds: // value for 'evaluationIds'
 *   },
 * });
 */
export function useBulkEvaluateDocumentClassificationsMutation(baseOptions?: Apollo.MutationHookOptions<Types.BulkEvaluateDocumentClassificationsMutation, Types.BulkEvaluateDocumentClassificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.BulkEvaluateDocumentClassificationsMutation, Types.BulkEvaluateDocumentClassificationsMutationVariables>(BulkEvaluateDocumentClassificationsDocument, options);
      }
export type BulkEvaluateDocumentClassificationsMutationHookResult = ReturnType<typeof useBulkEvaluateDocumentClassificationsMutation>;
export type BulkEvaluateDocumentClassificationsMutationResult = Apollo.MutationResult<Types.BulkEvaluateDocumentClassificationsMutation>;
export type BulkEvaluateDocumentClassificationsMutationOptions = Apollo.BaseMutationOptions<Types.BulkEvaluateDocumentClassificationsMutation, Types.BulkEvaluateDocumentClassificationsMutationVariables>;
export const CreateOrUpdateDocumentLlmEvaluationDocument = gql`
    mutation CreateOrUpdateDocumentLLMEvaluation($input: DocumentLLMEvaluationInput!, $id: ID) {
  createOrUpdateDocumentLLMEvaluation(input: $input, id: $id) {
    id
    documentLLM {
      id
      documentLLMEvaluations {
        ...DocumentLLMEvaluation
      }
    }
    document {
      id
      name
      usState
      form
    }
  }
}
    ${DocumentLlmEvaluationFragmentDoc}`;
export type CreateOrUpdateDocumentLlmEvaluationMutationFn = Apollo.MutationFunction<Types.CreateOrUpdateDocumentLlmEvaluationMutation, Types.CreateOrUpdateDocumentLlmEvaluationMutationVariables>;

/**
 * __useCreateOrUpdateDocumentLlmEvaluationMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateDocumentLlmEvaluationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateDocumentLlmEvaluationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateDocumentLlmEvaluationMutation, { data, loading, error }] = useCreateOrUpdateDocumentLlmEvaluationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateOrUpdateDocumentLlmEvaluationMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateOrUpdateDocumentLlmEvaluationMutation, Types.CreateOrUpdateDocumentLlmEvaluationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateOrUpdateDocumentLlmEvaluationMutation, Types.CreateOrUpdateDocumentLlmEvaluationMutationVariables>(CreateOrUpdateDocumentLlmEvaluationDocument, options);
      }
export type CreateOrUpdateDocumentLlmEvaluationMutationHookResult = ReturnType<typeof useCreateOrUpdateDocumentLlmEvaluationMutation>;
export type CreateOrUpdateDocumentLlmEvaluationMutationResult = Apollo.MutationResult<Types.CreateOrUpdateDocumentLlmEvaluationMutation>;
export type CreateOrUpdateDocumentLlmEvaluationMutationOptions = Apollo.BaseMutationOptions<Types.CreateOrUpdateDocumentLlmEvaluationMutation, Types.CreateOrUpdateDocumentLlmEvaluationMutationVariables>;
export const CreateRuleDocument = gql`
    mutation createRule($input: CreateRuleInput!, $relationInput: RuleRelationInput!) {
  createRule(input: $input, relationInput: $relationInput) {
    rule {
      ...Rule
      field {
        id
        defaultRules {
          ...Rule
        }
      }
      documentVersionField {
        id
        rules {
          ...Rule
        }
      }
      defaultSecondaryDocument {
        id
        defaultRules {
          ...Rule
        }
      }
      secondaryDocumentVersion {
        id
        rules {
          ...Rule
        }
      }
    }
  }
}
    ${RuleFragmentDoc}`;
export type CreateRuleMutationFn = Apollo.MutationFunction<Types.CreateRuleMutation, Types.CreateRuleMutationVariables>;

/**
 * __useCreateRuleMutation__
 *
 * To run a mutation, you first call `useCreateRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRuleMutation, { data, loading, error }] = useCreateRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *      relationInput: // value for 'relationInput'
 *   },
 * });
 */
export function useCreateRuleMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateRuleMutation, Types.CreateRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateRuleMutation, Types.CreateRuleMutationVariables>(CreateRuleDocument, options);
      }
export type CreateRuleMutationHookResult = ReturnType<typeof useCreateRuleMutation>;
export type CreateRuleMutationResult = Apollo.MutationResult<Types.CreateRuleMutation>;
export type CreateRuleMutationOptions = Apollo.BaseMutationOptions<Types.CreateRuleMutation, Types.CreateRuleMutationVariables>;
export const CreateTransactionPipelineDocument = gql`
    mutation createTransactionPipeline($input: CreateTransactionPipelineInput!) {
  createTransactionPipeline(input: $input) {
    ...TransactionPipeline
  }
}
    ${TransactionPipelineFragmentDoc}`;
export type CreateTransactionPipelineMutationFn = Apollo.MutationFunction<Types.CreateTransactionPipelineMutation, Types.CreateTransactionPipelineMutationVariables>;

/**
 * __useCreateTransactionPipelineMutation__
 *
 * To run a mutation, you first call `useCreateTransactionPipelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTransactionPipelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTransactionPipelineMutation, { data, loading, error }] = useCreateTransactionPipelineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTransactionPipelineMutation(baseOptions?: Apollo.MutationHookOptions<Types.CreateTransactionPipelineMutation, Types.CreateTransactionPipelineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.CreateTransactionPipelineMutation, Types.CreateTransactionPipelineMutationVariables>(CreateTransactionPipelineDocument, options);
      }
export type CreateTransactionPipelineMutationHookResult = ReturnType<typeof useCreateTransactionPipelineMutation>;
export type CreateTransactionPipelineMutationResult = Apollo.MutationResult<Types.CreateTransactionPipelineMutation>;
export type CreateTransactionPipelineMutationOptions = Apollo.BaseMutationOptions<Types.CreateTransactionPipelineMutation, Types.CreateTransactionPipelineMutationVariables>;
export const DeleteComplianceKeyTermSectionDocument = gql`
    mutation deleteComplianceKeyTermSection($id: ID!) {
  deleteComplianceKeyTermSection(id: $id) {
    deleted
  }
}
    `;
export type DeleteComplianceKeyTermSectionMutationFn = Apollo.MutationFunction<Types.DeleteComplianceKeyTermSectionMutation, Types.DeleteComplianceKeyTermSectionMutationVariables>;

/**
 * __useDeleteComplianceKeyTermSectionMutation__
 *
 * To run a mutation, you first call `useDeleteComplianceKeyTermSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteComplianceKeyTermSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteComplianceKeyTermSectionMutation, { data, loading, error }] = useDeleteComplianceKeyTermSectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteComplianceKeyTermSectionMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteComplianceKeyTermSectionMutation, Types.DeleteComplianceKeyTermSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteComplianceKeyTermSectionMutation, Types.DeleteComplianceKeyTermSectionMutationVariables>(DeleteComplianceKeyTermSectionDocument, options);
      }
export type DeleteComplianceKeyTermSectionMutationHookResult = ReturnType<typeof useDeleteComplianceKeyTermSectionMutation>;
export type DeleteComplianceKeyTermSectionMutationResult = Apollo.MutationResult<Types.DeleteComplianceKeyTermSectionMutation>;
export type DeleteComplianceKeyTermSectionMutationOptions = Apollo.BaseMutationOptions<Types.DeleteComplianceKeyTermSectionMutation, Types.DeleteComplianceKeyTermSectionMutationVariables>;
export const DeleteContractDocumentsDocument = gql`
    mutation DeleteContractDocuments($input: DeleteContractDocumentsInput!) {
  deleteContractDocuments(input: $input) {
    contract {
      id
      fieldValues
      contractDocuments {
        ...ContractDocumentForContract
      }
    }
  }
}
    ${ContractDocumentForContractFragmentDoc}`;
export type DeleteContractDocumentsMutationFn = Apollo.MutationFunction<Types.DeleteContractDocumentsMutation, Types.DeleteContractDocumentsMutationVariables>;

/**
 * __useDeleteContractDocumentsMutation__
 *
 * To run a mutation, you first call `useDeleteContractDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractDocumentsMutation, { data, loading, error }] = useDeleteContractDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteContractDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteContractDocumentsMutation, Types.DeleteContractDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteContractDocumentsMutation, Types.DeleteContractDocumentsMutationVariables>(DeleteContractDocumentsDocument, options);
      }
export type DeleteContractDocumentsMutationHookResult = ReturnType<typeof useDeleteContractDocumentsMutation>;
export type DeleteContractDocumentsMutationResult = Apollo.MutationResult<Types.DeleteContractDocumentsMutation>;
export type DeleteContractDocumentsMutationOptions = Apollo.BaseMutationOptions<Types.DeleteContractDocumentsMutation, Types.DeleteContractDocumentsMutationVariables>;
export const DeleteDefaultSecondaryDocumentDocument = gql`
    mutation deleteDefaultSecondaryDocument($input: DeleteDefaultSecondaryDocumentInput!) {
  deleteDefaultSecondaryDocument(input: $input) {
    success
  }
}
    `;
export type DeleteDefaultSecondaryDocumentMutationFn = Apollo.MutationFunction<Types.DeleteDefaultSecondaryDocumentMutation, Types.DeleteDefaultSecondaryDocumentMutationVariables>;

/**
 * __useDeleteDefaultSecondaryDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDefaultSecondaryDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDefaultSecondaryDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDefaultSecondaryDocumentMutation, { data, loading, error }] = useDeleteDefaultSecondaryDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDefaultSecondaryDocumentMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteDefaultSecondaryDocumentMutation, Types.DeleteDefaultSecondaryDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteDefaultSecondaryDocumentMutation, Types.DeleteDefaultSecondaryDocumentMutationVariables>(DeleteDefaultSecondaryDocumentDocument, options);
      }
export type DeleteDefaultSecondaryDocumentMutationHookResult = ReturnType<typeof useDeleteDefaultSecondaryDocumentMutation>;
export type DeleteDefaultSecondaryDocumentMutationResult = Apollo.MutationResult<Types.DeleteDefaultSecondaryDocumentMutation>;
export type DeleteDefaultSecondaryDocumentMutationOptions = Apollo.BaseMutationOptions<Types.DeleteDefaultSecondaryDocumentMutation, Types.DeleteDefaultSecondaryDocumentMutationVariables>;
export const DeleteDocumentDocument = gql`
    mutation deleteDocument($id: ID!) {
  deleteDocument(id: $id) {
    deleted
  }
}
    `;
export type DeleteDocumentMutationFn = Apollo.MutationFunction<Types.DeleteDocumentMutation, Types.DeleteDocumentMutationVariables>;

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDocumentMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteDocumentMutation, Types.DeleteDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteDocumentMutation, Types.DeleteDocumentMutationVariables>(DeleteDocumentDocument, options);
      }
export type DeleteDocumentMutationHookResult = ReturnType<typeof useDeleteDocumentMutation>;
export type DeleteDocumentMutationResult = Apollo.MutationResult<Types.DeleteDocumentMutation>;
export type DeleteDocumentMutationOptions = Apollo.BaseMutationOptions<Types.DeleteDocumentMutation, Types.DeleteDocumentMutationVariables>;
export const DeleteDocumentLlmDocument = gql`
    mutation DeleteDocumentLLM($id: ID!) {
  deleteDocumentLLM(id: $id)
}
    `;
export type DeleteDocumentLlmMutationFn = Apollo.MutationFunction<Types.DeleteDocumentLlmMutation, Types.DeleteDocumentLlmMutationVariables>;

/**
 * __useDeleteDocumentLlmMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentLlmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentLlmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentLlmMutation, { data, loading, error }] = useDeleteDocumentLlmMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDocumentLlmMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteDocumentLlmMutation, Types.DeleteDocumentLlmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteDocumentLlmMutation, Types.DeleteDocumentLlmMutationVariables>(DeleteDocumentLlmDocument, options);
      }
export type DeleteDocumentLlmMutationHookResult = ReturnType<typeof useDeleteDocumentLlmMutation>;
export type DeleteDocumentLlmMutationResult = Apollo.MutationResult<Types.DeleteDocumentLlmMutation>;
export type DeleteDocumentLlmMutationOptions = Apollo.BaseMutationOptions<Types.DeleteDocumentLlmMutation, Types.DeleteDocumentLlmMutationVariables>;
export const DeleteDocumentLlmEvaluationDocument = gql`
    mutation DeleteDocumentLLMEvaluation($id: ID!) {
  deleteDocumentLLMEvaluation(id: $id)
}
    `;
export type DeleteDocumentLlmEvaluationMutationFn = Apollo.MutationFunction<Types.DeleteDocumentLlmEvaluationMutation, Types.DeleteDocumentLlmEvaluationMutationVariables>;

/**
 * __useDeleteDocumentLlmEvaluationMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentLlmEvaluationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentLlmEvaluationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentLlmEvaluationMutation, { data, loading, error }] = useDeleteDocumentLlmEvaluationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDocumentLlmEvaluationMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteDocumentLlmEvaluationMutation, Types.DeleteDocumentLlmEvaluationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteDocumentLlmEvaluationMutation, Types.DeleteDocumentLlmEvaluationMutationVariables>(DeleteDocumentLlmEvaluationDocument, options);
      }
export type DeleteDocumentLlmEvaluationMutationHookResult = ReturnType<typeof useDeleteDocumentLlmEvaluationMutation>;
export type DeleteDocumentLlmEvaluationMutationResult = Apollo.MutationResult<Types.DeleteDocumentLlmEvaluationMutation>;
export type DeleteDocumentLlmEvaluationMutationOptions = Apollo.BaseMutationOptions<Types.DeleteDocumentLlmEvaluationMutation, Types.DeleteDocumentLlmEvaluationMutationVariables>;
export const DeleteDocumentLlmExampleDocument = gql`
    mutation DeleteDocumentLLMExample($id: ID!) {
  deleteDocumentLLMExample(id: $id)
}
    `;
export type DeleteDocumentLlmExampleMutationFn = Apollo.MutationFunction<Types.DeleteDocumentLlmExampleMutation, Types.DeleteDocumentLlmExampleMutationVariables>;

/**
 * __useDeleteDocumentLlmExampleMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentLlmExampleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentLlmExampleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentLlmExampleMutation, { data, loading, error }] = useDeleteDocumentLlmExampleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDocumentLlmExampleMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteDocumentLlmExampleMutation, Types.DeleteDocumentLlmExampleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteDocumentLlmExampleMutation, Types.DeleteDocumentLlmExampleMutationVariables>(DeleteDocumentLlmExampleDocument, options);
      }
export type DeleteDocumentLlmExampleMutationHookResult = ReturnType<typeof useDeleteDocumentLlmExampleMutation>;
export type DeleteDocumentLlmExampleMutationResult = Apollo.MutationResult<Types.DeleteDocumentLlmExampleMutation>;
export type DeleteDocumentLlmExampleMutationOptions = Apollo.BaseMutationOptions<Types.DeleteDocumentLlmExampleMutation, Types.DeleteDocumentLlmExampleMutationVariables>;
export const DeleteDocumentSectionDocument = gql`
    mutation deleteDocumentSection($id: ID!) {
  deleteDocumentSection(id: $id) {
    deleted
  }
}
    `;
export type DeleteDocumentSectionMutationFn = Apollo.MutationFunction<Types.DeleteDocumentSectionMutation, Types.DeleteDocumentSectionMutationVariables>;

/**
 * __useDeleteDocumentSectionMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentSectionMutation, { data, loading, error }] = useDeleteDocumentSectionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDocumentSectionMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteDocumentSectionMutation, Types.DeleteDocumentSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteDocumentSectionMutation, Types.DeleteDocumentSectionMutationVariables>(DeleteDocumentSectionDocument, options);
      }
export type DeleteDocumentSectionMutationHookResult = ReturnType<typeof useDeleteDocumentSectionMutation>;
export type DeleteDocumentSectionMutationResult = Apollo.MutationResult<Types.DeleteDocumentSectionMutation>;
export type DeleteDocumentSectionMutationOptions = Apollo.BaseMutationOptions<Types.DeleteDocumentSectionMutation, Types.DeleteDocumentSectionMutationVariables>;
export const DeleteDocumentVersionDocument = gql`
    mutation deleteDocumentVersion($uuid: ID!) {
  deleteDocumentVersion(uuid: $uuid) {
    deletedDocumentVersionUuid
  }
}
    `;
export type DeleteDocumentVersionMutationFn = Apollo.MutationFunction<Types.DeleteDocumentVersionMutation, Types.DeleteDocumentVersionMutationVariables>;

/**
 * __useDeleteDocumentVersionMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentVersionMutation, { data, loading, error }] = useDeleteDocumentVersionMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useDeleteDocumentVersionMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteDocumentVersionMutation, Types.DeleteDocumentVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteDocumentVersionMutation, Types.DeleteDocumentVersionMutationVariables>(DeleteDocumentVersionDocument, options);
      }
export type DeleteDocumentVersionMutationHookResult = ReturnType<typeof useDeleteDocumentVersionMutation>;
export type DeleteDocumentVersionMutationResult = Apollo.MutationResult<Types.DeleteDocumentVersionMutation>;
export type DeleteDocumentVersionMutationOptions = Apollo.BaseMutationOptions<Types.DeleteDocumentVersionMutation, Types.DeleteDocumentVersionMutationVariables>;
export const DeleteDocumentVersionFieldsDocument = gql`
    mutation deleteDocumentVersionFields($ids: [ID!]!) {
  deleteDocumentVersionFields(ids: $ids) {
    deletedIds
  }
}
    `;
export type DeleteDocumentVersionFieldsMutationFn = Apollo.MutationFunction<Types.DeleteDocumentVersionFieldsMutation, Types.DeleteDocumentVersionFieldsMutationVariables>;

/**
 * __useDeleteDocumentVersionFieldsMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentVersionFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentVersionFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentVersionFieldsMutation, { data, loading, error }] = useDeleteDocumentVersionFieldsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteDocumentVersionFieldsMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteDocumentVersionFieldsMutation, Types.DeleteDocumentVersionFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteDocumentVersionFieldsMutation, Types.DeleteDocumentVersionFieldsMutationVariables>(DeleteDocumentVersionFieldsDocument, options);
      }
export type DeleteDocumentVersionFieldsMutationHookResult = ReturnType<typeof useDeleteDocumentVersionFieldsMutation>;
export type DeleteDocumentVersionFieldsMutationResult = Apollo.MutationResult<Types.DeleteDocumentVersionFieldsMutation>;
export type DeleteDocumentVersionFieldsMutationOptions = Apollo.BaseMutationOptions<Types.DeleteDocumentVersionFieldsMutation, Types.DeleteDocumentVersionFieldsMutationVariables>;
export const DeleteFieldDocument = gql`
    mutation deleteField($id: ID!) {
  deleteField(id: $id) {
    id
  }
}
    `;
export type DeleteFieldMutationFn = Apollo.MutationFunction<Types.DeleteFieldMutation, Types.DeleteFieldMutationVariables>;

/**
 * __useDeleteFieldMutation__
 *
 * To run a mutation, you first call `useDeleteFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFieldMutation, { data, loading, error }] = useDeleteFieldMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFieldMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteFieldMutation, Types.DeleteFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteFieldMutation, Types.DeleteFieldMutationVariables>(DeleteFieldDocument, options);
      }
export type DeleteFieldMutationHookResult = ReturnType<typeof useDeleteFieldMutation>;
export type DeleteFieldMutationResult = Apollo.MutationResult<Types.DeleteFieldMutation>;
export type DeleteFieldMutationOptions = Apollo.BaseMutationOptions<Types.DeleteFieldMutation, Types.DeleteFieldMutationVariables>;
export const DeletePreapprovalContractDocumentDocument = gql`
    mutation deletePreapprovalContractDocument($input: DeletePreapprovalContractDocumentInput!) {
  deletePreapprovalContractDocument(input: $input) {
    contract {
      id
    }
  }
}
    `;
export type DeletePreapprovalContractDocumentMutationFn = Apollo.MutationFunction<Types.DeletePreapprovalContractDocumentMutation, Types.DeletePreapprovalContractDocumentMutationVariables>;

/**
 * __useDeletePreapprovalContractDocumentMutation__
 *
 * To run a mutation, you first call `useDeletePreapprovalContractDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePreapprovalContractDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePreapprovalContractDocumentMutation, { data, loading, error }] = useDeletePreapprovalContractDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePreapprovalContractDocumentMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeletePreapprovalContractDocumentMutation, Types.DeletePreapprovalContractDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeletePreapprovalContractDocumentMutation, Types.DeletePreapprovalContractDocumentMutationVariables>(DeletePreapprovalContractDocumentDocument, options);
      }
export type DeletePreapprovalContractDocumentMutationHookResult = ReturnType<typeof useDeletePreapprovalContractDocumentMutation>;
export type DeletePreapprovalContractDocumentMutationResult = Apollo.MutationResult<Types.DeletePreapprovalContractDocumentMutation>;
export type DeletePreapprovalContractDocumentMutationOptions = Apollo.BaseMutationOptions<Types.DeletePreapprovalContractDocumentMutation, Types.DeletePreapprovalContractDocumentMutationVariables>;
export const DeleteRuleDocument = gql`
    mutation deleteRule($id: ID!) {
  deleteRule(id: $id) {
    id
  }
}
    `;
export type DeleteRuleMutationFn = Apollo.MutationFunction<Types.DeleteRuleMutation, Types.DeleteRuleMutationVariables>;

/**
 * __useDeleteRuleMutation__
 *
 * To run a mutation, you first call `useDeleteRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRuleMutation, { data, loading, error }] = useDeleteRuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRuleMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteRuleMutation, Types.DeleteRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteRuleMutation, Types.DeleteRuleMutationVariables>(DeleteRuleDocument, options);
      }
export type DeleteRuleMutationHookResult = ReturnType<typeof useDeleteRuleMutation>;
export type DeleteRuleMutationResult = Apollo.MutationResult<Types.DeleteRuleMutation>;
export type DeleteRuleMutationOptions = Apollo.BaseMutationOptions<Types.DeleteRuleMutation, Types.DeleteRuleMutationVariables>;
export const DeleteTransactionRuleDocument = gql`
    mutation deleteTransactionRule($id: ID!) {
  deleteTransactionRule(id: $id)
}
    `;
export type DeleteTransactionRuleMutationFn = Apollo.MutationFunction<Types.DeleteTransactionRuleMutation, Types.DeleteTransactionRuleMutationVariables>;

/**
 * __useDeleteTransactionRuleMutation__
 *
 * To run a mutation, you first call `useDeleteTransactionRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTransactionRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTransactionRuleMutation, { data, loading, error }] = useDeleteTransactionRuleMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTransactionRuleMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteTransactionRuleMutation, Types.DeleteTransactionRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteTransactionRuleMutation, Types.DeleteTransactionRuleMutationVariables>(DeleteTransactionRuleDocument, options);
      }
export type DeleteTransactionRuleMutationHookResult = ReturnType<typeof useDeleteTransactionRuleMutation>;
export type DeleteTransactionRuleMutationResult = Apollo.MutationResult<Types.DeleteTransactionRuleMutation>;
export type DeleteTransactionRuleMutationOptions = Apollo.BaseMutationOptions<Types.DeleteTransactionRuleMutation, Types.DeleteTransactionRuleMutationVariables>;
export const DeleteTransactionStageDocument = gql`
    mutation deleteTransactionStage($id: ID!) {
  deleteTransactionStage(id: $id)
}
    `;
export type DeleteTransactionStageMutationFn = Apollo.MutationFunction<Types.DeleteTransactionStageMutation, Types.DeleteTransactionStageMutationVariables>;

/**
 * __useDeleteTransactionStageMutation__
 *
 * To run a mutation, you first call `useDeleteTransactionStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTransactionStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTransactionStageMutation, { data, loading, error }] = useDeleteTransactionStageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTransactionStageMutation(baseOptions?: Apollo.MutationHookOptions<Types.DeleteTransactionStageMutation, Types.DeleteTransactionStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DeleteTransactionStageMutation, Types.DeleteTransactionStageMutationVariables>(DeleteTransactionStageDocument, options);
      }
export type DeleteTransactionStageMutationHookResult = ReturnType<typeof useDeleteTransactionStageMutation>;
export type DeleteTransactionStageMutationResult = Apollo.MutationResult<Types.DeleteTransactionStageMutation>;
export type DeleteTransactionStageMutationOptions = Apollo.BaseMutationOptions<Types.DeleteTransactionStageMutation, Types.DeleteTransactionStageMutationVariables>;
export const DetectFormFieldsDocument = gql`
    mutation detectFormFields($input: ExtractContractInput!) {
  detectFormFields(input: $input) {
    ...DetectFormFields
  }
}
    ${DetectFormFieldsFragmentDoc}`;
export type DetectFormFieldsMutationFn = Apollo.MutationFunction<Types.DetectFormFieldsMutation, Types.DetectFormFieldsMutationVariables>;

/**
 * __useDetectFormFieldsMutation__
 *
 * To run a mutation, you first call `useDetectFormFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetectFormFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detectFormFieldsMutation, { data, loading, error }] = useDetectFormFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDetectFormFieldsMutation(baseOptions?: Apollo.MutationHookOptions<Types.DetectFormFieldsMutation, Types.DetectFormFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DetectFormFieldsMutation, Types.DetectFormFieldsMutationVariables>(DetectFormFieldsDocument, options);
      }
export type DetectFormFieldsMutationHookResult = ReturnType<typeof useDetectFormFieldsMutation>;
export type DetectFormFieldsMutationResult = Apollo.MutationResult<Types.DetectFormFieldsMutation>;
export type DetectFormFieldsMutationOptions = Apollo.BaseMutationOptions<Types.DetectFormFieldsMutation, Types.DetectFormFieldsMutationVariables>;
export const DetectFormFieldsForDocumentVersionDocument = gql`
    mutation detectFormFieldsForDocumentVersion($id: ID!) {
  detectFormFieldsForDocumentVersion(id: $id) {
    jobId
  }
}
    `;
export type DetectFormFieldsForDocumentVersionMutationFn = Apollo.MutationFunction<Types.DetectFormFieldsForDocumentVersionMutation, Types.DetectFormFieldsForDocumentVersionMutationVariables>;

/**
 * __useDetectFormFieldsForDocumentVersionMutation__
 *
 * To run a mutation, you first call `useDetectFormFieldsForDocumentVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDetectFormFieldsForDocumentVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [detectFormFieldsForDocumentVersionMutation, { data, loading, error }] = useDetectFormFieldsForDocumentVersionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDetectFormFieldsForDocumentVersionMutation(baseOptions?: Apollo.MutationHookOptions<Types.DetectFormFieldsForDocumentVersionMutation, Types.DetectFormFieldsForDocumentVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.DetectFormFieldsForDocumentVersionMutation, Types.DetectFormFieldsForDocumentVersionMutationVariables>(DetectFormFieldsForDocumentVersionDocument, options);
      }
export type DetectFormFieldsForDocumentVersionMutationHookResult = ReturnType<typeof useDetectFormFieldsForDocumentVersionMutation>;
export type DetectFormFieldsForDocumentVersionMutationResult = Apollo.MutationResult<Types.DetectFormFieldsForDocumentVersionMutation>;
export type DetectFormFieldsForDocumentVersionMutationOptions = Apollo.BaseMutationOptions<Types.DetectFormFieldsForDocumentVersionMutation, Types.DetectFormFieldsForDocumentVersionMutationVariables>;
export const ExternalCreateComplianceMessageHistoryDocument = gql`
    mutation externalCreateComplianceMessageHistory($input: ExternalCreateComplianceMessageHistoryInput!) {
  externalCreateComplianceMessageHistory(input: $input) {
    complianceMessageHistory {
      id
      recipientType
      recipientValue
      messageContent
      workflowRunId
      createdAt
      updatedAt
    }
  }
}
    `;
export type ExternalCreateComplianceMessageHistoryMutationFn = Apollo.MutationFunction<Types.ExternalCreateComplianceMessageHistoryMutation, Types.ExternalCreateComplianceMessageHistoryMutationVariables>;

/**
 * __useExternalCreateComplianceMessageHistoryMutation__
 *
 * To run a mutation, you first call `useExternalCreateComplianceMessageHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExternalCreateComplianceMessageHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [externalCreateComplianceMessageHistoryMutation, { data, loading, error }] = useExternalCreateComplianceMessageHistoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalCreateComplianceMessageHistoryMutation(baseOptions?: Apollo.MutationHookOptions<Types.ExternalCreateComplianceMessageHistoryMutation, Types.ExternalCreateComplianceMessageHistoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ExternalCreateComplianceMessageHistoryMutation, Types.ExternalCreateComplianceMessageHistoryMutationVariables>(ExternalCreateComplianceMessageHistoryDocument, options);
      }
export type ExternalCreateComplianceMessageHistoryMutationHookResult = ReturnType<typeof useExternalCreateComplianceMessageHistoryMutation>;
export type ExternalCreateComplianceMessageHistoryMutationResult = Apollo.MutationResult<Types.ExternalCreateComplianceMessageHistoryMutation>;
export type ExternalCreateComplianceMessageHistoryMutationOptions = Apollo.BaseMutationOptions<Types.ExternalCreateComplianceMessageHistoryMutation, Types.ExternalCreateComplianceMessageHistoryMutationVariables>;
export const ExternalOverrideKeyTermsForIngestionFolderDocument = gql`
    mutation ExternalOverrideKeyTermsForIngestionFolder($input: OverrideKeyTermsForIngestionFolderInput!) {
  externalOverrideKeyTermsForIngestionFolder(input: $input) {
    success
  }
}
    `;
export type ExternalOverrideKeyTermsForIngestionFolderMutationFn = Apollo.MutationFunction<Types.ExternalOverrideKeyTermsForIngestionFolderMutation, Types.ExternalOverrideKeyTermsForIngestionFolderMutationVariables>;

/**
 * __useExternalOverrideKeyTermsForIngestionFolderMutation__
 *
 * To run a mutation, you first call `useExternalOverrideKeyTermsForIngestionFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExternalOverrideKeyTermsForIngestionFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [externalOverrideKeyTermsForIngestionFolderMutation, { data, loading, error }] = useExternalOverrideKeyTermsForIngestionFolderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalOverrideKeyTermsForIngestionFolderMutation(baseOptions?: Apollo.MutationHookOptions<Types.ExternalOverrideKeyTermsForIngestionFolderMutation, Types.ExternalOverrideKeyTermsForIngestionFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ExternalOverrideKeyTermsForIngestionFolderMutation, Types.ExternalOverrideKeyTermsForIngestionFolderMutationVariables>(ExternalOverrideKeyTermsForIngestionFolderDocument, options);
      }
export type ExternalOverrideKeyTermsForIngestionFolderMutationHookResult = ReturnType<typeof useExternalOverrideKeyTermsForIngestionFolderMutation>;
export type ExternalOverrideKeyTermsForIngestionFolderMutationResult = Apollo.MutationResult<Types.ExternalOverrideKeyTermsForIngestionFolderMutation>;
export type ExternalOverrideKeyTermsForIngestionFolderMutationOptions = Apollo.BaseMutationOptions<Types.ExternalOverrideKeyTermsForIngestionFolderMutation, Types.ExternalOverrideKeyTermsForIngestionFolderMutationVariables>;
export const ExternalSyncDarwinFeesDocument = gql`
    mutation externalSyncDarwinFees($input: ExternalSyncDarwinFeesInput!) {
  externalSyncDarwinFees(input: $input) {
    success
    syncedFees {
      feeType
      syncedAmount
      payer
      action
      skipReason
    }
  }
}
    `;
export type ExternalSyncDarwinFeesMutationFn = Apollo.MutationFunction<Types.ExternalSyncDarwinFeesMutation, Types.ExternalSyncDarwinFeesMutationVariables>;

/**
 * __useExternalSyncDarwinFeesMutation__
 *
 * To run a mutation, you first call `useExternalSyncDarwinFeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExternalSyncDarwinFeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [externalSyncDarwinFeesMutation, { data, loading, error }] = useExternalSyncDarwinFeesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalSyncDarwinFeesMutation(baseOptions?: Apollo.MutationHookOptions<Types.ExternalSyncDarwinFeesMutation, Types.ExternalSyncDarwinFeesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ExternalSyncDarwinFeesMutation, Types.ExternalSyncDarwinFeesMutationVariables>(ExternalSyncDarwinFeesDocument, options);
      }
export type ExternalSyncDarwinFeesMutationHookResult = ReturnType<typeof useExternalSyncDarwinFeesMutation>;
export type ExternalSyncDarwinFeesMutationResult = Apollo.MutationResult<Types.ExternalSyncDarwinFeesMutation>;
export type ExternalSyncDarwinFeesMutationOptions = Apollo.BaseMutationOptions<Types.ExternalSyncDarwinFeesMutation, Types.ExternalSyncDarwinFeesMutationVariables>;
export const ExternalSyncDarwinVendorsDocument = gql`
    mutation ExternalSyncDarwinVendors($input: ExternalSyncDarwinVendorsInput!) {
  externalSyncDarwinVendors(input: $input) {
    success
    syncedVendors {
      vendorType
      personId
      personName
    }
  }
}
    `;
export type ExternalSyncDarwinVendorsMutationFn = Apollo.MutationFunction<Types.ExternalSyncDarwinVendorsMutation, Types.ExternalSyncDarwinVendorsMutationVariables>;

/**
 * __useExternalSyncDarwinVendorsMutation__
 *
 * To run a mutation, you first call `useExternalSyncDarwinVendorsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExternalSyncDarwinVendorsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [externalSyncDarwinVendorsMutation, { data, loading, error }] = useExternalSyncDarwinVendorsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalSyncDarwinVendorsMutation(baseOptions?: Apollo.MutationHookOptions<Types.ExternalSyncDarwinVendorsMutation, Types.ExternalSyncDarwinVendorsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ExternalSyncDarwinVendorsMutation, Types.ExternalSyncDarwinVendorsMutationVariables>(ExternalSyncDarwinVendorsDocument, options);
      }
export type ExternalSyncDarwinVendorsMutationHookResult = ReturnType<typeof useExternalSyncDarwinVendorsMutation>;
export type ExternalSyncDarwinVendorsMutationResult = Apollo.MutationResult<Types.ExternalSyncDarwinVendorsMutation>;
export type ExternalSyncDarwinVendorsMutationOptions = Apollo.BaseMutationOptions<Types.ExternalSyncDarwinVendorsMutation, Types.ExternalSyncDarwinVendorsMutationVariables>;
export const ExternalUpdateIngestionDocumentStatusDocument = gql`
    mutation ExternalUpdateIngestionDocumentStatus($input: ExternalUpdateIngestionDocumentStatusInput!) {
  externalUpdateIngestionDocumentStatus(input: $input) {
    id
    needsReview
    complianceStatus
  }
}
    `;
export type ExternalUpdateIngestionDocumentStatusMutationFn = Apollo.MutationFunction<Types.ExternalUpdateIngestionDocumentStatusMutation, Types.ExternalUpdateIngestionDocumentStatusMutationVariables>;

/**
 * __useExternalUpdateIngestionDocumentStatusMutation__
 *
 * To run a mutation, you first call `useExternalUpdateIngestionDocumentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExternalUpdateIngestionDocumentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [externalUpdateIngestionDocumentStatusMutation, { data, loading, error }] = useExternalUpdateIngestionDocumentStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalUpdateIngestionDocumentStatusMutation(baseOptions?: Apollo.MutationHookOptions<Types.ExternalUpdateIngestionDocumentStatusMutation, Types.ExternalUpdateIngestionDocumentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ExternalUpdateIngestionDocumentStatusMutation, Types.ExternalUpdateIngestionDocumentStatusMutationVariables>(ExternalUpdateIngestionDocumentStatusDocument, options);
      }
export type ExternalUpdateIngestionDocumentStatusMutationHookResult = ReturnType<typeof useExternalUpdateIngestionDocumentStatusMutation>;
export type ExternalUpdateIngestionDocumentStatusMutationResult = Apollo.MutationResult<Types.ExternalUpdateIngestionDocumentStatusMutation>;
export type ExternalUpdateIngestionDocumentStatusMutationOptions = Apollo.BaseMutationOptions<Types.ExternalUpdateIngestionDocumentStatusMutation, Types.ExternalUpdateIngestionDocumentStatusMutationVariables>;
export const ExtractContractDocument = gql`
    mutation extractContract($input: [ExtractContractInput!]!) {
  extractContract(inputs: $input) {
    ...ExtractContractMutation
  }
}
    ${ExtractContractMutationFragmentDoc}`;
export type ExtractContractMutationFn = Apollo.MutationFunction<Types.ExtractContractMutation, Types.ExtractContractMutationVariables>;

/**
 * __useExtractContractMutation__
 *
 * To run a mutation, you first call `useExtractContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtractContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extractContractMutation, { data, loading, error }] = useExtractContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExtractContractMutation(baseOptions?: Apollo.MutationHookOptions<Types.ExtractContractMutation, Types.ExtractContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ExtractContractMutation, Types.ExtractContractMutationVariables>(ExtractContractDocument, options);
      }
export type ExtractContractMutationHookResult = ReturnType<typeof useExtractContractMutation>;
export type ExtractContractMutationResult = Apollo.MutationResult<Types.ExtractContractMutation>;
export type ExtractContractMutationOptions = Apollo.BaseMutationOptions<Types.ExtractContractMutation, Types.ExtractContractMutationVariables>;
export const ExtractPreapprovalInfoDocument = gql`
    mutation extractPreapprovalInfo($input: ExtractPreapprovalInfoInput!) {
  extractPreapprovalInfo(input: $input) {
    primary_buyer
    co_buyer
    loan_type
    loan_amount
    purchase_price
  }
}
    `;
export type ExtractPreapprovalInfoMutationFn = Apollo.MutationFunction<Types.ExtractPreapprovalInfoMutation, Types.ExtractPreapprovalInfoMutationVariables>;

/**
 * __useExtractPreapprovalInfoMutation__
 *
 * To run a mutation, you first call `useExtractPreapprovalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtractPreapprovalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extractPreapprovalInfoMutation, { data, loading, error }] = useExtractPreapprovalInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExtractPreapprovalInfoMutation(baseOptions?: Apollo.MutationHookOptions<Types.ExtractPreapprovalInfoMutation, Types.ExtractPreapprovalInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ExtractPreapprovalInfoMutation, Types.ExtractPreapprovalInfoMutationVariables>(ExtractPreapprovalInfoDocument, options);
      }
export type ExtractPreapprovalInfoMutationHookResult = ReturnType<typeof useExtractPreapprovalInfoMutation>;
export type ExtractPreapprovalInfoMutationResult = Apollo.MutationResult<Types.ExtractPreapprovalInfoMutation>;
export type ExtractPreapprovalInfoMutationOptions = Apollo.BaseMutationOptions<Types.ExtractPreapprovalInfoMutation, Types.ExtractPreapprovalInfoMutationVariables>;
export const InternalCreateOrUpdateIngestionDocumentValidationFeedbackDocument = gql`
    mutation InternalCreateOrUpdateIngestionDocumentValidationFeedback($input: CreateIngestionDocumentValidationFeedbackInput!) {
  internalCreateOrUpdateIngestionDocumentValidationFeedback(input: $input) {
    ...IngestionDocumentValidationFeedback
  }
}
    ${IngestionDocumentValidationFeedbackFragmentDoc}`;
export type InternalCreateOrUpdateIngestionDocumentValidationFeedbackMutationFn = Apollo.MutationFunction<Types.InternalCreateOrUpdateIngestionDocumentValidationFeedbackMutation, Types.InternalCreateOrUpdateIngestionDocumentValidationFeedbackMutationVariables>;

/**
 * __useInternalCreateOrUpdateIngestionDocumentValidationFeedbackMutation__
 *
 * To run a mutation, you first call `useInternalCreateOrUpdateIngestionDocumentValidationFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInternalCreateOrUpdateIngestionDocumentValidationFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [internalCreateOrUpdateIngestionDocumentValidationFeedbackMutation, { data, loading, error }] = useInternalCreateOrUpdateIngestionDocumentValidationFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInternalCreateOrUpdateIngestionDocumentValidationFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<Types.InternalCreateOrUpdateIngestionDocumentValidationFeedbackMutation, Types.InternalCreateOrUpdateIngestionDocumentValidationFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.InternalCreateOrUpdateIngestionDocumentValidationFeedbackMutation, Types.InternalCreateOrUpdateIngestionDocumentValidationFeedbackMutationVariables>(InternalCreateOrUpdateIngestionDocumentValidationFeedbackDocument, options);
      }
export type InternalCreateOrUpdateIngestionDocumentValidationFeedbackMutationHookResult = ReturnType<typeof useInternalCreateOrUpdateIngestionDocumentValidationFeedbackMutation>;
export type InternalCreateOrUpdateIngestionDocumentValidationFeedbackMutationResult = Apollo.MutationResult<Types.InternalCreateOrUpdateIngestionDocumentValidationFeedbackMutation>;
export type InternalCreateOrUpdateIngestionDocumentValidationFeedbackMutationOptions = Apollo.BaseMutationOptions<Types.InternalCreateOrUpdateIngestionDocumentValidationFeedbackMutation, Types.InternalCreateOrUpdateIngestionDocumentValidationFeedbackMutationVariables>;
export const InternalCreateOrUpdateIngestionFolderValidationFeedbackDocument = gql`
    mutation InternalCreateOrUpdateIngestionFolderValidationFeedback($input: CreateIngestionFolderValidationFeedbackInput!) {
  internalCreateOrUpdateIngestionFolderValidationFeedback(input: $input) {
    ...IngestionFolderValidationFeedback
  }
}
    ${IngestionFolderValidationFeedbackFragmentDoc}`;
export type InternalCreateOrUpdateIngestionFolderValidationFeedbackMutationFn = Apollo.MutationFunction<Types.InternalCreateOrUpdateIngestionFolderValidationFeedbackMutation, Types.InternalCreateOrUpdateIngestionFolderValidationFeedbackMutationVariables>;

/**
 * __useInternalCreateOrUpdateIngestionFolderValidationFeedbackMutation__
 *
 * To run a mutation, you first call `useInternalCreateOrUpdateIngestionFolderValidationFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInternalCreateOrUpdateIngestionFolderValidationFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [internalCreateOrUpdateIngestionFolderValidationFeedbackMutation, { data, loading, error }] = useInternalCreateOrUpdateIngestionFolderValidationFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInternalCreateOrUpdateIngestionFolderValidationFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<Types.InternalCreateOrUpdateIngestionFolderValidationFeedbackMutation, Types.InternalCreateOrUpdateIngestionFolderValidationFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.InternalCreateOrUpdateIngestionFolderValidationFeedbackMutation, Types.InternalCreateOrUpdateIngestionFolderValidationFeedbackMutationVariables>(InternalCreateOrUpdateIngestionFolderValidationFeedbackDocument, options);
      }
export type InternalCreateOrUpdateIngestionFolderValidationFeedbackMutationHookResult = ReturnType<typeof useInternalCreateOrUpdateIngestionFolderValidationFeedbackMutation>;
export type InternalCreateOrUpdateIngestionFolderValidationFeedbackMutationResult = Apollo.MutationResult<Types.InternalCreateOrUpdateIngestionFolderValidationFeedbackMutation>;
export type InternalCreateOrUpdateIngestionFolderValidationFeedbackMutationOptions = Apollo.BaseMutationOptions<Types.InternalCreateOrUpdateIngestionFolderValidationFeedbackMutation, Types.InternalCreateOrUpdateIngestionFolderValidationFeedbackMutationVariables>;
export const LabelIngestionDocumentClassificationDocument = gql`
    mutation LabelIngestionDocumentClassification($input: OverrideIngestionDocumentClassificationInput!) {
  labelIngestionDocumentClassification(input: $input)
}
    `;
export type LabelIngestionDocumentClassificationMutationFn = Apollo.MutationFunction<Types.LabelIngestionDocumentClassificationMutation, Types.LabelIngestionDocumentClassificationMutationVariables>;

/**
 * __useLabelIngestionDocumentClassificationMutation__
 *
 * To run a mutation, you first call `useLabelIngestionDocumentClassificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLabelIngestionDocumentClassificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [labelIngestionDocumentClassificationMutation, { data, loading, error }] = useLabelIngestionDocumentClassificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLabelIngestionDocumentClassificationMutation(baseOptions?: Apollo.MutationHookOptions<Types.LabelIngestionDocumentClassificationMutation, Types.LabelIngestionDocumentClassificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.LabelIngestionDocumentClassificationMutation, Types.LabelIngestionDocumentClassificationMutationVariables>(LabelIngestionDocumentClassificationDocument, options);
      }
export type LabelIngestionDocumentClassificationMutationHookResult = ReturnType<typeof useLabelIngestionDocumentClassificationMutation>;
export type LabelIngestionDocumentClassificationMutationResult = Apollo.MutationResult<Types.LabelIngestionDocumentClassificationMutation>;
export type LabelIngestionDocumentClassificationMutationOptions = Apollo.BaseMutationOptions<Types.LabelIngestionDocumentClassificationMutation, Types.LabelIngestionDocumentClassificationMutationVariables>;
export const ReassignIngestionFolderPipelinesDocument = gql`
    mutation ReassignIngestionFolderPipelines($input: ReassignIngestionFolderPipelinesInput!) {
  reassignIngestionFolderPipelines(input: $input) {
    success
    jobId
    itemCount
    message
  }
}
    `;
export type ReassignIngestionFolderPipelinesMutationFn = Apollo.MutationFunction<Types.ReassignIngestionFolderPipelinesMutation, Types.ReassignIngestionFolderPipelinesMutationVariables>;

/**
 * __useReassignIngestionFolderPipelinesMutation__
 *
 * To run a mutation, you first call `useReassignIngestionFolderPipelinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReassignIngestionFolderPipelinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reassignIngestionFolderPipelinesMutation, { data, loading, error }] = useReassignIngestionFolderPipelinesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReassignIngestionFolderPipelinesMutation(baseOptions?: Apollo.MutationHookOptions<Types.ReassignIngestionFolderPipelinesMutation, Types.ReassignIngestionFolderPipelinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ReassignIngestionFolderPipelinesMutation, Types.ReassignIngestionFolderPipelinesMutationVariables>(ReassignIngestionFolderPipelinesDocument, options);
      }
export type ReassignIngestionFolderPipelinesMutationHookResult = ReturnType<typeof useReassignIngestionFolderPipelinesMutation>;
export type ReassignIngestionFolderPipelinesMutationResult = Apollo.MutationResult<Types.ReassignIngestionFolderPipelinesMutation>;
export type ReassignIngestionFolderPipelinesMutationOptions = Apollo.BaseMutationOptions<Types.ReassignIngestionFolderPipelinesMutation, Types.ReassignIngestionFolderPipelinesMutationVariables>;
export const RunIngestionDocumentValidationLlmAsJudgeDocument = gql`
    mutation RunIngestionDocumentValidationLlmAsJudge($input: RunIngestionDocumentValidationLlmAsJudgeInput!) {
  runIngestionDocumentValidationLlmAsJudge(input: $input) {
    llmAnalysis
    llmOutput
  }
}
    `;
export type RunIngestionDocumentValidationLlmAsJudgeMutationFn = Apollo.MutationFunction<Types.RunIngestionDocumentValidationLlmAsJudgeMutation, Types.RunIngestionDocumentValidationLlmAsJudgeMutationVariables>;

/**
 * __useRunIngestionDocumentValidationLlmAsJudgeMutation__
 *
 * To run a mutation, you first call `useRunIngestionDocumentValidationLlmAsJudgeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunIngestionDocumentValidationLlmAsJudgeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runIngestionDocumentValidationLlmAsJudgeMutation, { data, loading, error }] = useRunIngestionDocumentValidationLlmAsJudgeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunIngestionDocumentValidationLlmAsJudgeMutation(baseOptions?: Apollo.MutationHookOptions<Types.RunIngestionDocumentValidationLlmAsJudgeMutation, Types.RunIngestionDocumentValidationLlmAsJudgeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.RunIngestionDocumentValidationLlmAsJudgeMutation, Types.RunIngestionDocumentValidationLlmAsJudgeMutationVariables>(RunIngestionDocumentValidationLlmAsJudgeDocument, options);
      }
export type RunIngestionDocumentValidationLlmAsJudgeMutationHookResult = ReturnType<typeof useRunIngestionDocumentValidationLlmAsJudgeMutation>;
export type RunIngestionDocumentValidationLlmAsJudgeMutationResult = Apollo.MutationResult<Types.RunIngestionDocumentValidationLlmAsJudgeMutation>;
export type RunIngestionDocumentValidationLlmAsJudgeMutationOptions = Apollo.BaseMutationOptions<Types.RunIngestionDocumentValidationLlmAsJudgeMutation, Types.RunIngestionDocumentValidationLlmAsJudgeMutationVariables>;
export const SaveSignatureInitialDatasetDocument = gql`
    mutation SaveSignatureInitialDataset($input: SaveSignatureInitialDatasetInput!) {
  saveSignatureInitialDataset(input: $input)
}
    `;
export type SaveSignatureInitialDatasetMutationFn = Apollo.MutationFunction<Types.SaveSignatureInitialDatasetMutation, Types.SaveSignatureInitialDatasetMutationVariables>;

/**
 * __useSaveSignatureInitialDatasetMutation__
 *
 * To run a mutation, you first call `useSaveSignatureInitialDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSignatureInitialDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSignatureInitialDatasetMutation, { data, loading, error }] = useSaveSignatureInitialDatasetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSignatureInitialDatasetMutation(baseOptions?: Apollo.MutationHookOptions<Types.SaveSignatureInitialDatasetMutation, Types.SaveSignatureInitialDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SaveSignatureInitialDatasetMutation, Types.SaveSignatureInitialDatasetMutationVariables>(SaveSignatureInitialDatasetDocument, options);
      }
export type SaveSignatureInitialDatasetMutationHookResult = ReturnType<typeof useSaveSignatureInitialDatasetMutation>;
export type SaveSignatureInitialDatasetMutationResult = Apollo.MutationResult<Types.SaveSignatureInitialDatasetMutation>;
export type SaveSignatureInitialDatasetMutationOptions = Apollo.BaseMutationOptions<Types.SaveSignatureInitialDatasetMutation, Types.SaveSignatureInitialDatasetMutationVariables>;
export const SaveSignatureInitialValidationsDocument = gql`
    mutation SaveSignatureInitialValidations($input: SaveSignatureInitialDatasetInput!) {
  saveSignatureInitialValidations(input: $input)
}
    `;
export type SaveSignatureInitialValidationsMutationFn = Apollo.MutationFunction<Types.SaveSignatureInitialValidationsMutation, Types.SaveSignatureInitialValidationsMutationVariables>;

/**
 * __useSaveSignatureInitialValidationsMutation__
 *
 * To run a mutation, you first call `useSaveSignatureInitialValidationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSignatureInitialValidationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSignatureInitialValidationsMutation, { data, loading, error }] = useSaveSignatureInitialValidationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSignatureInitialValidationsMutation(baseOptions?: Apollo.MutationHookOptions<Types.SaveSignatureInitialValidationsMutation, Types.SaveSignatureInitialValidationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SaveSignatureInitialValidationsMutation, Types.SaveSignatureInitialValidationsMutationVariables>(SaveSignatureInitialValidationsDocument, options);
      }
export type SaveSignatureInitialValidationsMutationHookResult = ReturnType<typeof useSaveSignatureInitialValidationsMutation>;
export type SaveSignatureInitialValidationsMutationResult = Apollo.MutationResult<Types.SaveSignatureInitialValidationsMutation>;
export type SaveSignatureInitialValidationsMutationOptions = Apollo.BaseMutationOptions<Types.SaveSignatureInitialValidationsMutation, Types.SaveSignatureInitialValidationsMutationVariables>;
export const SetDocumentVersionAsActiveDocument = gql`
    mutation setDocumentVersionAsActive($input: SetDocumentVersionAsActiveInput!) {
  setDocumentVersionAsActive(input: $input) {
    documentVersion {
      id
      document {
        id
        documentVersions {
          id
          status
        }
      }
    }
  }
}
    `;
export type SetDocumentVersionAsActiveMutationFn = Apollo.MutationFunction<Types.SetDocumentVersionAsActiveMutation, Types.SetDocumentVersionAsActiveMutationVariables>;

/**
 * __useSetDocumentVersionAsActiveMutation__
 *
 * To run a mutation, you first call `useSetDocumentVersionAsActiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDocumentVersionAsActiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDocumentVersionAsActiveMutation, { data, loading, error }] = useSetDocumentVersionAsActiveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetDocumentVersionAsActiveMutation(baseOptions?: Apollo.MutationHookOptions<Types.SetDocumentVersionAsActiveMutation, Types.SetDocumentVersionAsActiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SetDocumentVersionAsActiveMutation, Types.SetDocumentVersionAsActiveMutationVariables>(SetDocumentVersionAsActiveDocument, options);
      }
export type SetDocumentVersionAsActiveMutationHookResult = ReturnType<typeof useSetDocumentVersionAsActiveMutation>;
export type SetDocumentVersionAsActiveMutationResult = Apollo.MutationResult<Types.SetDocumentVersionAsActiveMutation>;
export type SetDocumentVersionAsActiveMutationOptions = Apollo.BaseMutationOptions<Types.SetDocumentVersionAsActiveMutation, Types.SetDocumentVersionAsActiveMutationVariables>;
export const SyncAcroformToDocumentVersionFieldsDocument = gql`
    mutation syncAcroformToDocumentVersionFields($input: SyncAcroformToDocumentVersionFieldsInput!) {
  syncAcroformToDocumentVersionFields(input: $input) {
    documentVersion {
      id
      documentVersionFieldsCount
    }
  }
}
    `;
export type SyncAcroformToDocumentVersionFieldsMutationFn = Apollo.MutationFunction<Types.SyncAcroformToDocumentVersionFieldsMutation, Types.SyncAcroformToDocumentVersionFieldsMutationVariables>;

/**
 * __useSyncAcroformToDocumentVersionFieldsMutation__
 *
 * To run a mutation, you first call `useSyncAcroformToDocumentVersionFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncAcroformToDocumentVersionFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncAcroformToDocumentVersionFieldsMutation, { data, loading, error }] = useSyncAcroformToDocumentVersionFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncAcroformToDocumentVersionFieldsMutation(baseOptions?: Apollo.MutationHookOptions<Types.SyncAcroformToDocumentVersionFieldsMutation, Types.SyncAcroformToDocumentVersionFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SyncAcroformToDocumentVersionFieldsMutation, Types.SyncAcroformToDocumentVersionFieldsMutationVariables>(SyncAcroformToDocumentVersionFieldsDocument, options);
      }
export type SyncAcroformToDocumentVersionFieldsMutationHookResult = ReturnType<typeof useSyncAcroformToDocumentVersionFieldsMutation>;
export type SyncAcroformToDocumentVersionFieldsMutationResult = Apollo.MutationResult<Types.SyncAcroformToDocumentVersionFieldsMutation>;
export type SyncAcroformToDocumentVersionFieldsMutationOptions = Apollo.BaseMutationOptions<Types.SyncAcroformToDocumentVersionFieldsMutation, Types.SyncAcroformToDocumentVersionFieldsMutationVariables>;
export const SyncSecondaryDocumentVersionsDocument = gql`
    mutation syncSecondaryDocumentVersions($input: SyncSecondaryDocumentVersionsInput!) {
  syncSecondaryDocumentVersions(input: $input) {
    documentVersion {
      id
      secondaryDocumentVersions {
        ...SecondaryDocumentVersion
      }
    }
  }
}
    ${SecondaryDocumentVersionFragmentDoc}`;
export type SyncSecondaryDocumentVersionsMutationFn = Apollo.MutationFunction<Types.SyncSecondaryDocumentVersionsMutation, Types.SyncSecondaryDocumentVersionsMutationVariables>;

/**
 * __useSyncSecondaryDocumentVersionsMutation__
 *
 * To run a mutation, you first call `useSyncSecondaryDocumentVersionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncSecondaryDocumentVersionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncSecondaryDocumentVersionsMutation, { data, loading, error }] = useSyncSecondaryDocumentVersionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncSecondaryDocumentVersionsMutation(baseOptions?: Apollo.MutationHookOptions<Types.SyncSecondaryDocumentVersionsMutation, Types.SyncSecondaryDocumentVersionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SyncSecondaryDocumentVersionsMutation, Types.SyncSecondaryDocumentVersionsMutationVariables>(SyncSecondaryDocumentVersionsDocument, options);
      }
export type SyncSecondaryDocumentVersionsMutationHookResult = ReturnType<typeof useSyncSecondaryDocumentVersionsMutation>;
export type SyncSecondaryDocumentVersionsMutationResult = Apollo.MutationResult<Types.SyncSecondaryDocumentVersionsMutation>;
export type SyncSecondaryDocumentVersionsMutationOptions = Apollo.BaseMutationOptions<Types.SyncSecondaryDocumentVersionsMutation, Types.SyncSecondaryDocumentVersionsMutationVariables>;
export const SyncAllTransactionPipelinesToProductionDocument = gql`
    mutation syncAllTransactionPipelinesToProduction {
  syncAllTransactionPipelinesToProduction {
    success
    message
    workflowRunId
  }
}
    `;
export type SyncAllTransactionPipelinesToProductionMutationFn = Apollo.MutationFunction<Types.SyncAllTransactionPipelinesToProductionMutation, Types.SyncAllTransactionPipelinesToProductionMutationVariables>;

/**
 * __useSyncAllTransactionPipelinesToProductionMutation__
 *
 * To run a mutation, you first call `useSyncAllTransactionPipelinesToProductionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncAllTransactionPipelinesToProductionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncAllTransactionPipelinesToProductionMutation, { data, loading, error }] = useSyncAllTransactionPipelinesToProductionMutation({
 *   variables: {
 *   },
 * });
 */
export function useSyncAllTransactionPipelinesToProductionMutation(baseOptions?: Apollo.MutationHookOptions<Types.SyncAllTransactionPipelinesToProductionMutation, Types.SyncAllTransactionPipelinesToProductionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.SyncAllTransactionPipelinesToProductionMutation, Types.SyncAllTransactionPipelinesToProductionMutationVariables>(SyncAllTransactionPipelinesToProductionDocument, options);
      }
export type SyncAllTransactionPipelinesToProductionMutationHookResult = ReturnType<typeof useSyncAllTransactionPipelinesToProductionMutation>;
export type SyncAllTransactionPipelinesToProductionMutationResult = Apollo.MutationResult<Types.SyncAllTransactionPipelinesToProductionMutation>;
export type SyncAllTransactionPipelinesToProductionMutationOptions = Apollo.BaseMutationOptions<Types.SyncAllTransactionPipelinesToProductionMutation, Types.SyncAllTransactionPipelinesToProductionMutationVariables>;
export const TriggerBatchValidationRerunDocument = gql`
    mutation TriggerBatchValidationRerun($folderIds: [ID!]!, $recalculateStage: Boolean) {
  triggerBatchValidationRerun(
    folderIds: $folderIds
    recalculateStage: $recalculateStage
  ) {
    success
    queuedCount
    message
  }
}
    `;
export type TriggerBatchValidationRerunMutationFn = Apollo.MutationFunction<Types.TriggerBatchValidationRerunMutation, Types.TriggerBatchValidationRerunMutationVariables>;

/**
 * __useTriggerBatchValidationRerunMutation__
 *
 * To run a mutation, you first call `useTriggerBatchValidationRerunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerBatchValidationRerunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerBatchValidationRerunMutation, { data, loading, error }] = useTriggerBatchValidationRerunMutation({
 *   variables: {
 *      folderIds: // value for 'folderIds'
 *      recalculateStage: // value for 'recalculateStage'
 *   },
 * });
 */
export function useTriggerBatchValidationRerunMutation(baseOptions?: Apollo.MutationHookOptions<Types.TriggerBatchValidationRerunMutation, Types.TriggerBatchValidationRerunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.TriggerBatchValidationRerunMutation, Types.TriggerBatchValidationRerunMutationVariables>(TriggerBatchValidationRerunDocument, options);
      }
export type TriggerBatchValidationRerunMutationHookResult = ReturnType<typeof useTriggerBatchValidationRerunMutation>;
export type TriggerBatchValidationRerunMutationResult = Apollo.MutationResult<Types.TriggerBatchValidationRerunMutation>;
export type TriggerBatchValidationRerunMutationOptions = Apollo.BaseMutationOptions<Types.TriggerBatchValidationRerunMutation, Types.TriggerBatchValidationRerunMutationVariables>;
export const UpdateAutofillDocument = gql`
    mutation updateAutofill($input: UpdateAutofillInput!) {
  updateAutofill(input: $input) {
    autofill {
      ...Autofill
    }
  }
}
    ${AutofillFragmentDoc}`;
export type UpdateAutofillMutationFn = Apollo.MutationFunction<Types.UpdateAutofillMutation, Types.UpdateAutofillMutationVariables>;

/**
 * __useUpdateAutofillMutation__
 *
 * To run a mutation, you first call `useUpdateAutofillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAutofillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAutofillMutation, { data, loading, error }] = useUpdateAutofillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAutofillMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateAutofillMutation, Types.UpdateAutofillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateAutofillMutation, Types.UpdateAutofillMutationVariables>(UpdateAutofillDocument, options);
      }
export type UpdateAutofillMutationHookResult = ReturnType<typeof useUpdateAutofillMutation>;
export type UpdateAutofillMutationResult = Apollo.MutationResult<Types.UpdateAutofillMutation>;
export type UpdateAutofillMutationOptions = Apollo.BaseMutationOptions<Types.UpdateAutofillMutation, Types.UpdateAutofillMutationVariables>;
export const UpdateComplianceKeyTermSectionFieldsDocument = gql`
    mutation updateComplianceKeyTermSectionFields($input: UpdateComplianceKeyTermSectionFieldsInput!) {
  updateComplianceKeyTermSectionFields(input: $input) {
    complianceKeyTermSectionFields {
      id
      order
      helpText
      fieldsToColumn {
        ...FieldsToColumn
      }
    }
  }
}
    ${FieldsToColumnFragmentDoc}`;
export type UpdateComplianceKeyTermSectionFieldsMutationFn = Apollo.MutationFunction<Types.UpdateComplianceKeyTermSectionFieldsMutation, Types.UpdateComplianceKeyTermSectionFieldsMutationVariables>;

/**
 * __useUpdateComplianceKeyTermSectionFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateComplianceKeyTermSectionFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateComplianceKeyTermSectionFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateComplianceKeyTermSectionFieldsMutation, { data, loading, error }] = useUpdateComplianceKeyTermSectionFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateComplianceKeyTermSectionFieldsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateComplianceKeyTermSectionFieldsMutation, Types.UpdateComplianceKeyTermSectionFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateComplianceKeyTermSectionFieldsMutation, Types.UpdateComplianceKeyTermSectionFieldsMutationVariables>(UpdateComplianceKeyTermSectionFieldsDocument, options);
      }
export type UpdateComplianceKeyTermSectionFieldsMutationHookResult = ReturnType<typeof useUpdateComplianceKeyTermSectionFieldsMutation>;
export type UpdateComplianceKeyTermSectionFieldsMutationResult = Apollo.MutationResult<Types.UpdateComplianceKeyTermSectionFieldsMutation>;
export type UpdateComplianceKeyTermSectionFieldsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateComplianceKeyTermSectionFieldsMutation, Types.UpdateComplianceKeyTermSectionFieldsMutationVariables>;
export const UpdateComplianceKeyTermSectionsDocument = gql`
    mutation updateComplianceKeyTermSections($inputs: [UpdateComplianceKeyTermSectionInput!]!) {
  updateComplianceKeyTermSections(inputs: $inputs) {
    complianceKeyTermSections {
      ...ComplianceKeyTermSectionList
    }
  }
}
    ${ComplianceKeyTermSectionListFragmentDoc}`;
export type UpdateComplianceKeyTermSectionsMutationFn = Apollo.MutationFunction<Types.UpdateComplianceKeyTermSectionsMutation, Types.UpdateComplianceKeyTermSectionsMutationVariables>;

/**
 * __useUpdateComplianceKeyTermSectionsMutation__
 *
 * To run a mutation, you first call `useUpdateComplianceKeyTermSectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateComplianceKeyTermSectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateComplianceKeyTermSectionsMutation, { data, loading, error }] = useUpdateComplianceKeyTermSectionsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateComplianceKeyTermSectionsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateComplianceKeyTermSectionsMutation, Types.UpdateComplianceKeyTermSectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateComplianceKeyTermSectionsMutation, Types.UpdateComplianceKeyTermSectionsMutationVariables>(UpdateComplianceKeyTermSectionsDocument, options);
      }
export type UpdateComplianceKeyTermSectionsMutationHookResult = ReturnType<typeof useUpdateComplianceKeyTermSectionsMutation>;
export type UpdateComplianceKeyTermSectionsMutationResult = Apollo.MutationResult<Types.UpdateComplianceKeyTermSectionsMutation>;
export type UpdateComplianceKeyTermSectionsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateComplianceKeyTermSectionsMutation, Types.UpdateComplianceKeyTermSectionsMutationVariables>;
export const UpdateComplianceKeyTermSectionsOrderDocument = gql`
    mutation updateComplianceKeyTermSectionsOrder($inputs: [UpdateComplianceKeyTermSectionsOrderInput!]!) {
  updateComplianceKeyTermSectionsOrder(inputs: $inputs) {
    complianceKeyTermSections {
      ...ComplianceKeyTermSectionList
    }
  }
}
    ${ComplianceKeyTermSectionListFragmentDoc}`;
export type UpdateComplianceKeyTermSectionsOrderMutationFn = Apollo.MutationFunction<Types.UpdateComplianceKeyTermSectionsOrderMutation, Types.UpdateComplianceKeyTermSectionsOrderMutationVariables>;

/**
 * __useUpdateComplianceKeyTermSectionsOrderMutation__
 *
 * To run a mutation, you first call `useUpdateComplianceKeyTermSectionsOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateComplianceKeyTermSectionsOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateComplianceKeyTermSectionsOrderMutation, { data, loading, error }] = useUpdateComplianceKeyTermSectionsOrderMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateComplianceKeyTermSectionsOrderMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateComplianceKeyTermSectionsOrderMutation, Types.UpdateComplianceKeyTermSectionsOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateComplianceKeyTermSectionsOrderMutation, Types.UpdateComplianceKeyTermSectionsOrderMutationVariables>(UpdateComplianceKeyTermSectionsOrderDocument, options);
      }
export type UpdateComplianceKeyTermSectionsOrderMutationHookResult = ReturnType<typeof useUpdateComplianceKeyTermSectionsOrderMutation>;
export type UpdateComplianceKeyTermSectionsOrderMutationResult = Apollo.MutationResult<Types.UpdateComplianceKeyTermSectionsOrderMutation>;
export type UpdateComplianceKeyTermSectionsOrderMutationOptions = Apollo.BaseMutationOptions<Types.UpdateComplianceKeyTermSectionsOrderMutation, Types.UpdateComplianceKeyTermSectionsOrderMutationVariables>;
export const UpdateContractDocument = gql`
    mutation updateContract($input: UpdateContractInput!) {
  updateContract(input: $input) {
    contract {
      id
      fieldValues
    }
  }
}
    `;
export type UpdateContractMutationFn = Apollo.MutationFunction<Types.UpdateContractMutation, Types.UpdateContractMutationVariables>;

/**
 * __useUpdateContractMutation__
 *
 * To run a mutation, you first call `useUpdateContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractMutation, { data, loading, error }] = useUpdateContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContractMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateContractMutation, Types.UpdateContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateContractMutation, Types.UpdateContractMutationVariables>(UpdateContractDocument, options);
      }
export type UpdateContractMutationHookResult = ReturnType<typeof useUpdateContractMutation>;
export type UpdateContractMutationResult = Apollo.MutationResult<Types.UpdateContractMutation>;
export type UpdateContractMutationOptions = Apollo.BaseMutationOptions<Types.UpdateContractMutation, Types.UpdateContractMutationVariables>;
export const UpdateContractDocumentCustomFieldsDocument = gql`
    mutation UpdateContractDocumentCustomFields($input: UpdateContractDocumentCustomFieldsInput!) {
  updateContractDocumentCustomFields(input: $input) {
    id
    fields {
      ...DocumentVersionField
    }
  }
}
    ${DocumentVersionFieldFragmentDoc}`;
export type UpdateContractDocumentCustomFieldsMutationFn = Apollo.MutationFunction<Types.UpdateContractDocumentCustomFieldsMutation, Types.UpdateContractDocumentCustomFieldsMutationVariables>;

/**
 * __useUpdateContractDocumentCustomFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateContractDocumentCustomFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractDocumentCustomFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractDocumentCustomFieldsMutation, { data, loading, error }] = useUpdateContractDocumentCustomFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContractDocumentCustomFieldsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateContractDocumentCustomFieldsMutation, Types.UpdateContractDocumentCustomFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateContractDocumentCustomFieldsMutation, Types.UpdateContractDocumentCustomFieldsMutationVariables>(UpdateContractDocumentCustomFieldsDocument, options);
      }
export type UpdateContractDocumentCustomFieldsMutationHookResult = ReturnType<typeof useUpdateContractDocumentCustomFieldsMutation>;
export type UpdateContractDocumentCustomFieldsMutationResult = Apollo.MutationResult<Types.UpdateContractDocumentCustomFieldsMutation>;
export type UpdateContractDocumentCustomFieldsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateContractDocumentCustomFieldsMutation, Types.UpdateContractDocumentCustomFieldsMutationVariables>;
export const UpdateContractDocumentsDocument = gql`
    mutation updateContractDocuments($input: UpdateContractDocumentsInput!) {
  updateContractDocuments(input: $input) {
    contract {
      id
      contractDocuments {
        ...ContractDocumentForContract
      }
    }
  }
}
    ${ContractDocumentForContractFragmentDoc}`;
export type UpdateContractDocumentsMutationFn = Apollo.MutationFunction<Types.UpdateContractDocumentsMutation, Types.UpdateContractDocumentsMutationVariables>;

/**
 * __useUpdateContractDocumentsMutation__
 *
 * To run a mutation, you first call `useUpdateContractDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractDocumentsMutation, { data, loading, error }] = useUpdateContractDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContractDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateContractDocumentsMutation, Types.UpdateContractDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateContractDocumentsMutation, Types.UpdateContractDocumentsMutationVariables>(UpdateContractDocumentsDocument, options);
      }
export type UpdateContractDocumentsMutationHookResult = ReturnType<typeof useUpdateContractDocumentsMutation>;
export type UpdateContractDocumentsMutationResult = Apollo.MutationResult<Types.UpdateContractDocumentsMutation>;
export type UpdateContractDocumentsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateContractDocumentsMutation, Types.UpdateContractDocumentsMutationVariables>;
export const UpdateDefaultSecondaryDocumentsDocument = gql`
    mutation updateDefaultSecondaryDocuments($input: [UpdateDefaultSecondaryDocumentInput!]!) {
  updateDefaultSecondaryDocuments(input: $input) {
    defaultSecondaryDocuments {
      ...DefaultSecondaryDocument
    }
  }
}
    ${DefaultSecondaryDocumentFragmentDoc}`;
export type UpdateDefaultSecondaryDocumentsMutationFn = Apollo.MutationFunction<Types.UpdateDefaultSecondaryDocumentsMutation, Types.UpdateDefaultSecondaryDocumentsMutationVariables>;

/**
 * __useUpdateDefaultSecondaryDocumentsMutation__
 *
 * To run a mutation, you first call `useUpdateDefaultSecondaryDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDefaultSecondaryDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDefaultSecondaryDocumentsMutation, { data, loading, error }] = useUpdateDefaultSecondaryDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDefaultSecondaryDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateDefaultSecondaryDocumentsMutation, Types.UpdateDefaultSecondaryDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateDefaultSecondaryDocumentsMutation, Types.UpdateDefaultSecondaryDocumentsMutationVariables>(UpdateDefaultSecondaryDocumentsDocument, options);
      }
export type UpdateDefaultSecondaryDocumentsMutationHookResult = ReturnType<typeof useUpdateDefaultSecondaryDocumentsMutation>;
export type UpdateDefaultSecondaryDocumentsMutationResult = Apollo.MutationResult<Types.UpdateDefaultSecondaryDocumentsMutation>;
export type UpdateDefaultSecondaryDocumentsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateDefaultSecondaryDocumentsMutation, Types.UpdateDefaultSecondaryDocumentsMutationVariables>;
export const UpdateDocumentDocument = gql`
    mutation updateDocument($input: UpdateDocumentInput!) {
  updateDocument(input: $input) {
    document {
      ...Document
      subsetOfDocument {
        id
        name
        form
        usState
      }
    }
  }
}
    ${DocumentFragmentDoc}`;
export type UpdateDocumentMutationFn = Apollo.MutationFunction<Types.UpdateDocumentMutation, Types.UpdateDocumentMutationVariables>;

/**
 * __useUpdateDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentMutation, { data, loading, error }] = useUpdateDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateDocumentMutation, Types.UpdateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateDocumentMutation, Types.UpdateDocumentMutationVariables>(UpdateDocumentDocument, options);
      }
export type UpdateDocumentMutationHookResult = ReturnType<typeof useUpdateDocumentMutation>;
export type UpdateDocumentMutationResult = Apollo.MutationResult<Types.UpdateDocumentMutation>;
export type UpdateDocumentMutationOptions = Apollo.BaseMutationOptions<Types.UpdateDocumentMutation, Types.UpdateDocumentMutationVariables>;
export const UpdateDocumentLlmDocument = gql`
    mutation UpdateDocumentLLM($id: ID!, $input: DocumentLLMInput!, $isDetail: Boolean! = true) {
  updateDocumentLLM(id: $id, input: $input) {
    ...DocumentLLM
  }
}
    ${DocumentLlmFragmentDoc}`;
export type UpdateDocumentLlmMutationFn = Apollo.MutationFunction<Types.UpdateDocumentLlmMutation, Types.UpdateDocumentLlmMutationVariables>;

/**
 * __useUpdateDocumentLlmMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentLlmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentLlmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentLlmMutation, { data, loading, error }] = useUpdateDocumentLlmMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      isDetail: // value for 'isDetail'
 *   },
 * });
 */
export function useUpdateDocumentLlmMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateDocumentLlmMutation, Types.UpdateDocumentLlmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateDocumentLlmMutation, Types.UpdateDocumentLlmMutationVariables>(UpdateDocumentLlmDocument, options);
      }
export type UpdateDocumentLlmMutationHookResult = ReturnType<typeof useUpdateDocumentLlmMutation>;
export type UpdateDocumentLlmMutationResult = Apollo.MutationResult<Types.UpdateDocumentLlmMutation>;
export type UpdateDocumentLlmMutationOptions = Apollo.BaseMutationOptions<Types.UpdateDocumentLlmMutation, Types.UpdateDocumentLlmMutationVariables>;
export const UpdateDocumentSectionFieldsDocument = gql`
    mutation updateDocumentSectionFields($input: UpdateDocumentSectionFieldsInput!) {
  updateDocumentSectionFields(input: $input) {
    documentSectionFields {
      id
    }
  }
}
    `;
export type UpdateDocumentSectionFieldsMutationFn = Apollo.MutationFunction<Types.UpdateDocumentSectionFieldsMutation, Types.UpdateDocumentSectionFieldsMutationVariables>;

/**
 * __useUpdateDocumentSectionFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentSectionFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentSectionFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentSectionFieldsMutation, { data, loading, error }] = useUpdateDocumentSectionFieldsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentSectionFieldsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateDocumentSectionFieldsMutation, Types.UpdateDocumentSectionFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateDocumentSectionFieldsMutation, Types.UpdateDocumentSectionFieldsMutationVariables>(UpdateDocumentSectionFieldsDocument, options);
      }
export type UpdateDocumentSectionFieldsMutationHookResult = ReturnType<typeof useUpdateDocumentSectionFieldsMutation>;
export type UpdateDocumentSectionFieldsMutationResult = Apollo.MutationResult<Types.UpdateDocumentSectionFieldsMutation>;
export type UpdateDocumentSectionFieldsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateDocumentSectionFieldsMutation, Types.UpdateDocumentSectionFieldsMutationVariables>;
export const UpdateDocumentSectionsDocument = gql`
    mutation updateDocumentSections($inputs: [UpdateDocumentSectionInput!]!) {
  updateDocumentSections(inputs: $inputs) {
    documentSections {
      ...DocumentSectionList
    }
  }
}
    ${DocumentSectionListFragmentDoc}`;
export type UpdateDocumentSectionsMutationFn = Apollo.MutationFunction<Types.UpdateDocumentSectionsMutation, Types.UpdateDocumentSectionsMutationVariables>;

/**
 * __useUpdateDocumentSectionsMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentSectionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentSectionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentSectionsMutation, { data, loading, error }] = useUpdateDocumentSectionsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateDocumentSectionsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateDocumentSectionsMutation, Types.UpdateDocumentSectionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateDocumentSectionsMutation, Types.UpdateDocumentSectionsMutationVariables>(UpdateDocumentSectionsDocument, options);
      }
export type UpdateDocumentSectionsMutationHookResult = ReturnType<typeof useUpdateDocumentSectionsMutation>;
export type UpdateDocumentSectionsMutationResult = Apollo.MutationResult<Types.UpdateDocumentSectionsMutation>;
export type UpdateDocumentSectionsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateDocumentSectionsMutation, Types.UpdateDocumentSectionsMutationVariables>;
export const UpdateDocumentSectionsOrderDocument = gql`
    mutation updateDocumentSectionsOrder($inputs: [UpdateDocumentSectionsOrderInput!]!) {
  updateDocumentSectionsOrder(inputs: $inputs) {
    documentSections {
      id
    }
  }
}
    `;
export type UpdateDocumentSectionsOrderMutationFn = Apollo.MutationFunction<Types.UpdateDocumentSectionsOrderMutation, Types.UpdateDocumentSectionsOrderMutationVariables>;

/**
 * __useUpdateDocumentSectionsOrderMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentSectionsOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentSectionsOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentSectionsOrderMutation, { data, loading, error }] = useUpdateDocumentSectionsOrderMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateDocumentSectionsOrderMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateDocumentSectionsOrderMutation, Types.UpdateDocumentSectionsOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateDocumentSectionsOrderMutation, Types.UpdateDocumentSectionsOrderMutationVariables>(UpdateDocumentSectionsOrderDocument, options);
      }
export type UpdateDocumentSectionsOrderMutationHookResult = ReturnType<typeof useUpdateDocumentSectionsOrderMutation>;
export type UpdateDocumentSectionsOrderMutationResult = Apollo.MutationResult<Types.UpdateDocumentSectionsOrderMutation>;
export type UpdateDocumentSectionsOrderMutationOptions = Apollo.BaseMutationOptions<Types.UpdateDocumentSectionsOrderMutation, Types.UpdateDocumentSectionsOrderMutationVariables>;
export const UpdateDocumentVersionDocument = gql`
    mutation updateDocumentVersion($id: ID!, $input: UpdateDocumentVersionInput!) {
  updateDocumentVersion(id: $id, input: $input) {
    documentVersion {
      id
      version
      searchRegex
      file {
        fileName
        url
      }
    }
  }
}
    `;
export type UpdateDocumentVersionMutationFn = Apollo.MutationFunction<Types.UpdateDocumentVersionMutation, Types.UpdateDocumentVersionMutationVariables>;

/**
 * __useUpdateDocumentVersionMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentVersionMutation, { data, loading, error }] = useUpdateDocumentVersionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentVersionMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateDocumentVersionMutation, Types.UpdateDocumentVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateDocumentVersionMutation, Types.UpdateDocumentVersionMutationVariables>(UpdateDocumentVersionDocument, options);
      }
export type UpdateDocumentVersionMutationHookResult = ReturnType<typeof useUpdateDocumentVersionMutation>;
export type UpdateDocumentVersionMutationResult = Apollo.MutationResult<Types.UpdateDocumentVersionMutation>;
export type UpdateDocumentVersionMutationOptions = Apollo.BaseMutationOptions<Types.UpdateDocumentVersionMutation, Types.UpdateDocumentVersionMutationVariables>;
export const UpdateDocumentVersionFieldsDocument = gql`
    mutation updateDocumentVersionFields($inputs: [UpdateDocumentVersionFieldInput!]!) {
  updateDocumentVersionFields(inputs: $inputs) {
    documentVersionFields {
      ...DocumentVersionField
      field {
        ...Field
      }
    }
  }
}
    ${DocumentVersionFieldFragmentDoc}
${FieldFragmentDoc}`;
export type UpdateDocumentVersionFieldsMutationFn = Apollo.MutationFunction<Types.UpdateDocumentVersionFieldsMutation, Types.UpdateDocumentVersionFieldsMutationVariables>;

/**
 * __useUpdateDocumentVersionFieldsMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentVersionFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentVersionFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentVersionFieldsMutation, { data, loading, error }] = useUpdateDocumentVersionFieldsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateDocumentVersionFieldsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateDocumentVersionFieldsMutation, Types.UpdateDocumentVersionFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateDocumentVersionFieldsMutation, Types.UpdateDocumentVersionFieldsMutationVariables>(UpdateDocumentVersionFieldsDocument, options);
      }
export type UpdateDocumentVersionFieldsMutationHookResult = ReturnType<typeof useUpdateDocumentVersionFieldsMutation>;
export type UpdateDocumentVersionFieldsMutationResult = Apollo.MutationResult<Types.UpdateDocumentVersionFieldsMutation>;
export type UpdateDocumentVersionFieldsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateDocumentVersionFieldsMutation, Types.UpdateDocumentVersionFieldsMutationVariables>;
export const UpdateFieldDocument = gql`
    mutation updateField($input: UpdateFieldInput!) {
  updateField(input: $input) {
    field {
      ...Field
      ...FieldDetail
    }
  }
}
    ${FieldFragmentDoc}
${FieldDetailFragmentDoc}`;
export type UpdateFieldMutationFn = Apollo.MutationFunction<Types.UpdateFieldMutation, Types.UpdateFieldMutationVariables>;

/**
 * __useUpdateFieldMutation__
 *
 * To run a mutation, you first call `useUpdateFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFieldMutation, { data, loading, error }] = useUpdateFieldMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateFieldMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateFieldMutation, Types.UpdateFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateFieldMutation, Types.UpdateFieldMutationVariables>(UpdateFieldDocument, options);
      }
export type UpdateFieldMutationHookResult = ReturnType<typeof useUpdateFieldMutation>;
export type UpdateFieldMutationResult = Apollo.MutationResult<Types.UpdateFieldMutation>;
export type UpdateFieldMutationOptions = Apollo.BaseMutationOptions<Types.UpdateFieldMutation, Types.UpdateFieldMutationVariables>;
export const UpdateOrCreateFieldsToColumnDocument = gql`
    mutation updateOrCreateFieldsToColumn($input: UpdateOrCreateFieldsToColumnInput!) {
  updateOrCreateFieldsToColumn(input: $input) {
    ...FieldsToColumn
  }
}
    ${FieldsToColumnFragmentDoc}`;
export type UpdateOrCreateFieldsToColumnMutationFn = Apollo.MutationFunction<Types.UpdateOrCreateFieldsToColumnMutation, Types.UpdateOrCreateFieldsToColumnMutationVariables>;

/**
 * __useUpdateOrCreateFieldsToColumnMutation__
 *
 * To run a mutation, you first call `useUpdateOrCreateFieldsToColumnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrCreateFieldsToColumnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrCreateFieldsToColumnMutation, { data, loading, error }] = useUpdateOrCreateFieldsToColumnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrCreateFieldsToColumnMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrCreateFieldsToColumnMutation, Types.UpdateOrCreateFieldsToColumnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrCreateFieldsToColumnMutation, Types.UpdateOrCreateFieldsToColumnMutationVariables>(UpdateOrCreateFieldsToColumnDocument, options);
      }
export type UpdateOrCreateFieldsToColumnMutationHookResult = ReturnType<typeof useUpdateOrCreateFieldsToColumnMutation>;
export type UpdateOrCreateFieldsToColumnMutationResult = Apollo.MutationResult<Types.UpdateOrCreateFieldsToColumnMutation>;
export type UpdateOrCreateFieldsToColumnMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrCreateFieldsToColumnMutation, Types.UpdateOrCreateFieldsToColumnMutationVariables>;
export const UpdateOrCreateTransactionRuleDocument = gql`
    mutation updateOrCreateTransactionRule($input: UpdateOrCreateTransactionRuleInput!) {
  updateOrCreateTransactionRule(input: $input) {
    id
    targetDocumentCategory
    targetDocument {
      id
      name
      documentCategory
    }
    stageRequirementTransactionStage {
      id
      stage
      sortOrder
    }
    validationTransactionStage {
      id
      stage
      sortOrder
    }
    rules {
      id
      message
      ruleType
    }
    isRequiredDocument
  }
}
    `;
export type UpdateOrCreateTransactionRuleMutationFn = Apollo.MutationFunction<Types.UpdateOrCreateTransactionRuleMutation, Types.UpdateOrCreateTransactionRuleMutationVariables>;

/**
 * __useUpdateOrCreateTransactionRuleMutation__
 *
 * To run a mutation, you first call `useUpdateOrCreateTransactionRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrCreateTransactionRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrCreateTransactionRuleMutation, { data, loading, error }] = useUpdateOrCreateTransactionRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrCreateTransactionRuleMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrCreateTransactionRuleMutation, Types.UpdateOrCreateTransactionRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrCreateTransactionRuleMutation, Types.UpdateOrCreateTransactionRuleMutationVariables>(UpdateOrCreateTransactionRuleDocument, options);
      }
export type UpdateOrCreateTransactionRuleMutationHookResult = ReturnType<typeof useUpdateOrCreateTransactionRuleMutation>;
export type UpdateOrCreateTransactionRuleMutationResult = Apollo.MutationResult<Types.UpdateOrCreateTransactionRuleMutation>;
export type UpdateOrCreateTransactionRuleMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrCreateTransactionRuleMutation, Types.UpdateOrCreateTransactionRuleMutationVariables>;
export const UpdateOrCreateTransactionStageDocument = gql`
    mutation updateOrCreateTransactionStage($input: UpdateOrCreateTransactionStageInput!) {
  updateOrCreateTransactionStage(input: $input) {
    id
    stage
    sortOrder
    transactionPipeline {
      id
      clientType
      usState
      transactionPropertyType
    }
  }
}
    `;
export type UpdateOrCreateTransactionStageMutationFn = Apollo.MutationFunction<Types.UpdateOrCreateTransactionStageMutation, Types.UpdateOrCreateTransactionStageMutationVariables>;

/**
 * __useUpdateOrCreateTransactionStageMutation__
 *
 * To run a mutation, you first call `useUpdateOrCreateTransactionStageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrCreateTransactionStageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrCreateTransactionStageMutation, { data, loading, error }] = useUpdateOrCreateTransactionStageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrCreateTransactionStageMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrCreateTransactionStageMutation, Types.UpdateOrCreateTransactionStageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrCreateTransactionStageMutation, Types.UpdateOrCreateTransactionStageMutationVariables>(UpdateOrCreateTransactionStageDocument, options);
      }
export type UpdateOrCreateTransactionStageMutationHookResult = ReturnType<typeof useUpdateOrCreateTransactionStageMutation>;
export type UpdateOrCreateTransactionStageMutationResult = Apollo.MutationResult<Types.UpdateOrCreateTransactionStageMutation>;
export type UpdateOrCreateTransactionStageMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrCreateTransactionStageMutation, Types.UpdateOrCreateTransactionStageMutationVariables>;
export const UpdateOrganizationValidationSettingsDocument = gql`
    mutation updateOrganizationValidationSettings($input: UpdateOrganizationValidationSettingsInput!) {
  updateOrganizationValidationSettings(input: $input) {
    stageIgnoredRuleIds
    documentIgnoredRuleIds
  }
}
    `;
export type UpdateOrganizationValidationSettingsMutationFn = Apollo.MutationFunction<Types.UpdateOrganizationValidationSettingsMutation, Types.UpdateOrganizationValidationSettingsMutationVariables>;

/**
 * __useUpdateOrganizationValidationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationValidationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationValidationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationValidationSettingsMutation, { data, loading, error }] = useUpdateOrganizationValidationSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationValidationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateOrganizationValidationSettingsMutation, Types.UpdateOrganizationValidationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateOrganizationValidationSettingsMutation, Types.UpdateOrganizationValidationSettingsMutationVariables>(UpdateOrganizationValidationSettingsDocument, options);
      }
export type UpdateOrganizationValidationSettingsMutationHookResult = ReturnType<typeof useUpdateOrganizationValidationSettingsMutation>;
export type UpdateOrganizationValidationSettingsMutationResult = Apollo.MutationResult<Types.UpdateOrganizationValidationSettingsMutation>;
export type UpdateOrganizationValidationSettingsMutationOptions = Apollo.BaseMutationOptions<Types.UpdateOrganizationValidationSettingsMutation, Types.UpdateOrganizationValidationSettingsMutationVariables>;
export const UpdateRuleDocument = gql`
    mutation updateRule($input: UpdateRuleInput!) {
  updateRule(input: $input) {
    rule {
      ...Rule
    }
  }
}
    ${RuleFragmentDoc}`;
export type UpdateRuleMutationFn = Apollo.MutationFunction<Types.UpdateRuleMutation, Types.UpdateRuleMutationVariables>;

/**
 * __useUpdateRuleMutation__
 *
 * To run a mutation, you first call `useUpdateRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRuleMutation, { data, loading, error }] = useUpdateRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRuleMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateRuleMutation, Types.UpdateRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateRuleMutation, Types.UpdateRuleMutationVariables>(UpdateRuleDocument, options);
      }
export type UpdateRuleMutationHookResult = ReturnType<typeof useUpdateRuleMutation>;
export type UpdateRuleMutationResult = Apollo.MutationResult<Types.UpdateRuleMutation>;
export type UpdateRuleMutationOptions = Apollo.BaseMutationOptions<Types.UpdateRuleMutation, Types.UpdateRuleMutationVariables>;
export const UpdateRulesForTransactionRuleDocument = gql`
    mutation UpdateRulesForTransactionRule($input: UpdateRulesForTransactionRuleInput!) {
  updateRulesForTransactionRule(input: $input) {
    id
    rules {
      id
      message
      ruleType
    }
  }
}
    `;
export type UpdateRulesForTransactionRuleMutationFn = Apollo.MutationFunction<Types.UpdateRulesForTransactionRuleMutation, Types.UpdateRulesForTransactionRuleMutationVariables>;

/**
 * __useUpdateRulesForTransactionRuleMutation__
 *
 * To run a mutation, you first call `useUpdateRulesForTransactionRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRulesForTransactionRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRulesForTransactionRuleMutation, { data, loading, error }] = useUpdateRulesForTransactionRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRulesForTransactionRuleMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateRulesForTransactionRuleMutation, Types.UpdateRulesForTransactionRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateRulesForTransactionRuleMutation, Types.UpdateRulesForTransactionRuleMutationVariables>(UpdateRulesForTransactionRuleDocument, options);
      }
export type UpdateRulesForTransactionRuleMutationHookResult = ReturnType<typeof useUpdateRulesForTransactionRuleMutation>;
export type UpdateRulesForTransactionRuleMutationResult = Apollo.MutationResult<Types.UpdateRulesForTransactionRuleMutation>;
export type UpdateRulesForTransactionRuleMutationOptions = Apollo.BaseMutationOptions<Types.UpdateRulesForTransactionRuleMutation, Types.UpdateRulesForTransactionRuleMutationVariables>;
export const UpdateSecondaryDocumentVersionDocument = gql`
    mutation updateSecondaryDocumentVersion($input: UpdateSecondaryDocumentVersionInput!) {
  updateSecondaryDocumentVersion(input: $input) {
    secondaryDocumentVersion {
      ...SecondaryDocumentVersion
    }
  }
}
    ${SecondaryDocumentVersionFragmentDoc}`;
export type UpdateSecondaryDocumentVersionMutationFn = Apollo.MutationFunction<Types.UpdateSecondaryDocumentVersionMutation, Types.UpdateSecondaryDocumentVersionMutationVariables>;

/**
 * __useUpdateSecondaryDocumentVersionMutation__
 *
 * To run a mutation, you first call `useUpdateSecondaryDocumentVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSecondaryDocumentVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSecondaryDocumentVersionMutation, { data, loading, error }] = useUpdateSecondaryDocumentVersionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSecondaryDocumentVersionMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateSecondaryDocumentVersionMutation, Types.UpdateSecondaryDocumentVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateSecondaryDocumentVersionMutation, Types.UpdateSecondaryDocumentVersionMutationVariables>(UpdateSecondaryDocumentVersionDocument, options);
      }
export type UpdateSecondaryDocumentVersionMutationHookResult = ReturnType<typeof useUpdateSecondaryDocumentVersionMutation>;
export type UpdateSecondaryDocumentVersionMutationResult = Apollo.MutationResult<Types.UpdateSecondaryDocumentVersionMutation>;
export type UpdateSecondaryDocumentVersionMutationOptions = Apollo.BaseMutationOptions<Types.UpdateSecondaryDocumentVersionMutation, Types.UpdateSecondaryDocumentVersionMutationVariables>;
export const UpdateSignatureInitialsDatasetDocument = gql`
    mutation UpdateSignatureInitialsDataset($input: UpdateSignatureInitialsDatasetInput!) {
  updateSignatureInitialsDataset(input: $input) {
    success
    key
  }
}
    `;
export type UpdateSignatureInitialsDatasetMutationFn = Apollo.MutationFunction<Types.UpdateSignatureInitialsDatasetMutation, Types.UpdateSignatureInitialsDatasetMutationVariables>;

/**
 * __useUpdateSignatureInitialsDatasetMutation__
 *
 * To run a mutation, you first call `useUpdateSignatureInitialsDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSignatureInitialsDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSignatureInitialsDatasetMutation, { data, loading, error }] = useUpdateSignatureInitialsDatasetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSignatureInitialsDatasetMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateSignatureInitialsDatasetMutation, Types.UpdateSignatureInitialsDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateSignatureInitialsDatasetMutation, Types.UpdateSignatureInitialsDatasetMutationVariables>(UpdateSignatureInitialsDatasetDocument, options);
      }
export type UpdateSignatureInitialsDatasetMutationHookResult = ReturnType<typeof useUpdateSignatureInitialsDatasetMutation>;
export type UpdateSignatureInitialsDatasetMutationResult = Apollo.MutationResult<Types.UpdateSignatureInitialsDatasetMutation>;
export type UpdateSignatureInitialsDatasetMutationOptions = Apollo.BaseMutationOptions<Types.UpdateSignatureInitialsDatasetMutation, Types.UpdateSignatureInitialsDatasetMutationVariables>;
export const UpdateSortOrderDocument = gql`
    mutation updateSortOrder($inputs: [UpdateSortOrderInput!]!) {
  updateSortOrder(inputs: $inputs) {
    id
    stage
    sortOrder
    transactionPipeline {
      id
      clientType
      usState
      transactionPropertyType
    }
  }
}
    `;
export type UpdateSortOrderMutationFn = Apollo.MutationFunction<Types.UpdateSortOrderMutation, Types.UpdateSortOrderMutationVariables>;

/**
 * __useUpdateSortOrderMutation__
 *
 * To run a mutation, you first call `useUpdateSortOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSortOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSortOrderMutation, { data, loading, error }] = useUpdateSortOrderMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useUpdateSortOrderMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateSortOrderMutation, Types.UpdateSortOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateSortOrderMutation, Types.UpdateSortOrderMutationVariables>(UpdateSortOrderDocument, options);
      }
export type UpdateSortOrderMutationHookResult = ReturnType<typeof useUpdateSortOrderMutation>;
export type UpdateSortOrderMutationResult = Apollo.MutationResult<Types.UpdateSortOrderMutation>;
export type UpdateSortOrderMutationOptions = Apollo.BaseMutationOptions<Types.UpdateSortOrderMutation, Types.UpdateSortOrderMutationVariables>;
export const UpdateTransactionRuleParentDocument = gql`
    mutation updateTransactionRuleParent($input: UpdateTransactionRuleParentInput!) {
  updateTransactionRuleParent(input: $input) {
    ...TransactionRule
  }
}
    ${TransactionRuleFragmentDoc}`;
export type UpdateTransactionRuleParentMutationFn = Apollo.MutationFunction<Types.UpdateTransactionRuleParentMutation, Types.UpdateTransactionRuleParentMutationVariables>;

/**
 * __useUpdateTransactionRuleParentMutation__
 *
 * To run a mutation, you first call `useUpdateTransactionRuleParentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTransactionRuleParentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTransactionRuleParentMutation, { data, loading, error }] = useUpdateTransactionRuleParentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTransactionRuleParentMutation(baseOptions?: Apollo.MutationHookOptions<Types.UpdateTransactionRuleParentMutation, Types.UpdateTransactionRuleParentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.UpdateTransactionRuleParentMutation, Types.UpdateTransactionRuleParentMutationVariables>(UpdateTransactionRuleParentDocument, options);
      }
export type UpdateTransactionRuleParentMutationHookResult = ReturnType<typeof useUpdateTransactionRuleParentMutation>;
export type UpdateTransactionRuleParentMutationResult = Apollo.MutationResult<Types.UpdateTransactionRuleParentMutation>;
export type UpdateTransactionRuleParentMutationOptions = Apollo.BaseMutationOptions<Types.UpdateTransactionRuleParentMutation, Types.UpdateTransactionRuleParentMutationVariables>;
export const ValidateTransactionPipelineDocument = gql`
    mutation ValidateTransactionPipeline($input: ValidateTransactionPipelineInput!) {
  validateTransactionPipeline(input: $input) {
    documentValidations {
      contractDocumentId
      documentVersionId
      documentName
      documentForm
      documentCategory
      ingestionDocumentId
      validations {
        field {
          id
          label
          mappingKey
          fieldType
          displayLabel
        }
        documentVersionField {
          id
          fieldType
          displayLabel
          label
          mappingKey
          pageNumber
          x
          y
          width
          height
        }
        results {
          ...GenericRuleValidation
        }
      }
    }
    pipelineValidations {
      ...PipelineValidationResult
    }
  }
}
    ${GenericRuleValidationFragmentDoc}
${PipelineValidationResultFragmentDoc}`;
export type ValidateTransactionPipelineMutationFn = Apollo.MutationFunction<Types.ValidateTransactionPipelineMutation, Types.ValidateTransactionPipelineMutationVariables>;

/**
 * __useValidateTransactionPipelineMutation__
 *
 * To run a mutation, you first call `useValidateTransactionPipelineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateTransactionPipelineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateTransactionPipelineMutation, { data, loading, error }] = useValidateTransactionPipelineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateTransactionPipelineMutation(baseOptions?: Apollo.MutationHookOptions<Types.ValidateTransactionPipelineMutation, Types.ValidateTransactionPipelineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ValidateTransactionPipelineMutation, Types.ValidateTransactionPipelineMutationVariables>(ValidateTransactionPipelineDocument, options);
      }
export type ValidateTransactionPipelineMutationHookResult = ReturnType<typeof useValidateTransactionPipelineMutation>;
export type ValidateTransactionPipelineMutationResult = Apollo.MutationResult<Types.ValidateTransactionPipelineMutation>;
export type ValidateTransactionPipelineMutationOptions = Apollo.BaseMutationOptions<Types.ValidateTransactionPipelineMutation, Types.ValidateTransactionPipelineMutationVariables>;
export const ValidateTransactionRuleOnProductionDocument = gql`
    mutation validateTransactionRuleOnProduction($input: ValidateTransactionRuleOnProductionInput!) {
  validateTransactionRuleOnProduction(input: $input) {
    success
    error
    summary {
      totalFoldersTested
      foldersWithErrors
      foldersWithWarnings
      foldersWithMissingRequiredDocs
      totalErrors
      totalWarnings
    }
    results {
      folder {
        uuid
        folderName
        organizationUuid
        stage
        platform
        folderUpdatedAt
      }
      pipelineValidations {
        operator
        results {
          message
          output
          hasError
          hasWarning
          passedRequirement
          inputValues
        }
        children {
          operator
          results {
            message
            output
            hasError
            hasWarning
            passedRequirement
            inputValues
          }
        }
        requiredDocument {
          isRequired
          isMissing
          message
        }
        contractDocumentId
        ingestionDocumentId
        ingestionDocumentName
        documentName
        documentForm
        documentCategory
      }
      errorCount
      warningCount
      hasRequiredDocumentMissing
    }
  }
}
    `;
export type ValidateTransactionRuleOnProductionMutationFn = Apollo.MutationFunction<Types.ValidateTransactionRuleOnProductionMutation, Types.ValidateTransactionRuleOnProductionMutationVariables>;

/**
 * __useValidateTransactionRuleOnProductionMutation__
 *
 * To run a mutation, you first call `useValidateTransactionRuleOnProductionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateTransactionRuleOnProductionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateTransactionRuleOnProductionMutation, { data, loading, error }] = useValidateTransactionRuleOnProductionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useValidateTransactionRuleOnProductionMutation(baseOptions?: Apollo.MutationHookOptions<Types.ValidateTransactionRuleOnProductionMutation, Types.ValidateTransactionRuleOnProductionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Types.ValidateTransactionRuleOnProductionMutation, Types.ValidateTransactionRuleOnProductionMutationVariables>(ValidateTransactionRuleOnProductionDocument, options);
      }
export type ValidateTransactionRuleOnProductionMutationHookResult = ReturnType<typeof useValidateTransactionRuleOnProductionMutation>;
export type ValidateTransactionRuleOnProductionMutationResult = Apollo.MutationResult<Types.ValidateTransactionRuleOnProductionMutation>;
export type ValidateTransactionRuleOnProductionMutationOptions = Apollo.BaseMutationOptions<Types.ValidateTransactionRuleOnProductionMutation, Types.ValidateTransactionRuleOnProductionMutationVariables>;
export const CheckDocumentVersionDuplicateDocument = gql`
    query checkDocumentVersionDuplicate($input: CheckDocumentVersionDuplicateInput!) {
  checkDocumentVersionDuplicate(input: $input) {
    duplicates {
      documentUuid
      documentVersionUuid
      documentName
      version
      form
      pageCount
    }
  }
}
    `;

/**
 * __useCheckDocumentVersionDuplicateQuery__
 *
 * To run a query within a React component, call `useCheckDocumentVersionDuplicateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckDocumentVersionDuplicateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckDocumentVersionDuplicateQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckDocumentVersionDuplicateQuery(baseOptions: Apollo.QueryHookOptions<Types.CheckDocumentVersionDuplicateQuery, Types.CheckDocumentVersionDuplicateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CheckDocumentVersionDuplicateQuery, Types.CheckDocumentVersionDuplicateQueryVariables>(CheckDocumentVersionDuplicateDocument, options);
      }
export function useCheckDocumentVersionDuplicateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CheckDocumentVersionDuplicateQuery, Types.CheckDocumentVersionDuplicateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CheckDocumentVersionDuplicateQuery, Types.CheckDocumentVersionDuplicateQueryVariables>(CheckDocumentVersionDuplicateDocument, options);
        }
export type CheckDocumentVersionDuplicateQueryHookResult = ReturnType<typeof useCheckDocumentVersionDuplicateQuery>;
export type CheckDocumentVersionDuplicateLazyQueryHookResult = ReturnType<typeof useCheckDocumentVersionDuplicateLazyQuery>;
export type CheckDocumentVersionDuplicateQueryResult = Apollo.QueryResult<Types.CheckDocumentVersionDuplicateQuery, Types.CheckDocumentVersionDuplicateQueryVariables>;
export const CheckSignatureInitialDatasetExistsDocument = gql`
    query checkSignatureInitialDatasetExists($input: CheckSignatureInitialDatasetExistsInput!) {
  checkSignatureInitialDatasetExists(input: $input) {
    results {
      pageNumber
      exists
      key
    }
  }
}
    `;

/**
 * __useCheckSignatureInitialDatasetExistsQuery__
 *
 * To run a query within a React component, call `useCheckSignatureInitialDatasetExistsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckSignatureInitialDatasetExistsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckSignatureInitialDatasetExistsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckSignatureInitialDatasetExistsQuery(baseOptions: Apollo.QueryHookOptions<Types.CheckSignatureInitialDatasetExistsQuery, Types.CheckSignatureInitialDatasetExistsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.CheckSignatureInitialDatasetExistsQuery, Types.CheckSignatureInitialDatasetExistsQueryVariables>(CheckSignatureInitialDatasetExistsDocument, options);
      }
export function useCheckSignatureInitialDatasetExistsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.CheckSignatureInitialDatasetExistsQuery, Types.CheckSignatureInitialDatasetExistsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.CheckSignatureInitialDatasetExistsQuery, Types.CheckSignatureInitialDatasetExistsQueryVariables>(CheckSignatureInitialDatasetExistsDocument, options);
        }
export type CheckSignatureInitialDatasetExistsQueryHookResult = ReturnType<typeof useCheckSignatureInitialDatasetExistsQuery>;
export type CheckSignatureInitialDatasetExistsLazyQueryHookResult = ReturnType<typeof useCheckSignatureInitialDatasetExistsLazyQuery>;
export type CheckSignatureInitialDatasetExistsQueryResult = Apollo.QueryResult<Types.CheckSignatureInitialDatasetExistsQuery, Types.CheckSignatureInitialDatasetExistsQueryVariables>;
export const ComplianceKeyTermSectionListDocument = gql`
    query complianceKeyTermSectionList($filters: ComplianceKeyTermSectionListFilters) {
  complianceKeyTermSectionList(filters: $filters, perPage: 50, orderBy: "order") {
    pageInfo {
      ...PageInfo
    }
    results {
      ...ComplianceKeyTermSectionList
    }
  }
}
    ${PageInfoFragmentDoc}
${ComplianceKeyTermSectionListFragmentDoc}`;

/**
 * __useComplianceKeyTermSectionListQuery__
 *
 * To run a query within a React component, call `useComplianceKeyTermSectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useComplianceKeyTermSectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplianceKeyTermSectionListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useComplianceKeyTermSectionListQuery(baseOptions?: Apollo.QueryHookOptions<Types.ComplianceKeyTermSectionListQuery, Types.ComplianceKeyTermSectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ComplianceKeyTermSectionListQuery, Types.ComplianceKeyTermSectionListQueryVariables>(ComplianceKeyTermSectionListDocument, options);
      }
export function useComplianceKeyTermSectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ComplianceKeyTermSectionListQuery, Types.ComplianceKeyTermSectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ComplianceKeyTermSectionListQuery, Types.ComplianceKeyTermSectionListQueryVariables>(ComplianceKeyTermSectionListDocument, options);
        }
export type ComplianceKeyTermSectionListQueryHookResult = ReturnType<typeof useComplianceKeyTermSectionListQuery>;
export type ComplianceKeyTermSectionListLazyQueryHookResult = ReturnType<typeof useComplianceKeyTermSectionListLazyQuery>;
export type ComplianceKeyTermSectionListQueryResult = Apollo.QueryResult<Types.ComplianceKeyTermSectionListQuery, Types.ComplianceKeyTermSectionListQueryVariables>;
export const ContractByIdDocument = gql`
    query contractById($id: ID!, $resolveFieldValues: Boolean = false, $documentML: Boolean = false, $documentVersionFields: Boolean = false, $extractedValues: Boolean = false, $documentVersionFile: Boolean = false, $autofill: Boolean = true) {
  contractById(id: $id, resolveFieldValues: $resolveFieldValues) {
    ...ContractDetail
  }
}
    ${ContractDetailFragmentDoc}`;

/**
 * __useContractByIdQuery__
 *
 * To run a query within a React component, call `useContractByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      resolveFieldValues: // value for 'resolveFieldValues'
 *      documentML: // value for 'documentML'
 *      documentVersionFields: // value for 'documentVersionFields'
 *      extractedValues: // value for 'extractedValues'
 *      documentVersionFile: // value for 'documentVersionFile'
 *      autofill: // value for 'autofill'
 *   },
 * });
 */
export function useContractByIdQuery(baseOptions: Apollo.QueryHookOptions<Types.ContractByIdQuery, Types.ContractByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ContractByIdQuery, Types.ContractByIdQueryVariables>(ContractByIdDocument, options);
      }
export function useContractByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ContractByIdQuery, Types.ContractByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ContractByIdQuery, Types.ContractByIdQueryVariables>(ContractByIdDocument, options);
        }
export type ContractByIdQueryHookResult = ReturnType<typeof useContractByIdQuery>;
export type ContractByIdLazyQueryHookResult = ReturnType<typeof useContractByIdLazyQuery>;
export type ContractByIdQueryResult = Apollo.QueryResult<Types.ContractByIdQuery, Types.ContractByIdQueryVariables>;
export const ContractFieldValuesDocument = gql`
    query ContractFieldValues($ids: [ID!]!, $resolveFieldValues: Boolean = false) {
  contractByIds(ids: $ids, resolveFieldValues: $resolveFieldValues) {
    ...ContractFieldValues
  }
}
    ${ContractFieldValuesFragmentDoc}`;

/**
 * __useContractFieldValuesQuery__
 *
 * To run a query within a React component, call `useContractFieldValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractFieldValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractFieldValuesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      resolveFieldValues: // value for 'resolveFieldValues'
 *   },
 * });
 */
export function useContractFieldValuesQuery(baseOptions: Apollo.QueryHookOptions<Types.ContractFieldValuesQuery, Types.ContractFieldValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ContractFieldValuesQuery, Types.ContractFieldValuesQueryVariables>(ContractFieldValuesDocument, options);
      }
export function useContractFieldValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ContractFieldValuesQuery, Types.ContractFieldValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ContractFieldValuesQuery, Types.ContractFieldValuesQueryVariables>(ContractFieldValuesDocument, options);
        }
export type ContractFieldValuesQueryHookResult = ReturnType<typeof useContractFieldValuesQuery>;
export type ContractFieldValuesLazyQueryHookResult = ReturnType<typeof useContractFieldValuesLazyQuery>;
export type ContractFieldValuesQueryResult = Apollo.QueryResult<Types.ContractFieldValuesQuery, Types.ContractFieldValuesQueryVariables>;
export const ContractListDocument = gql`
    query contractList($cursor: String, $orderBy: String, $perPage: Int! = 20, $filters: ContractListFilterArgs, $extractedValues: Boolean! = false, $documentML: Boolean! = false, $documentVersionFields: Boolean! = false, $documentVersionFile: Boolean! = false, $autofill: Boolean! = true) {
  contractList(
    cursor: $cursor
    filters: $filters
    orderBy: $orderBy
    perPage: $perPage
  ) @include(if: $documentML) {
    pageInfo {
      ...PageInfo
    }
    results {
      ...ContractDetail
    }
  }
}
    ${PageInfoFragmentDoc}
${ContractDetailFragmentDoc}`;

/**
 * __useContractListQuery__
 *
 * To run a query within a React component, call `useContractListQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractListQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      orderBy: // value for 'orderBy'
 *      perPage: // value for 'perPage'
 *      filters: // value for 'filters'
 *      extractedValues: // value for 'extractedValues'
 *      documentML: // value for 'documentML'
 *      documentVersionFields: // value for 'documentVersionFields'
 *      documentVersionFile: // value for 'documentVersionFile'
 *      autofill: // value for 'autofill'
 *   },
 * });
 */
export function useContractListQuery(baseOptions?: Apollo.QueryHookOptions<Types.ContractListQuery, Types.ContractListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ContractListQuery, Types.ContractListQueryVariables>(ContractListDocument, options);
      }
export function useContractListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ContractListQuery, Types.ContractListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ContractListQuery, Types.ContractListQueryVariables>(ContractListDocument, options);
        }
export type ContractListQueryHookResult = ReturnType<typeof useContractListQuery>;
export type ContractListLazyQueryHookResult = ReturnType<typeof useContractListLazyQuery>;
export type ContractListQueryResult = Apollo.QueryResult<Types.ContractListQuery, Types.ContractListQueryVariables>;
export const ContractSignatureFieldsDocument = gql`
    query contractSignatureFields($args: ContractSignatureFieldsArgs!) {
  contractSignatureFields(input: $args) {
    documentVersionFields {
      ...PublicDocumentVersionField
      field {
        id
        label
        group
        mappingKey
        fieldType
        isComputed
        isHidden
        readOnly
      }
    }
    signatureFormFields {
      ...SignatureFormField
    }
  }
}
    ${PublicDocumentVersionFieldFragmentDoc}
${SignatureFormFieldFragmentDoc}`;

/**
 * __useContractSignatureFieldsQuery__
 *
 * To run a query within a React component, call `useContractSignatureFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractSignatureFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractSignatureFieldsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useContractSignatureFieldsQuery(baseOptions: Apollo.QueryHookOptions<Types.ContractSignatureFieldsQuery, Types.ContractSignatureFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ContractSignatureFieldsQuery, Types.ContractSignatureFieldsQueryVariables>(ContractSignatureFieldsDocument, options);
      }
export function useContractSignatureFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ContractSignatureFieldsQuery, Types.ContractSignatureFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ContractSignatureFieldsQuery, Types.ContractSignatureFieldsQueryVariables>(ContractSignatureFieldsDocument, options);
        }
export type ContractSignatureFieldsQueryHookResult = ReturnType<typeof useContractSignatureFieldsQuery>;
export type ContractSignatureFieldsLazyQueryHookResult = ReturnType<typeof useContractSignatureFieldsLazyQuery>;
export type ContractSignatureFieldsQueryResult = Apollo.QueryResult<Types.ContractSignatureFieldsQuery, Types.ContractSignatureFieldsQueryVariables>;
export const ContractValidationsDocument = gql`
    query contractValidations($autofillVariableValues: JSONObject!, $contractId: ID!, $fieldValues: JSONObject!) {
  contractValidations(
    autofillVariableValues: $autofillVariableValues
    contractId: $contractId
    fieldValues: $fieldValues
  ) {
    id
    validations {
      ...ContractValidation
    }
  }
}
    ${ContractValidationFragmentDoc}`;

/**
 * __useContractValidationsQuery__
 *
 * To run a query within a React component, call `useContractValidationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractValidationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractValidationsQuery({
 *   variables: {
 *      autofillVariableValues: // value for 'autofillVariableValues'
 *      contractId: // value for 'contractId'
 *      fieldValues: // value for 'fieldValues'
 *   },
 * });
 */
export function useContractValidationsQuery(baseOptions: Apollo.QueryHookOptions<Types.ContractValidationsQuery, Types.ContractValidationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ContractValidationsQuery, Types.ContractValidationsQueryVariables>(ContractValidationsDocument, options);
      }
export function useContractValidationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ContractValidationsQuery, Types.ContractValidationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ContractValidationsQuery, Types.ContractValidationsQueryVariables>(ContractValidationsDocument, options);
        }
export type ContractValidationsQueryHookResult = ReturnType<typeof useContractValidationsQuery>;
export type ContractValidationsLazyQueryHookResult = ReturnType<typeof useContractValidationsLazyQuery>;
export type ContractValidationsQueryResult = Apollo.QueryResult<Types.ContractValidationsQuery, Types.ContractValidationsQueryVariables>;
export const ContractVariableValuesDocument = gql`
    query contractVariableValues($input: [ContractVariableValuesInput!]!) {
  contractVariableValues(input: $input) {
    contractId
    contractVariableValues
    variableSource
    state
  }
}
    `;

/**
 * __useContractVariableValuesQuery__
 *
 * To run a query within a React component, call `useContractVariableValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractVariableValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractVariableValuesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContractVariableValuesQuery(baseOptions: Apollo.QueryHookOptions<Types.ContractVariableValuesQuery, Types.ContractVariableValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ContractVariableValuesQuery, Types.ContractVariableValuesQueryVariables>(ContractVariableValuesDocument, options);
      }
export function useContractVariableValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ContractVariableValuesQuery, Types.ContractVariableValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ContractVariableValuesQuery, Types.ContractVariableValuesQueryVariables>(ContractVariableValuesDocument, options);
        }
export type ContractVariableValuesQueryHookResult = ReturnType<typeof useContractVariableValuesQuery>;
export type ContractVariableValuesLazyQueryHookResult = ReturnType<typeof useContractVariableValuesLazyQuery>;
export type ContractVariableValuesQueryResult = Apollo.QueryResult<Types.ContractVariableValuesQuery, Types.ContractVariableValuesQueryVariables>;
export const DocumentClassificationEvaluationListDocument = gql`
    query DocumentClassificationEvaluationList($filter: DocumentClassificationEvaluationListFilter, $cursor: String, $perPage: Int, $orderBy: String) {
  documentClassificationEvaluationList(
    filter: $filter
    cursor: $cursor
    orderBy: $orderBy
    perPage: $perPage
  ) {
    pageInfo {
      ...PageInfo
    }
    results {
      ...DocumentClassificationEvaluation
    }
  }
}
    ${PageInfoFragmentDoc}
${DocumentClassificationEvaluationFragmentDoc}`;

/**
 * __useDocumentClassificationEvaluationListQuery__
 *
 * To run a query within a React component, call `useDocumentClassificationEvaluationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentClassificationEvaluationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentClassificationEvaluationListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      cursor: // value for 'cursor'
 *      perPage: // value for 'perPage'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useDocumentClassificationEvaluationListQuery(baseOptions?: Apollo.QueryHookOptions<Types.DocumentClassificationEvaluationListQuery, Types.DocumentClassificationEvaluationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DocumentClassificationEvaluationListQuery, Types.DocumentClassificationEvaluationListQueryVariables>(DocumentClassificationEvaluationListDocument, options);
      }
export function useDocumentClassificationEvaluationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DocumentClassificationEvaluationListQuery, Types.DocumentClassificationEvaluationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DocumentClassificationEvaluationListQuery, Types.DocumentClassificationEvaluationListQueryVariables>(DocumentClassificationEvaluationListDocument, options);
        }
export type DocumentClassificationEvaluationListQueryHookResult = ReturnType<typeof useDocumentClassificationEvaluationListQuery>;
export type DocumentClassificationEvaluationListLazyQueryHookResult = ReturnType<typeof useDocumentClassificationEvaluationListLazyQuery>;
export type DocumentClassificationEvaluationListQueryResult = Apollo.QueryResult<Types.DocumentClassificationEvaluationListQuery, Types.DocumentClassificationEvaluationListQueryVariables>;
export const DocumentEvaluationJobStatusDocument = gql`
    query DocumentEvaluationJobStatus($jobId: String!) {
  documentEvaluationJobStatus(jobId: $jobId) {
    jobId
    state
    progress {
      current
      total
      evaluationId
    }
    isFailed
    isCompleted
    isInProgress
  }
}
    `;

/**
 * __useDocumentEvaluationJobStatusQuery__
 *
 * To run a query within a React component, call `useDocumentEvaluationJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentEvaluationJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentEvaluationJobStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useDocumentEvaluationJobStatusQuery(baseOptions: Apollo.QueryHookOptions<Types.DocumentEvaluationJobStatusQuery, Types.DocumentEvaluationJobStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DocumentEvaluationJobStatusQuery, Types.DocumentEvaluationJobStatusQueryVariables>(DocumentEvaluationJobStatusDocument, options);
      }
export function useDocumentEvaluationJobStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DocumentEvaluationJobStatusQuery, Types.DocumentEvaluationJobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DocumentEvaluationJobStatusQuery, Types.DocumentEvaluationJobStatusQueryVariables>(DocumentEvaluationJobStatusDocument, options);
        }
export type DocumentEvaluationJobStatusQueryHookResult = ReturnType<typeof useDocumentEvaluationJobStatusQuery>;
export type DocumentEvaluationJobStatusLazyQueryHookResult = ReturnType<typeof useDocumentEvaluationJobStatusLazyQuery>;
export type DocumentEvaluationJobStatusQueryResult = Apollo.QueryResult<Types.DocumentEvaluationJobStatusQuery, Types.DocumentEvaluationJobStatusQueryVariables>;
export const DocumentLlmEvaluationListDocument = gql`
    query DocumentLLMEvaluationList($filters: DocumentLLMEvaluationListFilterArgs, $cursor: String, $perPage: Int, $orderBy: String) {
  documentLLMEvaluationList(
    filters: $filters
    cursor: $cursor
    orderBy: $orderBy
    perPage: $perPage
  ) {
    pageInfo {
      ...PageInfo
    }
    results {
      ...DocumentLLMEvaluation
      document {
        id
        name
        usState
        form
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${DocumentLlmEvaluationFragmentDoc}`;

/**
 * __useDocumentLlmEvaluationListQuery__
 *
 * To run a query within a React component, call `useDocumentLlmEvaluationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentLlmEvaluationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentLlmEvaluationListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      cursor: // value for 'cursor'
 *      perPage: // value for 'perPage'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useDocumentLlmEvaluationListQuery(baseOptions?: Apollo.QueryHookOptions<Types.DocumentLlmEvaluationListQuery, Types.DocumentLlmEvaluationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DocumentLlmEvaluationListQuery, Types.DocumentLlmEvaluationListQueryVariables>(DocumentLlmEvaluationListDocument, options);
      }
export function useDocumentLlmEvaluationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DocumentLlmEvaluationListQuery, Types.DocumentLlmEvaluationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DocumentLlmEvaluationListQuery, Types.DocumentLlmEvaluationListQueryVariables>(DocumentLlmEvaluationListDocument, options);
        }
export type DocumentLlmEvaluationListQueryHookResult = ReturnType<typeof useDocumentLlmEvaluationListQuery>;
export type DocumentLlmEvaluationListLazyQueryHookResult = ReturnType<typeof useDocumentLlmEvaluationListLazyQuery>;
export type DocumentLlmEvaluationListQueryResult = Apollo.QueryResult<Types.DocumentLlmEvaluationListQuery, Types.DocumentLlmEvaluationListQueryVariables>;
export const DocumentLlmListDocument = gql`
    query DocumentLLMList($filters: DocumentLLMListFilterArgs, $cursor: String, $perPage: Int, $orderBy: String, $isDetail: Boolean! = false) {
  documentLLMList(
    filters: $filters
    cursor: $cursor
    orderBy: $orderBy
    perPage: $perPage
  ) {
    pageInfo {
      ...PageInfo
    }
    results {
      ...DocumentLLM
    }
  }
}
    ${PageInfoFragmentDoc}
${DocumentLlmFragmentDoc}`;

/**
 * __useDocumentLlmListQuery__
 *
 * To run a query within a React component, call `useDocumentLlmListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentLlmListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentLlmListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      cursor: // value for 'cursor'
 *      perPage: // value for 'perPage'
 *      orderBy: // value for 'orderBy'
 *      isDetail: // value for 'isDetail'
 *   },
 * });
 */
export function useDocumentLlmListQuery(baseOptions?: Apollo.QueryHookOptions<Types.DocumentLlmListQuery, Types.DocumentLlmListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DocumentLlmListQuery, Types.DocumentLlmListQueryVariables>(DocumentLlmListDocument, options);
      }
export function useDocumentLlmListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DocumentLlmListQuery, Types.DocumentLlmListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DocumentLlmListQuery, Types.DocumentLlmListQueryVariables>(DocumentLlmListDocument, options);
        }
export type DocumentLlmListQueryHookResult = ReturnType<typeof useDocumentLlmListQuery>;
export type DocumentLlmListLazyQueryHookResult = ReturnType<typeof useDocumentLlmListLazyQuery>;
export type DocumentLlmListQueryResult = Apollo.QueryResult<Types.DocumentLlmListQuery, Types.DocumentLlmListQueryVariables>;
export const DocumentLlmMissingKeysDocument = gql`
    query DocumentLLMMissingKeys($documentLLMId: ID!) {
  documentLLMMissingKeys(documentLLMId: $documentLLMId) {
    documentLLMId
    missingMappingKeys
  }
}
    `;

/**
 * __useDocumentLlmMissingKeysQuery__
 *
 * To run a query within a React component, call `useDocumentLlmMissingKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentLlmMissingKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentLlmMissingKeysQuery({
 *   variables: {
 *      documentLLMId: // value for 'documentLLMId'
 *   },
 * });
 */
export function useDocumentLlmMissingKeysQuery(baseOptions: Apollo.QueryHookOptions<Types.DocumentLlmMissingKeysQuery, Types.DocumentLlmMissingKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DocumentLlmMissingKeysQuery, Types.DocumentLlmMissingKeysQueryVariables>(DocumentLlmMissingKeysDocument, options);
      }
export function useDocumentLlmMissingKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DocumentLlmMissingKeysQuery, Types.DocumentLlmMissingKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DocumentLlmMissingKeysQuery, Types.DocumentLlmMissingKeysQueryVariables>(DocumentLlmMissingKeysDocument, options);
        }
export type DocumentLlmMissingKeysQueryHookResult = ReturnType<typeof useDocumentLlmMissingKeysQuery>;
export type DocumentLlmMissingKeysLazyQueryHookResult = ReturnType<typeof useDocumentLlmMissingKeysLazyQuery>;
export type DocumentLlmMissingKeysQueryResult = Apollo.QueryResult<Types.DocumentLlmMissingKeysQuery, Types.DocumentLlmMissingKeysQueryVariables>;
export const DocumentListDocument = gql`
    query documentList($cursor: String, $orderBy: String = "-id", $perPage: Int = 20, $filters: DocumentListArgs!, $includeDocumentVersions: Boolean! = false, $includeDefaultSecondaryDocuments: Boolean! = false, $includeActiveDocumentVersion: Boolean! = false, $includeSubsetOfDocument: Boolean! = false) {
  documentList(
    cursor: $cursor
    orderBy: $orderBy
    perPage: $perPage
    filters: $filters
  ) {
    pageInfo {
      ...PageInfo
    }
    results {
      ...DocumentList
    }
  }
}
    ${PageInfoFragmentDoc}
${DocumentListFragmentDoc}`;

/**
 * __useDocumentListQuery__
 *
 * To run a query within a React component, call `useDocumentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentListQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      orderBy: // value for 'orderBy'
 *      perPage: // value for 'perPage'
 *      filters: // value for 'filters'
 *      includeDocumentVersions: // value for 'includeDocumentVersions'
 *      includeDefaultSecondaryDocuments: // value for 'includeDefaultSecondaryDocuments'
 *      includeActiveDocumentVersion: // value for 'includeActiveDocumentVersion'
 *      includeSubsetOfDocument: // value for 'includeSubsetOfDocument'
 *   },
 * });
 */
export function useDocumentListQuery(baseOptions: Apollo.QueryHookOptions<Types.DocumentListQuery, Types.DocumentListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DocumentListQuery, Types.DocumentListQueryVariables>(DocumentListDocument, options);
      }
export function useDocumentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DocumentListQuery, Types.DocumentListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DocumentListQuery, Types.DocumentListQueryVariables>(DocumentListDocument, options);
        }
export type DocumentListQueryHookResult = ReturnType<typeof useDocumentListQuery>;
export type DocumentListLazyQueryHookResult = ReturnType<typeof useDocumentListLazyQuery>;
export type DocumentListQueryResult = Apollo.QueryResult<Types.DocumentListQuery, Types.DocumentListQueryVariables>;
export const DocumentListForOfferFlowDocument = gql`
    query documentListForOfferFlow($cursor: String, $orderBy: String = "-id", $perPage: Int = 20, $filters: DocumentListArgs!, $isAgentVerified: Boolean = false, $activeDocumentVersion: Boolean = false, $defaultSecondaryDocuments: Boolean! = false) {
  publicDocumentList(
    cursor: $cursor
    orderBy: $orderBy
    perPage: $perPage
    filters: $filters
  ) @skip(if: $isAgentVerified) {
    pageInfo {
      ...PageInfo
    }
    results {
      ...PublicDocumentForOfferFlow
    }
  }
  documentList(
    cursor: $cursor
    orderBy: $orderBy
    perPage: $perPage
    filters: $filters
  ) @include(if: $isAgentVerified) {
    pageInfo {
      ...PageInfo
    }
    results {
      ...DocumentForOfferFlow
    }
  }
}
    ${PageInfoFragmentDoc}
${PublicDocumentForOfferFlowFragmentDoc}
${DocumentForOfferFlowFragmentDoc}`;

/**
 * __useDocumentListForOfferFlowQuery__
 *
 * To run a query within a React component, call `useDocumentListForOfferFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentListForOfferFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentListForOfferFlowQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      orderBy: // value for 'orderBy'
 *      perPage: // value for 'perPage'
 *      filters: // value for 'filters'
 *      isAgentVerified: // value for 'isAgentVerified'
 *      activeDocumentVersion: // value for 'activeDocumentVersion'
 *      defaultSecondaryDocuments: // value for 'defaultSecondaryDocuments'
 *   },
 * });
 */
export function useDocumentListForOfferFlowQuery(baseOptions: Apollo.QueryHookOptions<Types.DocumentListForOfferFlowQuery, Types.DocumentListForOfferFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DocumentListForOfferFlowQuery, Types.DocumentListForOfferFlowQueryVariables>(DocumentListForOfferFlowDocument, options);
      }
export function useDocumentListForOfferFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DocumentListForOfferFlowQuery, Types.DocumentListForOfferFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DocumentListForOfferFlowQuery, Types.DocumentListForOfferFlowQueryVariables>(DocumentListForOfferFlowDocument, options);
        }
export type DocumentListForOfferFlowQueryHookResult = ReturnType<typeof useDocumentListForOfferFlowQuery>;
export type DocumentListForOfferFlowLazyQueryHookResult = ReturnType<typeof useDocumentListForOfferFlowLazyQuery>;
export type DocumentListForOfferFlowQueryResult = Apollo.QueryResult<Types.DocumentListForOfferFlowQuery, Types.DocumentListForOfferFlowQueryVariables>;
export const DocumentSectionListDocument = gql`
    query documentSectionList($filters: DocumentSectionListFilters) {
  documentSectionList(filters: $filters, perPage: 50, orderBy: "order") {
    pageInfo {
      ...PageInfo
    }
    results {
      ...DocumentSectionList
    }
  }
}
    ${PageInfoFragmentDoc}
${DocumentSectionListFragmentDoc}`;

/**
 * __useDocumentSectionListQuery__
 *
 * To run a query within a React component, call `useDocumentSectionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentSectionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentSectionListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDocumentSectionListQuery(baseOptions?: Apollo.QueryHookOptions<Types.DocumentSectionListQuery, Types.DocumentSectionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DocumentSectionListQuery, Types.DocumentSectionListQueryVariables>(DocumentSectionListDocument, options);
      }
export function useDocumentSectionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DocumentSectionListQuery, Types.DocumentSectionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DocumentSectionListQuery, Types.DocumentSectionListQueryVariables>(DocumentSectionListDocument, options);
        }
export type DocumentSectionListQueryHookResult = ReturnType<typeof useDocumentSectionListQuery>;
export type DocumentSectionListLazyQueryHookResult = ReturnType<typeof useDocumentSectionListLazyQuery>;
export type DocumentSectionListQueryResult = Apollo.QueryResult<Types.DocumentSectionListQuery, Types.DocumentSectionListQueryVariables>;
export const DocumentSectionListForOfferFlowDocument = gql`
    query documentSectionListForOfferFlow($filters: DocumentSectionListFilters, $perPage: Int = 100) {
  publicDocumentSectionList(
    filters: $filters
    perPage: $perPage
    orderBy: "order"
  ) {
    pageInfo {
      ...PageInfo
    }
    results {
      ...DocumentSectionListForOfferFlow
    }
  }
}
    ${PageInfoFragmentDoc}
${DocumentSectionListForOfferFlowFragmentDoc}`;

/**
 * __useDocumentSectionListForOfferFlowQuery__
 *
 * To run a query within a React component, call `useDocumentSectionListForOfferFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentSectionListForOfferFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentSectionListForOfferFlowQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useDocumentSectionListForOfferFlowQuery(baseOptions?: Apollo.QueryHookOptions<Types.DocumentSectionListForOfferFlowQuery, Types.DocumentSectionListForOfferFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DocumentSectionListForOfferFlowQuery, Types.DocumentSectionListForOfferFlowQueryVariables>(DocumentSectionListForOfferFlowDocument, options);
      }
export function useDocumentSectionListForOfferFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DocumentSectionListForOfferFlowQuery, Types.DocumentSectionListForOfferFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DocumentSectionListForOfferFlowQuery, Types.DocumentSectionListForOfferFlowQueryVariables>(DocumentSectionListForOfferFlowDocument, options);
        }
export type DocumentSectionListForOfferFlowQueryHookResult = ReturnType<typeof useDocumentSectionListForOfferFlowQuery>;
export type DocumentSectionListForOfferFlowLazyQueryHookResult = ReturnType<typeof useDocumentSectionListForOfferFlowLazyQuery>;
export type DocumentSectionListForOfferFlowQueryResult = Apollo.QueryResult<Types.DocumentSectionListForOfferFlowQuery, Types.DocumentSectionListForOfferFlowQueryVariables>;
export const DocumentVersionAutofillValuesDocument = gql`
    query documentVersionAutofillValues($variableValues: JSONObject!, $documentVersionIds: [ID!]!, $fieldValues: JSONObject!) {
  documentVersionAutofillValues(
    variableValues: $variableValues
    documentVersionIds: $documentVersionIds
    fieldValues: $fieldValues
  ) {
    readOnlyAutofillValues
    autofillValues
    optionsAutofillValues
    helpTextAutofillValues
  }
}
    `;

/**
 * __useDocumentVersionAutofillValuesQuery__
 *
 * To run a query within a React component, call `useDocumentVersionAutofillValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentVersionAutofillValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentVersionAutofillValuesQuery({
 *   variables: {
 *      variableValues: // value for 'variableValues'
 *      documentVersionIds: // value for 'documentVersionIds'
 *      fieldValues: // value for 'fieldValues'
 *   },
 * });
 */
export function useDocumentVersionAutofillValuesQuery(baseOptions: Apollo.QueryHookOptions<Types.DocumentVersionAutofillValuesQuery, Types.DocumentVersionAutofillValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DocumentVersionAutofillValuesQuery, Types.DocumentVersionAutofillValuesQueryVariables>(DocumentVersionAutofillValuesDocument, options);
      }
export function useDocumentVersionAutofillValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DocumentVersionAutofillValuesQuery, Types.DocumentVersionAutofillValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DocumentVersionAutofillValuesQuery, Types.DocumentVersionAutofillValuesQueryVariables>(DocumentVersionAutofillValuesDocument, options);
        }
export type DocumentVersionAutofillValuesQueryHookResult = ReturnType<typeof useDocumentVersionAutofillValuesQuery>;
export type DocumentVersionAutofillValuesLazyQueryHookResult = ReturnType<typeof useDocumentVersionAutofillValuesLazyQuery>;
export type DocumentVersionAutofillValuesQueryResult = Apollo.QueryResult<Types.DocumentVersionAutofillValuesQuery, Types.DocumentVersionAutofillValuesQueryVariables>;
export const DocumentVersionListDocument = gql`
    query documentVersionList($cursor: String, $orderBy: String = "-id", $perPage: Int = 10, $filters: DocumentVersionListFilterArgs, $document: Boolean = false, $fields: Boolean = false, $secondaryDocumentVersions: Boolean = false) {
  documentVersionList(
    cursor: $cursor
    orderBy: $orderBy
    perPage: $perPage
    filters: $filters
  ) {
    pageInfo {
      ...PageInfo
    }
    results {
      ...DocumentVersionList
    }
  }
}
    ${PageInfoFragmentDoc}
${DocumentVersionListFragmentDoc}`;

/**
 * __useDocumentVersionListQuery__
 *
 * To run a query within a React component, call `useDocumentVersionListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentVersionListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentVersionListQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      orderBy: // value for 'orderBy'
 *      perPage: // value for 'perPage'
 *      filters: // value for 'filters'
 *      document: // value for 'document'
 *      fields: // value for 'fields'
 *      secondaryDocumentVersions: // value for 'secondaryDocumentVersions'
 *   },
 * });
 */
export function useDocumentVersionListQuery(baseOptions?: Apollo.QueryHookOptions<Types.DocumentVersionListQuery, Types.DocumentVersionListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DocumentVersionListQuery, Types.DocumentVersionListQueryVariables>(DocumentVersionListDocument, options);
      }
export function useDocumentVersionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DocumentVersionListQuery, Types.DocumentVersionListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DocumentVersionListQuery, Types.DocumentVersionListQueryVariables>(DocumentVersionListDocument, options);
        }
export type DocumentVersionListQueryHookResult = ReturnType<typeof useDocumentVersionListQuery>;
export type DocumentVersionListLazyQueryHookResult = ReturnType<typeof useDocumentVersionListLazyQuery>;
export type DocumentVersionListQueryResult = Apollo.QueryResult<Types.DocumentVersionListQuery, Types.DocumentVersionListQueryVariables>;
export const DocumentVersionListForOfferFlowDocument = gql`
    query documentVersionListForOfferFlow($cursor: String, $orderBy: String = "-id", $perPage: Int = 20, $filters: DocumentVersionListFilterArgs!, $isAgentVerified: Boolean = false, $documentVersionFields: Boolean = false, $previewImages: Boolean = false, $skipSecondaryVersions: Boolean = false) {
  publicDocumentVersionList(
    cursor: $cursor
    orderBy: $orderBy
    perPage: $perPage
    filters: $filters
  ) @skip(if: $isAgentVerified) {
    pageInfo {
      ...PageInfo
    }
    results {
      ...PublicDocumentVersionForOfferFlow
    }
  }
  documentVersionList(
    cursor: $cursor
    orderBy: $orderBy
    perPage: $perPage
    filters: $filters
  ) @include(if: $isAgentVerified) {
    pageInfo {
      ...PageInfo
    }
    results {
      ...DocumentVersionForOfferFlow
    }
  }
}
    ${PageInfoFragmentDoc}
${PublicDocumentVersionForOfferFlowFragmentDoc}
${DocumentVersionForOfferFlowFragmentDoc}`;

/**
 * __useDocumentVersionListForOfferFlowQuery__
 *
 * To run a query within a React component, call `useDocumentVersionListForOfferFlowQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentVersionListForOfferFlowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentVersionListForOfferFlowQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      orderBy: // value for 'orderBy'
 *      perPage: // value for 'perPage'
 *      filters: // value for 'filters'
 *      isAgentVerified: // value for 'isAgentVerified'
 *      documentVersionFields: // value for 'documentVersionFields'
 *      previewImages: // value for 'previewImages'
 *      skipSecondaryVersions: // value for 'skipSecondaryVersions'
 *   },
 * });
 */
export function useDocumentVersionListForOfferFlowQuery(baseOptions: Apollo.QueryHookOptions<Types.DocumentVersionListForOfferFlowQuery, Types.DocumentVersionListForOfferFlowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DocumentVersionListForOfferFlowQuery, Types.DocumentVersionListForOfferFlowQueryVariables>(DocumentVersionListForOfferFlowDocument, options);
      }
export function useDocumentVersionListForOfferFlowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DocumentVersionListForOfferFlowQuery, Types.DocumentVersionListForOfferFlowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DocumentVersionListForOfferFlowQuery, Types.DocumentVersionListForOfferFlowQueryVariables>(DocumentVersionListForOfferFlowDocument, options);
        }
export type DocumentVersionListForOfferFlowQueryHookResult = ReturnType<typeof useDocumentVersionListForOfferFlowQuery>;
export type DocumentVersionListForOfferFlowLazyQueryHookResult = ReturnType<typeof useDocumentVersionListForOfferFlowLazyQuery>;
export type DocumentVersionListForOfferFlowQueryResult = Apollo.QueryResult<Types.DocumentVersionListForOfferFlowQuery, Types.DocumentVersionListForOfferFlowQueryVariables>;
export const DotloopComplianceGroupsDocument = gql`
    query dotloopComplianceGroups($filters: DotloopComplianceGroupsFilterInput!) {
  dotloopComplianceGroups(filters: $filters) {
    id
    name
    active
    type
    complianceStatuses
  }
}
    `;

/**
 * __useDotloopComplianceGroupsQuery__
 *
 * To run a query within a React component, call `useDotloopComplianceGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDotloopComplianceGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDotloopComplianceGroupsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useDotloopComplianceGroupsQuery(baseOptions: Apollo.QueryHookOptions<Types.DotloopComplianceGroupsQuery, Types.DotloopComplianceGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.DotloopComplianceGroupsQuery, Types.DotloopComplianceGroupsQueryVariables>(DotloopComplianceGroupsDocument, options);
      }
export function useDotloopComplianceGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.DotloopComplianceGroupsQuery, Types.DotloopComplianceGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.DotloopComplianceGroupsQuery, Types.DotloopComplianceGroupsQueryVariables>(DotloopComplianceGroupsDocument, options);
        }
export type DotloopComplianceGroupsQueryHookResult = ReturnType<typeof useDotloopComplianceGroupsQuery>;
export type DotloopComplianceGroupsLazyQueryHookResult = ReturnType<typeof useDotloopComplianceGroupsLazyQuery>;
export type DotloopComplianceGroupsQueryResult = Apollo.QueryResult<Types.DotloopComplianceGroupsQuery, Types.DotloopComplianceGroupsQueryVariables>;
export const EmbeddedSignatureRequestDocument = gql`
    query embeddedSignatureRequest($code: String!) {
  embeddedSignatureRequest(code: $code) {
    ...EmbeddedSignatureRequest
  }
}
    ${EmbeddedSignatureRequestFragmentDoc}`;

/**
 * __useEmbeddedSignatureRequestQuery__
 *
 * To run a query within a React component, call `useEmbeddedSignatureRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmbeddedSignatureRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmbeddedSignatureRequestQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useEmbeddedSignatureRequestQuery(baseOptions: Apollo.QueryHookOptions<Types.EmbeddedSignatureRequestQuery, Types.EmbeddedSignatureRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.EmbeddedSignatureRequestQuery, Types.EmbeddedSignatureRequestQueryVariables>(EmbeddedSignatureRequestDocument, options);
      }
export function useEmbeddedSignatureRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.EmbeddedSignatureRequestQuery, Types.EmbeddedSignatureRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.EmbeddedSignatureRequestQuery, Types.EmbeddedSignatureRequestQueryVariables>(EmbeddedSignatureRequestDocument, options);
        }
export type EmbeddedSignatureRequestQueryHookResult = ReturnType<typeof useEmbeddedSignatureRequestQuery>;
export type EmbeddedSignatureRequestLazyQueryHookResult = ReturnType<typeof useEmbeddedSignatureRequestLazyQuery>;
export type EmbeddedSignatureRequestQueryResult = Apollo.QueryResult<Types.EmbeddedSignatureRequestQuery, Types.EmbeddedSignatureRequestQueryVariables>;
export const ExternalDarwinPropertiesDocument = gql`
    query ExternalDarwinProperties($input: ExternalDarwinPropertyInput!) {
  externalDarwinProperties(input: $input) {
    properties {
      ...ExternalDarwinPropertyFields
    }
  }
}
    ${ExternalDarwinPropertyFieldsFragmentDoc}`;

/**
 * __useExternalDarwinPropertiesQuery__
 *
 * To run a query within a React component, call `useExternalDarwinPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalDarwinPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalDarwinPropertiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalDarwinPropertiesQuery(baseOptions: Apollo.QueryHookOptions<Types.ExternalDarwinPropertiesQuery, Types.ExternalDarwinPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ExternalDarwinPropertiesQuery, Types.ExternalDarwinPropertiesQueryVariables>(ExternalDarwinPropertiesDocument, options);
      }
export function useExternalDarwinPropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ExternalDarwinPropertiesQuery, Types.ExternalDarwinPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ExternalDarwinPropertiesQuery, Types.ExternalDarwinPropertiesQueryVariables>(ExternalDarwinPropertiesDocument, options);
        }
export type ExternalDarwinPropertiesQueryHookResult = ReturnType<typeof useExternalDarwinPropertiesQuery>;
export type ExternalDarwinPropertiesLazyQueryHookResult = ReturnType<typeof useExternalDarwinPropertiesLazyQuery>;
export type ExternalDarwinPropertiesQueryResult = Apollo.QueryResult<Types.ExternalDarwinPropertiesQuery, Types.ExternalDarwinPropertiesQueryVariables>;
export const ExternalDarwinPropertyDocument = gql`
    query ExternalDarwinProperty($input: ExternalDarwinPropertyInput!) {
  externalDarwinProperties(input: $input) {
    properties {
      ...ExternalDarwinPropertyFields
      participants {
        buyersAgents {
          personName
        }
        listingAgents {
          personName
        }
        buyers {
          personName
        }
        sellers {
          personName
        }
        transactionCoordinators {
          personName
          isMatched
        }
      }
    }
  }
}
    ${ExternalDarwinPropertyFieldsFragmentDoc}`;

/**
 * __useExternalDarwinPropertyQuery__
 *
 * To run a query within a React component, call `useExternalDarwinPropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalDarwinPropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalDarwinPropertyQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalDarwinPropertyQuery(baseOptions: Apollo.QueryHookOptions<Types.ExternalDarwinPropertyQuery, Types.ExternalDarwinPropertyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ExternalDarwinPropertyQuery, Types.ExternalDarwinPropertyQueryVariables>(ExternalDarwinPropertyDocument, options);
      }
export function useExternalDarwinPropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ExternalDarwinPropertyQuery, Types.ExternalDarwinPropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ExternalDarwinPropertyQuery, Types.ExternalDarwinPropertyQueryVariables>(ExternalDarwinPropertyDocument, options);
        }
export type ExternalDarwinPropertyQueryHookResult = ReturnType<typeof useExternalDarwinPropertyQuery>;
export type ExternalDarwinPropertyLazyQueryHookResult = ReturnType<typeof useExternalDarwinPropertyLazyQuery>;
export type ExternalDarwinPropertyQueryResult = Apollo.QueryResult<Types.ExternalDarwinPropertyQuery, Types.ExternalDarwinPropertyQueryVariables>;
export const ExternalGetComplianceMessageHistoryDocument = gql`
    query externalGetComplianceMessageHistory($input: ExternalGetComplianceMessageHistoryInput!) {
  externalGetComplianceMessageHistory(input: $input) {
    id
    recipientType
    recipientValue
    messageContent
    workflowRunId
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useExternalGetComplianceMessageHistoryQuery__
 *
 * To run a query within a React component, call `useExternalGetComplianceMessageHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalGetComplianceMessageHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalGetComplianceMessageHistoryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalGetComplianceMessageHistoryQuery(baseOptions: Apollo.QueryHookOptions<Types.ExternalGetComplianceMessageHistoryQuery, Types.ExternalGetComplianceMessageHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ExternalGetComplianceMessageHistoryQuery, Types.ExternalGetComplianceMessageHistoryQueryVariables>(ExternalGetComplianceMessageHistoryDocument, options);
      }
export function useExternalGetComplianceMessageHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ExternalGetComplianceMessageHistoryQuery, Types.ExternalGetComplianceMessageHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ExternalGetComplianceMessageHistoryQuery, Types.ExternalGetComplianceMessageHistoryQueryVariables>(ExternalGetComplianceMessageHistoryDocument, options);
        }
export type ExternalGetComplianceMessageHistoryQueryHookResult = ReturnType<typeof useExternalGetComplianceMessageHistoryQuery>;
export type ExternalGetComplianceMessageHistoryLazyQueryHookResult = ReturnType<typeof useExternalGetComplianceMessageHistoryLazyQuery>;
export type ExternalGetComplianceMessageHistoryQueryResult = Apollo.QueryResult<Types.ExternalGetComplianceMessageHistoryQuery, Types.ExternalGetComplianceMessageHistoryQueryVariables>;
export const ExternalGetDarwinPropertyClassificationDocument = gql`
    query externalGetDarwinPropertyClassification($input: ExternalGetDarwinPropertyClassificationInput!) {
  externalGetDarwinPropertyClassification(input: $input) {
    typeCode
    typeCodeName
    propertyTypeId
    propertyTypeName
    classificationId
    classificationName
  }
}
    `;

/**
 * __useExternalGetDarwinPropertyClassificationQuery__
 *
 * To run a query within a React component, call `useExternalGetDarwinPropertyClassificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalGetDarwinPropertyClassificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalGetDarwinPropertyClassificationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalGetDarwinPropertyClassificationQuery(baseOptions: Apollo.QueryHookOptions<Types.ExternalGetDarwinPropertyClassificationQuery, Types.ExternalGetDarwinPropertyClassificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ExternalGetDarwinPropertyClassificationQuery, Types.ExternalGetDarwinPropertyClassificationQueryVariables>(ExternalGetDarwinPropertyClassificationDocument, options);
      }
export function useExternalGetDarwinPropertyClassificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ExternalGetDarwinPropertyClassificationQuery, Types.ExternalGetDarwinPropertyClassificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ExternalGetDarwinPropertyClassificationQuery, Types.ExternalGetDarwinPropertyClassificationQueryVariables>(ExternalGetDarwinPropertyClassificationDocument, options);
        }
export type ExternalGetDarwinPropertyClassificationQueryHookResult = ReturnType<typeof useExternalGetDarwinPropertyClassificationQuery>;
export type ExternalGetDarwinPropertyClassificationLazyQueryHookResult = ReturnType<typeof useExternalGetDarwinPropertyClassificationLazyQuery>;
export type ExternalGetDarwinPropertyClassificationQueryResult = Apollo.QueryResult<Types.ExternalGetDarwinPropertyClassificationQuery, Types.ExternalGetDarwinPropertyClassificationQueryVariables>;
export const ExternalGetDarwinSyncPreviewDocument = gql`
    query externalGetDarwinSyncPreview($input: ExternalGetDarwinSyncPreviewInput!) {
  externalGetDarwinSyncPreview(input: $input) {
    sections {
      sectionType
      fields {
        label
        currentValue {
          value
        }
        proposedValue {
          value
          disabledOptions {
            isDisabled
            isDisabledByDefault
            isRequired
          }
          warningMessage
          sourceLabel
        }
        hasChange
      }
    }
    vendorsSection {
      sectionType
      fields {
        label
        vendorType
        currentValue {
          propertyPeopleId
          personId
          personName
          side
        }
        proposedValue {
          value
          sourceLabel
          changeType
          matchedPersonId
          matchedPersonName
          confidence
          side
          disabledReason
          alternatives {
            personId
            personName
            matchScore
            confidence
          }
          disabledOptions {
            isDisabled
            isDisabledByDefault
          }
        }
        hasChange
      }
    }
    feesSection {
      fields {
        feeType
        label
        currentValue {
          amount
        }
        proposedValue {
          amount
          payer
          sourceLabel
          disabledOptions {
            isDisabled
            isDisabledByDefault
          }
        }
        hasChange
      }
    }
  }
}
    `;

/**
 * __useExternalGetDarwinSyncPreviewQuery__
 *
 * To run a query within a React component, call `useExternalGetDarwinSyncPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalGetDarwinSyncPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalGetDarwinSyncPreviewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalGetDarwinSyncPreviewQuery(baseOptions: Apollo.QueryHookOptions<Types.ExternalGetDarwinSyncPreviewQuery, Types.ExternalGetDarwinSyncPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ExternalGetDarwinSyncPreviewQuery, Types.ExternalGetDarwinSyncPreviewQueryVariables>(ExternalGetDarwinSyncPreviewDocument, options);
      }
export function useExternalGetDarwinSyncPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ExternalGetDarwinSyncPreviewQuery, Types.ExternalGetDarwinSyncPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ExternalGetDarwinSyncPreviewQuery, Types.ExternalGetDarwinSyncPreviewQueryVariables>(ExternalGetDarwinSyncPreviewDocument, options);
        }
export type ExternalGetDarwinSyncPreviewQueryHookResult = ReturnType<typeof useExternalGetDarwinSyncPreviewQuery>;
export type ExternalGetDarwinSyncPreviewLazyQueryHookResult = ReturnType<typeof useExternalGetDarwinSyncPreviewLazyQuery>;
export type ExternalGetDarwinSyncPreviewQueryResult = Apollo.QueryResult<Types.ExternalGetDarwinSyncPreviewQuery, Types.ExternalGetDarwinSyncPreviewQueryVariables>;
export const ExternalGetMlsListingSelectionDocument = gql`
    query externalGetMLSListingSelection($input: ExternalGetMLSListingSelectionInput!) {
  externalGetMLSListingSelection(input: $input) {
    selectedListing {
      ...MLSListingSelectionInfo
    }
    rankedListings {
      listing {
        ...MLSListingSelectionInfo
      }
      score
      rankingFactors {
        statusScore
        recencyScore
        propertyTypeMatch
        osnPreferenceMatch
        documentRelevanceScore
      }
      disqualified
      disqualificationReason
    }
    isAmbiguous
    selectionReason
    totalListingsFound
  }
}
    ${MlsListingSelectionInfoFragmentDoc}`;

/**
 * __useExternalGetMlsListingSelectionQuery__
 *
 * To run a query within a React component, call `useExternalGetMlsListingSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalGetMlsListingSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalGetMlsListingSelectionQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExternalGetMlsListingSelectionQuery(baseOptions: Apollo.QueryHookOptions<Types.ExternalGetMlsListingSelectionQuery, Types.ExternalGetMlsListingSelectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.ExternalGetMlsListingSelectionQuery, Types.ExternalGetMlsListingSelectionQueryVariables>(ExternalGetMlsListingSelectionDocument, options);
      }
export function useExternalGetMlsListingSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.ExternalGetMlsListingSelectionQuery, Types.ExternalGetMlsListingSelectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.ExternalGetMlsListingSelectionQuery, Types.ExternalGetMlsListingSelectionQueryVariables>(ExternalGetMlsListingSelectionDocument, options);
        }
export type ExternalGetMlsListingSelectionQueryHookResult = ReturnType<typeof useExternalGetMlsListingSelectionQuery>;
export type ExternalGetMlsListingSelectionLazyQueryHookResult = ReturnType<typeof useExternalGetMlsListingSelectionLazyQuery>;
export type ExternalGetMlsListingSelectionQueryResult = Apollo.QueryResult<Types.ExternalGetMlsListingSelectionQuery, Types.ExternalGetMlsListingSelectionQueryVariables>;
export const FieldListDocument = gql`
    query fieldList($cursor: String, $orderBy: String = "-id", $perPage: Int = 20, $filters: FieldListFilterArgs, $fieldDetail: Boolean = false) {
  fieldList(
    cursor: $cursor
    orderBy: $orderBy
    perPage: $perPage
    filters: $filters
  ) {
    pageInfo {
      ...PageInfo
    }
    results {
      ...Field
      ...FieldDetail @include(if: $fieldDetail)
      includedDocumentVersions @include(if: $fieldDetail) {
        id
        version
        document {
          id
          form
          usState
        }
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${FieldFragmentDoc}
${FieldDetailFragmentDoc}`;

/**
 * __useFieldListQuery__
 *
 * To run a query within a React component, call `useFieldListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFieldListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFieldListQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      orderBy: // value for 'orderBy'
 *      perPage: // value for 'perPage'
 *      filters: // value for 'filters'
 *      fieldDetail: // value for 'fieldDetail'
 *   },
 * });
 */
export function useFieldListQuery(baseOptions?: Apollo.QueryHookOptions<Types.FieldListQuery, Types.FieldListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.FieldListQuery, Types.FieldListQueryVariables>(FieldListDocument, options);
      }
export function useFieldListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.FieldListQuery, Types.FieldListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.FieldListQuery, Types.FieldListQueryVariables>(FieldListDocument, options);
        }
export type FieldListQueryHookResult = ReturnType<typeof useFieldListQuery>;
export type FieldListLazyQueryHookResult = ReturnType<typeof useFieldListLazyQuery>;
export type FieldListQueryResult = Apollo.QueryResult<Types.FieldListQuery, Types.FieldListQueryVariables>;
export const GenerateValidationReportDocument = gql`
    query GenerateValidationReport($folderUuid: String!) {
  generateValidationReport(folderUuid: $folderUuid)
}
    `;

/**
 * __useGenerateValidationReportQuery__
 *
 * To run a query within a React component, call `useGenerateValidationReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateValidationReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateValidationReportQuery({
 *   variables: {
 *      folderUuid: // value for 'folderUuid'
 *   },
 * });
 */
export function useGenerateValidationReportQuery(baseOptions: Apollo.QueryHookOptions<Types.GenerateValidationReportQuery, Types.GenerateValidationReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GenerateValidationReportQuery, Types.GenerateValidationReportQueryVariables>(GenerateValidationReportDocument, options);
      }
export function useGenerateValidationReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GenerateValidationReportQuery, Types.GenerateValidationReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GenerateValidationReportQuery, Types.GenerateValidationReportQueryVariables>(GenerateValidationReportDocument, options);
        }
export type GenerateValidationReportQueryHookResult = ReturnType<typeof useGenerateValidationReportQuery>;
export type GenerateValidationReportLazyQueryHookResult = ReturnType<typeof useGenerateValidationReportLazyQuery>;
export type GenerateValidationReportQueryResult = Apollo.QueryResult<Types.GenerateValidationReportQuery, Types.GenerateValidationReportQueryVariables>;
export const GetDocumentVersionFieldDocument = gql`
    query getDocumentVersionField($id: ID!) {
  getDocumentVersionField(id: $id) {
    ...DocumentVersionField
    field {
      ...Field
      ...FieldDetail
    }
    rules {
      ...Rule
    }
    autofill {
      ...Autofill
    }
    optionsAutofill {
      ...Autofill
    }
    helpTextAutofill {
      ...Autofill
    }
  }
}
    ${DocumentVersionFieldFragmentDoc}
${FieldFragmentDoc}
${FieldDetailFragmentDoc}
${RuleFragmentDoc}
${AutofillFragmentDoc}`;

/**
 * __useGetDocumentVersionFieldQuery__
 *
 * To run a query within a React component, call `useGetDocumentVersionFieldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentVersionFieldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentVersionFieldQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDocumentVersionFieldQuery(baseOptions: Apollo.QueryHookOptions<Types.GetDocumentVersionFieldQuery, Types.GetDocumentVersionFieldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetDocumentVersionFieldQuery, Types.GetDocumentVersionFieldQueryVariables>(GetDocumentVersionFieldDocument, options);
      }
export function useGetDocumentVersionFieldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetDocumentVersionFieldQuery, Types.GetDocumentVersionFieldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetDocumentVersionFieldQuery, Types.GetDocumentVersionFieldQueryVariables>(GetDocumentVersionFieldDocument, options);
        }
export type GetDocumentVersionFieldQueryHookResult = ReturnType<typeof useGetDocumentVersionFieldQuery>;
export type GetDocumentVersionFieldLazyQueryHookResult = ReturnType<typeof useGetDocumentVersionFieldLazyQuery>;
export type GetDocumentVersionFieldQueryResult = Apollo.QueryResult<Types.GetDocumentVersionFieldQuery, Types.GetDocumentVersionFieldQueryVariables>;
export const GetDocumentVersionInfoDocument = gql`
    query getDocumentVersionInfo($input: GetDocumentVersionInfoInput!) {
  getDocumentVersionInfo(input: $input) {
    id
    usState
    documentType
    name
    form
    version
    searchRegex
  }
}
    `;

/**
 * __useGetDocumentVersionInfoQuery__
 *
 * To run a query within a React component, call `useGetDocumentVersionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDocumentVersionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDocumentVersionInfoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDocumentVersionInfoQuery(baseOptions: Apollo.QueryHookOptions<Types.GetDocumentVersionInfoQuery, Types.GetDocumentVersionInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetDocumentVersionInfoQuery, Types.GetDocumentVersionInfoQueryVariables>(GetDocumentVersionInfoDocument, options);
      }
export function useGetDocumentVersionInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetDocumentVersionInfoQuery, Types.GetDocumentVersionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetDocumentVersionInfoQuery, Types.GetDocumentVersionInfoQueryVariables>(GetDocumentVersionInfoDocument, options);
        }
export type GetDocumentVersionInfoQueryHookResult = ReturnType<typeof useGetDocumentVersionInfoQuery>;
export type GetDocumentVersionInfoLazyQueryHookResult = ReturnType<typeof useGetDocumentVersionInfoLazyQuery>;
export type GetDocumentVersionInfoQueryResult = Apollo.QueryResult<Types.GetDocumentVersionInfoQuery, Types.GetDocumentVersionInfoQueryVariables>;
export const GetSignedUrlsDocument = gql`
    query getSignedUrls($input: GetSignedUrlsInput!) {
  getSignedUrls(input: $input) {
    urls {
      key
      signedUrl
    }
  }
}
    `;

/**
 * __useGetSignedUrlsQuery__
 *
 * To run a query within a React component, call `useGetSignedUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignedUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignedUrlsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSignedUrlsQuery(baseOptions: Apollo.QueryHookOptions<Types.GetSignedUrlsQuery, Types.GetSignedUrlsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.GetSignedUrlsQuery, Types.GetSignedUrlsQueryVariables>(GetSignedUrlsDocument, options);
      }
export function useGetSignedUrlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.GetSignedUrlsQuery, Types.GetSignedUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.GetSignedUrlsQuery, Types.GetSignedUrlsQueryVariables>(GetSignedUrlsDocument, options);
        }
export type GetSignedUrlsQueryHookResult = ReturnType<typeof useGetSignedUrlsQuery>;
export type GetSignedUrlsLazyQueryHookResult = ReturnType<typeof useGetSignedUrlsLazyQuery>;
export type GetSignedUrlsQueryResult = Apollo.QueryResult<Types.GetSignedUrlsQuery, Types.GetSignedUrlsQueryVariables>;
export const IngestionDocumentListWithFieldsDocument = gql`
    query ingestionDocumentListWithFields($ingestionFolderId: String!) {
  ingestionDocumentList(ingestionFolderId: $ingestionFolderId) {
    id
    fields
  }
}
    `;

/**
 * __useIngestionDocumentListWithFieldsQuery__
 *
 * To run a query within a React component, call `useIngestionDocumentListWithFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIngestionDocumentListWithFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIngestionDocumentListWithFieldsQuery({
 *   variables: {
 *      ingestionFolderId: // value for 'ingestionFolderId'
 *   },
 * });
 */
export function useIngestionDocumentListWithFieldsQuery(baseOptions: Apollo.QueryHookOptions<Types.IngestionDocumentListWithFieldsQuery, Types.IngestionDocumentListWithFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IngestionDocumentListWithFieldsQuery, Types.IngestionDocumentListWithFieldsQueryVariables>(IngestionDocumentListWithFieldsDocument, options);
      }
export function useIngestionDocumentListWithFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IngestionDocumentListWithFieldsQuery, Types.IngestionDocumentListWithFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IngestionDocumentListWithFieldsQuery, Types.IngestionDocumentListWithFieldsQueryVariables>(IngestionDocumentListWithFieldsDocument, options);
        }
export type IngestionDocumentListWithFieldsQueryHookResult = ReturnType<typeof useIngestionDocumentListWithFieldsQuery>;
export type IngestionDocumentListWithFieldsLazyQueryHookResult = ReturnType<typeof useIngestionDocumentListWithFieldsLazyQuery>;
export type IngestionDocumentListWithFieldsQueryResult = Apollo.QueryResult<Types.IngestionDocumentListWithFieldsQuery, Types.IngestionDocumentListWithFieldsQueryVariables>;
export const IngestionFolderCountsByPipelineDocument = gql`
    query ingestionFolderCountsByPipeline($filters: IngestionFolderCountsByPipelineFilterArgs!) {
  ingestionFolderCountsByPipeline(filters: $filters) {
    pipelineCounts {
      transactionPipelineId
      count
    }
  }
}
    `;

/**
 * __useIngestionFolderCountsByPipelineQuery__
 *
 * To run a query within a React component, call `useIngestionFolderCountsByPipelineQuery` and pass it any options that fit your needs.
 * When your component renders, `useIngestionFolderCountsByPipelineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIngestionFolderCountsByPipelineQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useIngestionFolderCountsByPipelineQuery(baseOptions: Apollo.QueryHookOptions<Types.IngestionFolderCountsByPipelineQuery, Types.IngestionFolderCountsByPipelineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IngestionFolderCountsByPipelineQuery, Types.IngestionFolderCountsByPipelineQueryVariables>(IngestionFolderCountsByPipelineDocument, options);
      }
export function useIngestionFolderCountsByPipelineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IngestionFolderCountsByPipelineQuery, Types.IngestionFolderCountsByPipelineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IngestionFolderCountsByPipelineQuery, Types.IngestionFolderCountsByPipelineQueryVariables>(IngestionFolderCountsByPipelineDocument, options);
        }
export type IngestionFolderCountsByPipelineQueryHookResult = ReturnType<typeof useIngestionFolderCountsByPipelineQuery>;
export type IngestionFolderCountsByPipelineLazyQueryHookResult = ReturnType<typeof useIngestionFolderCountsByPipelineLazyQuery>;
export type IngestionFolderCountsByPipelineQueryResult = Apollo.QueryResult<Types.IngestionFolderCountsByPipelineQuery, Types.IngestionFolderCountsByPipelineQueryVariables>;
export const IngestionFolderCountsByStageDocument = gql`
    query ingestionFolderCountsByStage($filters: IngestionFolderCountsByStageFilterArgs!) {
  ingestionFolderCountsByStage(filters: $filters) {
    stageCounts {
      stage
      count
    }
  }
}
    `;

/**
 * __useIngestionFolderCountsByStageQuery__
 *
 * To run a query within a React component, call `useIngestionFolderCountsByStageQuery` and pass it any options that fit your needs.
 * When your component renders, `useIngestionFolderCountsByStageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIngestionFolderCountsByStageQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useIngestionFolderCountsByStageQuery(baseOptions: Apollo.QueryHookOptions<Types.IngestionFolderCountsByStageQuery, Types.IngestionFolderCountsByStageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IngestionFolderCountsByStageQuery, Types.IngestionFolderCountsByStageQueryVariables>(IngestionFolderCountsByStageDocument, options);
      }
export function useIngestionFolderCountsByStageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IngestionFolderCountsByStageQuery, Types.IngestionFolderCountsByStageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IngestionFolderCountsByStageQuery, Types.IngestionFolderCountsByStageQueryVariables>(IngestionFolderCountsByStageDocument, options);
        }
export type IngestionFolderCountsByStageQueryHookResult = ReturnType<typeof useIngestionFolderCountsByStageQuery>;
export type IngestionFolderCountsByStageLazyQueryHookResult = ReturnType<typeof useIngestionFolderCountsByStageLazyQuery>;
export type IngestionFolderCountsByStageQueryResult = Apollo.QueryResult<Types.IngestionFolderCountsByStageQuery, Types.IngestionFolderCountsByStageQueryVariables>;
export const IngestionFolderListDocument = gql`
    query ingestionFolderList($filters: IngestionFolderListFilterArgs!, $includeTransactionPipeline: Boolean! = false, $includeIngestionDocuments: Boolean! = false, $includeRepositionedFields: Boolean! = false, $orderBy: String! = "-updatedAt", $perPage: Int! = 20, $cursor: String) {
  ingestionFolderList(
    filters: $filters
    orderBy: $orderBy
    perPage: $perPage
    cursor: $cursor
  ) {
    results {
      ...IngestionFolderList
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${IngestionFolderListFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useIngestionFolderListQuery__
 *
 * To run a query within a React component, call `useIngestionFolderListQuery` and pass it any options that fit your needs.
 * When your component renders, `useIngestionFolderListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIngestionFolderListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      includeTransactionPipeline: // value for 'includeTransactionPipeline'
 *      includeIngestionDocuments: // value for 'includeIngestionDocuments'
 *      includeRepositionedFields: // value for 'includeRepositionedFields'
 *      orderBy: // value for 'orderBy'
 *      perPage: // value for 'perPage'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useIngestionFolderListQuery(baseOptions: Apollo.QueryHookOptions<Types.IngestionFolderListQuery, Types.IngestionFolderListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IngestionFolderListQuery, Types.IngestionFolderListQueryVariables>(IngestionFolderListDocument, options);
      }
export function useIngestionFolderListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IngestionFolderListQuery, Types.IngestionFolderListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IngestionFolderListQuery, Types.IngestionFolderListQueryVariables>(IngestionFolderListDocument, options);
        }
export type IngestionFolderListQueryHookResult = ReturnType<typeof useIngestionFolderListQuery>;
export type IngestionFolderListLazyQueryHookResult = ReturnType<typeof useIngestionFolderListLazyQuery>;
export type IngestionFolderListQueryResult = Apollo.QueryResult<Types.IngestionFolderListQuery, Types.IngestionFolderListQueryVariables>;
export const IngestionFolderListForOrganizationPipelineViewDocument = gql`
    query IngestionFolderListForOrganizationPipelineView($filters: IngestionFolderListFilterArgs!, $includeInvestigationReason: Boolean! = false, $orderBy: String! = "-updatedAt", $perPage: Int! = 20, $cursor: String) {
  ingestionFolderList(
    filters: $filters
    orderBy: $orderBy
    perPage: $perPage
    cursor: $cursor
  ) {
    results {
      ...IngestionFolderForPipelineView
    }
    pageInfo {
      ...PageInfo
    }
  }
}
    ${IngestionFolderForPipelineViewFragmentDoc}
${PageInfoFragmentDoc}`;

/**
 * __useIngestionFolderListForOrganizationPipelineViewQuery__
 *
 * To run a query within a React component, call `useIngestionFolderListForOrganizationPipelineViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useIngestionFolderListForOrganizationPipelineViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIngestionFolderListForOrganizationPipelineViewQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      includeInvestigationReason: // value for 'includeInvestigationReason'
 *      orderBy: // value for 'orderBy'
 *      perPage: // value for 'perPage'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useIngestionFolderListForOrganizationPipelineViewQuery(baseOptions: Apollo.QueryHookOptions<Types.IngestionFolderListForOrganizationPipelineViewQuery, Types.IngestionFolderListForOrganizationPipelineViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IngestionFolderListForOrganizationPipelineViewQuery, Types.IngestionFolderListForOrganizationPipelineViewQueryVariables>(IngestionFolderListForOrganizationPipelineViewDocument, options);
      }
export function useIngestionFolderListForOrganizationPipelineViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IngestionFolderListForOrganizationPipelineViewQuery, Types.IngestionFolderListForOrganizationPipelineViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IngestionFolderListForOrganizationPipelineViewQuery, Types.IngestionFolderListForOrganizationPipelineViewQueryVariables>(IngestionFolderListForOrganizationPipelineViewDocument, options);
        }
export type IngestionFolderListForOrganizationPipelineViewQueryHookResult = ReturnType<typeof useIngestionFolderListForOrganizationPipelineViewQuery>;
export type IngestionFolderListForOrganizationPipelineViewLazyQueryHookResult = ReturnType<typeof useIngestionFolderListForOrganizationPipelineViewLazyQuery>;
export type IngestionFolderListForOrganizationPipelineViewQueryResult = Apollo.QueryResult<Types.IngestionFolderListForOrganizationPipelineViewQuery, Types.IngestionFolderListForOrganizationPipelineViewQueryVariables>;
export const IngestionFolderPlatformUrlDocument = gql`
    query ingestionFolderPlatformUrl($ingestionFolderId: String!) {
  ingestionFolderPlatformUrl(folderId: $ingestionFolderId)
}
    `;

/**
 * __useIngestionFolderPlatformUrlQuery__
 *
 * To run a query within a React component, call `useIngestionFolderPlatformUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useIngestionFolderPlatformUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIngestionFolderPlatformUrlQuery({
 *   variables: {
 *      ingestionFolderId: // value for 'ingestionFolderId'
 *   },
 * });
 */
export function useIngestionFolderPlatformUrlQuery(baseOptions: Apollo.QueryHookOptions<Types.IngestionFolderPlatformUrlQuery, Types.IngestionFolderPlatformUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.IngestionFolderPlatformUrlQuery, Types.IngestionFolderPlatformUrlQueryVariables>(IngestionFolderPlatformUrlDocument, options);
      }
export function useIngestionFolderPlatformUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.IngestionFolderPlatformUrlQuery, Types.IngestionFolderPlatformUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.IngestionFolderPlatformUrlQuery, Types.IngestionFolderPlatformUrlQueryVariables>(IngestionFolderPlatformUrlDocument, options);
        }
export type IngestionFolderPlatformUrlQueryHookResult = ReturnType<typeof useIngestionFolderPlatformUrlQuery>;
export type IngestionFolderPlatformUrlLazyQueryHookResult = ReturnType<typeof useIngestionFolderPlatformUrlLazyQuery>;
export type IngestionFolderPlatformUrlQueryResult = Apollo.QueryResult<Types.IngestionFolderPlatformUrlQuery, Types.IngestionFolderPlatformUrlQueryVariables>;
export const InternalContractVariableValuesDocument = gql`
    query internalContractVariableValues($input: [ContractVariableValuesInput!]!) {
  internalContractVariableValues(input: $input) {
    contractId
    contractVariableValues
    variableSource
    state
  }
}
    `;

/**
 * __useInternalContractVariableValuesQuery__
 *
 * To run a query within a React component, call `useInternalContractVariableValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalContractVariableValuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalContractVariableValuesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInternalContractVariableValuesQuery(baseOptions: Apollo.QueryHookOptions<Types.InternalContractVariableValuesQuery, Types.InternalContractVariableValuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InternalContractVariableValuesQuery, Types.InternalContractVariableValuesQueryVariables>(InternalContractVariableValuesDocument, options);
      }
export function useInternalContractVariableValuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InternalContractVariableValuesQuery, Types.InternalContractVariableValuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InternalContractVariableValuesQuery, Types.InternalContractVariableValuesQueryVariables>(InternalContractVariableValuesDocument, options);
        }
export type InternalContractVariableValuesQueryHookResult = ReturnType<typeof useInternalContractVariableValuesQuery>;
export type InternalContractVariableValuesLazyQueryHookResult = ReturnType<typeof useInternalContractVariableValuesLazyQuery>;
export type InternalContractVariableValuesQueryResult = Apollo.QueryResult<Types.InternalContractVariableValuesQuery, Types.InternalContractVariableValuesQueryVariables>;
export const InternalGetIngestionDocumentValidationFeedbackDocument = gql`
    query InternalGetIngestionDocumentValidationFeedback($input: GetIngestionDocumentValidationFeedbackInput!) {
  internalGetIngestionDocumentValidationFeedback(input: $input) {
    ...IngestionDocumentValidationFeedback
  }
}
    ${IngestionDocumentValidationFeedbackFragmentDoc}`;

/**
 * __useInternalGetIngestionDocumentValidationFeedbackQuery__
 *
 * To run a query within a React component, call `useInternalGetIngestionDocumentValidationFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalGetIngestionDocumentValidationFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalGetIngestionDocumentValidationFeedbackQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInternalGetIngestionDocumentValidationFeedbackQuery(baseOptions: Apollo.QueryHookOptions<Types.InternalGetIngestionDocumentValidationFeedbackQuery, Types.InternalGetIngestionDocumentValidationFeedbackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InternalGetIngestionDocumentValidationFeedbackQuery, Types.InternalGetIngestionDocumentValidationFeedbackQueryVariables>(InternalGetIngestionDocumentValidationFeedbackDocument, options);
      }
export function useInternalGetIngestionDocumentValidationFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InternalGetIngestionDocumentValidationFeedbackQuery, Types.InternalGetIngestionDocumentValidationFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InternalGetIngestionDocumentValidationFeedbackQuery, Types.InternalGetIngestionDocumentValidationFeedbackQueryVariables>(InternalGetIngestionDocumentValidationFeedbackDocument, options);
        }
export type InternalGetIngestionDocumentValidationFeedbackQueryHookResult = ReturnType<typeof useInternalGetIngestionDocumentValidationFeedbackQuery>;
export type InternalGetIngestionDocumentValidationFeedbackLazyQueryHookResult = ReturnType<typeof useInternalGetIngestionDocumentValidationFeedbackLazyQuery>;
export type InternalGetIngestionDocumentValidationFeedbackQueryResult = Apollo.QueryResult<Types.InternalGetIngestionDocumentValidationFeedbackQuery, Types.InternalGetIngestionDocumentValidationFeedbackQueryVariables>;
export const InternalGetIngestionFolderValidationFeedbackDocument = gql`
    query InternalGetIngestionFolderValidationFeedback($input: GetIngestionFolderValidationFeedbackInput!) {
  internalGetIngestionFolderValidationFeedback(input: $input) {
    ...IngestionFolderValidationFeedback
  }
}
    ${IngestionFolderValidationFeedbackFragmentDoc}`;

/**
 * __useInternalGetIngestionFolderValidationFeedbackQuery__
 *
 * To run a query within a React component, call `useInternalGetIngestionFolderValidationFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalGetIngestionFolderValidationFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalGetIngestionFolderValidationFeedbackQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInternalGetIngestionFolderValidationFeedbackQuery(baseOptions: Apollo.QueryHookOptions<Types.InternalGetIngestionFolderValidationFeedbackQuery, Types.InternalGetIngestionFolderValidationFeedbackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InternalGetIngestionFolderValidationFeedbackQuery, Types.InternalGetIngestionFolderValidationFeedbackQueryVariables>(InternalGetIngestionFolderValidationFeedbackDocument, options);
      }
export function useInternalGetIngestionFolderValidationFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InternalGetIngestionFolderValidationFeedbackQuery, Types.InternalGetIngestionFolderValidationFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InternalGetIngestionFolderValidationFeedbackQuery, Types.InternalGetIngestionFolderValidationFeedbackQueryVariables>(InternalGetIngestionFolderValidationFeedbackDocument, options);
        }
export type InternalGetIngestionFolderValidationFeedbackQueryHookResult = ReturnType<typeof useInternalGetIngestionFolderValidationFeedbackQuery>;
export type InternalGetIngestionFolderValidationFeedbackLazyQueryHookResult = ReturnType<typeof useInternalGetIngestionFolderValidationFeedbackLazyQuery>;
export type InternalGetIngestionFolderValidationFeedbackQueryResult = Apollo.QueryResult<Types.InternalGetIngestionFolderValidationFeedbackQuery, Types.InternalGetIngestionFolderValidationFeedbackQueryVariables>;
export const InternalGetValidationReportDataDocument = gql`
    query InternalGetValidationReportData($input: InternalGetValidationReportDataInput!) {
  internalGetValidationReportData(input: $input) {
    ...InternalValidationReportData
  }
}
    ${InternalValidationReportDataFragmentDoc}`;

/**
 * __useInternalGetValidationReportDataQuery__
 *
 * To run a query within a React component, call `useInternalGetValidationReportDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalGetValidationReportDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalGetValidationReportDataQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInternalGetValidationReportDataQuery(baseOptions: Apollo.QueryHookOptions<Types.InternalGetValidationReportDataQuery, Types.InternalGetValidationReportDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InternalGetValidationReportDataQuery, Types.InternalGetValidationReportDataQueryVariables>(InternalGetValidationReportDataDocument, options);
      }
export function useInternalGetValidationReportDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InternalGetValidationReportDataQuery, Types.InternalGetValidationReportDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InternalGetValidationReportDataQuery, Types.InternalGetValidationReportDataQueryVariables>(InternalGetValidationReportDataDocument, options);
        }
export type InternalGetValidationReportDataQueryHookResult = ReturnType<typeof useInternalGetValidationReportDataQuery>;
export type InternalGetValidationReportDataLazyQueryHookResult = ReturnType<typeof useInternalGetValidationReportDataLazyQuery>;
export type InternalGetValidationReportDataQueryResult = Apollo.QueryResult<Types.InternalGetValidationReportDataQuery, Types.InternalGetValidationReportDataQueryVariables>;
export const InternalIngestionDocumentsForFolderDocument = gql`
    query InternalIngestionDocumentsForFolder($input: InternalIngestionDocumentsForFolderInput!) {
  internalIngestionDocumentsForFolder(input: $input) {
    ...InternalIngestionDocument
  }
}
    ${InternalIngestionDocumentFragmentDoc}`;

/**
 * __useInternalIngestionDocumentsForFolderQuery__
 *
 * To run a query within a React component, call `useInternalIngestionDocumentsForFolderQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalIngestionDocumentsForFolderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalIngestionDocumentsForFolderQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInternalIngestionDocumentsForFolderQuery(baseOptions: Apollo.QueryHookOptions<Types.InternalIngestionDocumentsForFolderQuery, Types.InternalIngestionDocumentsForFolderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InternalIngestionDocumentsForFolderQuery, Types.InternalIngestionDocumentsForFolderQueryVariables>(InternalIngestionDocumentsForFolderDocument, options);
      }
export function useInternalIngestionDocumentsForFolderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InternalIngestionDocumentsForFolderQuery, Types.InternalIngestionDocumentsForFolderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InternalIngestionDocumentsForFolderQuery, Types.InternalIngestionDocumentsForFolderQueryVariables>(InternalIngestionDocumentsForFolderDocument, options);
        }
export type InternalIngestionDocumentsForFolderQueryHookResult = ReturnType<typeof useInternalIngestionDocumentsForFolderQuery>;
export type InternalIngestionDocumentsForFolderLazyQueryHookResult = ReturnType<typeof useInternalIngestionDocumentsForFolderLazyQuery>;
export type InternalIngestionDocumentsForFolderQueryResult = Apollo.QueryResult<Types.InternalIngestionDocumentsForFolderQuery, Types.InternalIngestionDocumentsForFolderQueryVariables>;
export const InternalIngestionFolderListForOrganizationDocument = gql`
    query InternalIngestionFolderListForOrganization($input: InternalIngestionFolderListForOrganizationInput!, $orderBy: String, $perPage: Int, $cursor: String, $includeTransactionPipeline: Boolean! = true, $includeKeyTerms: Boolean! = true) {
  internalIngestionFolderListForOrganization(
    input: $input
    orderBy: $orderBy
    perPage: $perPage
    cursor: $cursor
  ) {
    results {
      ...InternalIngestionFolder
    }
    pageInfo {
      hasNextPage
      hasPrevPage
      nextCursor
      prevCursor
    }
  }
}
    ${InternalIngestionFolderFragmentDoc}`;

/**
 * __useInternalIngestionFolderListForOrganizationQuery__
 *
 * To run a query within a React component, call `useInternalIngestionFolderListForOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalIngestionFolderListForOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalIngestionFolderListForOrganizationQuery({
 *   variables: {
 *      input: // value for 'input'
 *      orderBy: // value for 'orderBy'
 *      perPage: // value for 'perPage'
 *      cursor: // value for 'cursor'
 *      includeTransactionPipeline: // value for 'includeTransactionPipeline'
 *      includeKeyTerms: // value for 'includeKeyTerms'
 *   },
 * });
 */
export function useInternalIngestionFolderListForOrganizationQuery(baseOptions: Apollo.QueryHookOptions<Types.InternalIngestionFolderListForOrganizationQuery, Types.InternalIngestionFolderListForOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InternalIngestionFolderListForOrganizationQuery, Types.InternalIngestionFolderListForOrganizationQueryVariables>(InternalIngestionFolderListForOrganizationDocument, options);
      }
export function useInternalIngestionFolderListForOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InternalIngestionFolderListForOrganizationQuery, Types.InternalIngestionFolderListForOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InternalIngestionFolderListForOrganizationQuery, Types.InternalIngestionFolderListForOrganizationQueryVariables>(InternalIngestionFolderListForOrganizationDocument, options);
        }
export type InternalIngestionFolderListForOrganizationQueryHookResult = ReturnType<typeof useInternalIngestionFolderListForOrganizationQuery>;
export type InternalIngestionFolderListForOrganizationLazyQueryHookResult = ReturnType<typeof useInternalIngestionFolderListForOrganizationLazyQuery>;
export type InternalIngestionFolderListForOrganizationQueryResult = Apollo.QueryResult<Types.InternalIngestionFolderListForOrganizationQuery, Types.InternalIngestionFolderListForOrganizationQueryVariables>;
export const InternalOrganizationListDocument = gql`
    query internalOrganizationList($prodOnly: Boolean) {
  internalOrganizationList(prodOnly: $prodOnly) {
    id
    name
  }
}
    `;

/**
 * __useInternalOrganizationListQuery__
 *
 * To run a query within a React component, call `useInternalOrganizationListQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalOrganizationListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalOrganizationListQuery({
 *   variables: {
 *      prodOnly: // value for 'prodOnly'
 *   },
 * });
 */
export function useInternalOrganizationListQuery(baseOptions?: Apollo.QueryHookOptions<Types.InternalOrganizationListQuery, Types.InternalOrganizationListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.InternalOrganizationListQuery, Types.InternalOrganizationListQueryVariables>(InternalOrganizationListDocument, options);
      }
export function useInternalOrganizationListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.InternalOrganizationListQuery, Types.InternalOrganizationListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.InternalOrganizationListQuery, Types.InternalOrganizationListQueryVariables>(InternalOrganizationListDocument, options);
        }
export type InternalOrganizationListQueryHookResult = ReturnType<typeof useInternalOrganizationListQuery>;
export type InternalOrganizationListLazyQueryHookResult = ReturnType<typeof useInternalOrganizationListLazyQuery>;
export type InternalOrganizationListQueryResult = Apollo.QueryResult<Types.InternalOrganizationListQuery, Types.InternalOrganizationListQueryVariables>;
export const MlQueueJobStatusDocument = gql`
    query mlQueueJobStatus($jobId: String!) {
  mlQueueJobStatus(jobId: $jobId) {
    isFailed
    isCompleted
    isInProgress
  }
}
    `;

/**
 * __useMlQueueJobStatusQuery__
 *
 * To run a query within a React component, call `useMlQueueJobStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useMlQueueJobStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMlQueueJobStatusQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *   },
 * });
 */
export function useMlQueueJobStatusQuery(baseOptions: Apollo.QueryHookOptions<Types.MlQueueJobStatusQuery, Types.MlQueueJobStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.MlQueueJobStatusQuery, Types.MlQueueJobStatusQueryVariables>(MlQueueJobStatusDocument, options);
      }
export function useMlQueueJobStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.MlQueueJobStatusQuery, Types.MlQueueJobStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.MlQueueJobStatusQuery, Types.MlQueueJobStatusQueryVariables>(MlQueueJobStatusDocument, options);
        }
export type MlQueueJobStatusQueryHookResult = ReturnType<typeof useMlQueueJobStatusQuery>;
export type MlQueueJobStatusLazyQueryHookResult = ReturnType<typeof useMlQueueJobStatusLazyQuery>;
export type MlQueueJobStatusQueryResult = Apollo.QueryResult<Types.MlQueueJobStatusQuery, Types.MlQueueJobStatusQueryVariables>;
export const OfferIngestionAutofillVariablesSchemaDocument = gql`
    query offerIngestionAutofillVariablesSchema {
  offerIngestionAutofillVariablesSchema
}
    `;

/**
 * __useOfferIngestionAutofillVariablesSchemaQuery__
 *
 * To run a query within a React component, call `useOfferIngestionAutofillVariablesSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferIngestionAutofillVariablesSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferIngestionAutofillVariablesSchemaQuery({
 *   variables: {
 *   },
 * });
 */
export function useOfferIngestionAutofillVariablesSchemaQuery(baseOptions?: Apollo.QueryHookOptions<Types.OfferIngestionAutofillVariablesSchemaQuery, Types.OfferIngestionAutofillVariablesSchemaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OfferIngestionAutofillVariablesSchemaQuery, Types.OfferIngestionAutofillVariablesSchemaQueryVariables>(OfferIngestionAutofillVariablesSchemaDocument, options);
      }
export function useOfferIngestionAutofillVariablesSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OfferIngestionAutofillVariablesSchemaQuery, Types.OfferIngestionAutofillVariablesSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OfferIngestionAutofillVariablesSchemaQuery, Types.OfferIngestionAutofillVariablesSchemaQueryVariables>(OfferIngestionAutofillVariablesSchemaDocument, options);
        }
export type OfferIngestionAutofillVariablesSchemaQueryHookResult = ReturnType<typeof useOfferIngestionAutofillVariablesSchemaQuery>;
export type OfferIngestionAutofillVariablesSchemaLazyQueryHookResult = ReturnType<typeof useOfferIngestionAutofillVariablesSchemaLazyQuery>;
export type OfferIngestionAutofillVariablesSchemaQueryResult = Apollo.QueryResult<Types.OfferIngestionAutofillVariablesSchemaQuery, Types.OfferIngestionAutofillVariablesSchemaQueryVariables>;
export const OfferIngestionDocumentAutofillVariablesSchemaDocument = gql`
    query offerIngestionDocumentAutofillVariablesSchema {
  offerIngestionDocumentAutofillVariablesSchema
}
    `;

/**
 * __useOfferIngestionDocumentAutofillVariablesSchemaQuery__
 *
 * To run a query within a React component, call `useOfferIngestionDocumentAutofillVariablesSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferIngestionDocumentAutofillVariablesSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOfferIngestionDocumentAutofillVariablesSchemaQuery({
 *   variables: {
 *   },
 * });
 */
export function useOfferIngestionDocumentAutofillVariablesSchemaQuery(baseOptions?: Apollo.QueryHookOptions<Types.OfferIngestionDocumentAutofillVariablesSchemaQuery, Types.OfferIngestionDocumentAutofillVariablesSchemaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OfferIngestionDocumentAutofillVariablesSchemaQuery, Types.OfferIngestionDocumentAutofillVariablesSchemaQueryVariables>(OfferIngestionDocumentAutofillVariablesSchemaDocument, options);
      }
export function useOfferIngestionDocumentAutofillVariablesSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OfferIngestionDocumentAutofillVariablesSchemaQuery, Types.OfferIngestionDocumentAutofillVariablesSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OfferIngestionDocumentAutofillVariablesSchemaQuery, Types.OfferIngestionDocumentAutofillVariablesSchemaQueryVariables>(OfferIngestionDocumentAutofillVariablesSchemaDocument, options);
        }
export type OfferIngestionDocumentAutofillVariablesSchemaQueryHookResult = ReturnType<typeof useOfferIngestionDocumentAutofillVariablesSchemaQuery>;
export type OfferIngestionDocumentAutofillVariablesSchemaLazyQueryHookResult = ReturnType<typeof useOfferIngestionDocumentAutofillVariablesSchemaLazyQuery>;
export type OfferIngestionDocumentAutofillVariablesSchemaQueryResult = Apollo.QueryResult<Types.OfferIngestionDocumentAutofillVariablesSchemaQuery, Types.OfferIngestionDocumentAutofillVariablesSchemaQueryVariables>;
export const OrganizationValidationSettingsDocument = gql`
    query organizationValidationSettings($transactionPipelineId: String!, $transactionStageId: String!, $organizationId: String) {
  organizationValidationSettings(
    organizationId: $organizationId
    transactionPipelineId: $transactionPipelineId
    transactionStageId: $transactionStageId
  ) {
    stageIgnoredRuleIds
    documentIgnoredRuleIds
    configuredOrganizations {
      organizationId
      stageIgnoredRuleIds
      documentIgnoredRuleIds
    }
  }
}
    `;

/**
 * __useOrganizationValidationSettingsQuery__
 *
 * To run a query within a React component, call `useOrganizationValidationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationValidationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationValidationSettingsQuery({
 *   variables: {
 *      transactionPipelineId: // value for 'transactionPipelineId'
 *      transactionStageId: // value for 'transactionStageId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationValidationSettingsQuery(baseOptions: Apollo.QueryHookOptions<Types.OrganizationValidationSettingsQuery, Types.OrganizationValidationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.OrganizationValidationSettingsQuery, Types.OrganizationValidationSettingsQueryVariables>(OrganizationValidationSettingsDocument, options);
      }
export function useOrganizationValidationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.OrganizationValidationSettingsQuery, Types.OrganizationValidationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.OrganizationValidationSettingsQuery, Types.OrganizationValidationSettingsQueryVariables>(OrganizationValidationSettingsDocument, options);
        }
export type OrganizationValidationSettingsQueryHookResult = ReturnType<typeof useOrganizationValidationSettingsQuery>;
export type OrganizationValidationSettingsLazyQueryHookResult = ReturnType<typeof useOrganizationValidationSettingsLazyQuery>;
export type OrganizationValidationSettingsQueryResult = Apollo.QueryResult<Types.OrganizationValidationSettingsQuery, Types.OrganizationValidationSettingsQueryVariables>;
export const PreviewFieldsToColumnDocument = gql`
    query previewFieldsToColumn($contractId: ID!) {
  previewFieldsToColumn(contractId: $contractId)
}
    `;

/**
 * __usePreviewFieldsToColumnQuery__
 *
 * To run a query within a React component, call `usePreviewFieldsToColumnQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewFieldsToColumnQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewFieldsToColumnQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function usePreviewFieldsToColumnQuery(baseOptions: Apollo.QueryHookOptions<Types.PreviewFieldsToColumnQuery, Types.PreviewFieldsToColumnQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PreviewFieldsToColumnQuery, Types.PreviewFieldsToColumnQueryVariables>(PreviewFieldsToColumnDocument, options);
      }
export function usePreviewFieldsToColumnLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PreviewFieldsToColumnQuery, Types.PreviewFieldsToColumnQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PreviewFieldsToColumnQuery, Types.PreviewFieldsToColumnQueryVariables>(PreviewFieldsToColumnDocument, options);
        }
export type PreviewFieldsToColumnQueryHookResult = ReturnType<typeof usePreviewFieldsToColumnQuery>;
export type PreviewFieldsToColumnLazyQueryHookResult = ReturnType<typeof usePreviewFieldsToColumnLazyQuery>;
export type PreviewFieldsToColumnQueryResult = Apollo.QueryResult<Types.PreviewFieldsToColumnQuery, Types.PreviewFieldsToColumnQueryVariables>;
export const PreviewReassignIngestionFolderPipelinesDocument = gql`
    query PreviewReassignIngestionFolderPipelines($input: PreviewReassignIngestionFolderPipelinesInput!) {
  previewReassignIngestionFolderPipelines(input: $input) {
    results {
      ingestionFolderUuid
      currentPipelineUuid
      currentPipelineName
      currentStage
      proposedPipelineUuid
      proposedPipelineName
      proposedStage
      proposedMatchedBy
      candidates {
        pipelineUuid
        pipelineName
        clientType
        usState
        transactionPropertyType
        matchedBy
        ruleMatchFormula
      }
      needsInvestigationReason
      error
    }
  }
}
    `;

/**
 * __usePreviewReassignIngestionFolderPipelinesQuery__
 *
 * To run a query within a React component, call `usePreviewReassignIngestionFolderPipelinesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewReassignIngestionFolderPipelinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewReassignIngestionFolderPipelinesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePreviewReassignIngestionFolderPipelinesQuery(baseOptions: Apollo.QueryHookOptions<Types.PreviewReassignIngestionFolderPipelinesQuery, Types.PreviewReassignIngestionFolderPipelinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.PreviewReassignIngestionFolderPipelinesQuery, Types.PreviewReassignIngestionFolderPipelinesQueryVariables>(PreviewReassignIngestionFolderPipelinesDocument, options);
      }
export function usePreviewReassignIngestionFolderPipelinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.PreviewReassignIngestionFolderPipelinesQuery, Types.PreviewReassignIngestionFolderPipelinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.PreviewReassignIngestionFolderPipelinesQuery, Types.PreviewReassignIngestionFolderPipelinesQueryVariables>(PreviewReassignIngestionFolderPipelinesDocument, options);
        }
export type PreviewReassignIngestionFolderPipelinesQueryHookResult = ReturnType<typeof usePreviewReassignIngestionFolderPipelinesQuery>;
export type PreviewReassignIngestionFolderPipelinesLazyQueryHookResult = ReturnType<typeof usePreviewReassignIngestionFolderPipelinesLazyQuery>;
export type PreviewReassignIngestionFolderPipelinesQueryResult = Apollo.QueryResult<Types.PreviewReassignIngestionFolderPipelinesQuery, Types.PreviewReassignIngestionFolderPipelinesQueryVariables>;
export const RuleListDocument = gql`
    query ruleList($filters: RuleListFilterArgs!, $orderBy: String, $perPage: Int, $cursor: String) {
  ruleList(
    filters: $filters
    orderBy: $orderBy
    perPage: $perPage
    cursor: $cursor
  ) {
    pageInfo {
      ...PageInfo
    }
    results {
      ...Rule
    }
  }
}
    ${PageInfoFragmentDoc}
${RuleFragmentDoc}`;

/**
 * __useRuleListQuery__
 *
 * To run a query within a React component, call `useRuleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRuleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuleListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      orderBy: // value for 'orderBy'
 *      perPage: // value for 'perPage'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useRuleListQuery(baseOptions: Apollo.QueryHookOptions<Types.RuleListQuery, Types.RuleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.RuleListQuery, Types.RuleListQueryVariables>(RuleListDocument, options);
      }
export function useRuleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.RuleListQuery, Types.RuleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.RuleListQuery, Types.RuleListQueryVariables>(RuleListDocument, options);
        }
export type RuleListQueryHookResult = ReturnType<typeof useRuleListQuery>;
export type RuleListLazyQueryHookResult = ReturnType<typeof useRuleListLazyQuery>;
export type RuleListQueryResult = Apollo.QueryResult<Types.RuleListQuery, Types.RuleListQueryVariables>;
export const RuleMissingKeysDocument = gql`
    query RuleMissingKeys($transactionRuleId: ID!, $ruleId: ID!) {
  ruleMissingKeys(transactionRuleId: $transactionRuleId, ruleId: $ruleId) {
    ruleId
    documentVersionsMissingKeys {
      documentId
      documentVersionId
      version
      searchRegex
      missingMappingKeys
    }
  }
}
    `;

/**
 * __useRuleMissingKeysQuery__
 *
 * To run a query within a React component, call `useRuleMissingKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useRuleMissingKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuleMissingKeysQuery({
 *   variables: {
 *      transactionRuleId: // value for 'transactionRuleId'
 *      ruleId: // value for 'ruleId'
 *   },
 * });
 */
export function useRuleMissingKeysQuery(baseOptions: Apollo.QueryHookOptions<Types.RuleMissingKeysQuery, Types.RuleMissingKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.RuleMissingKeysQuery, Types.RuleMissingKeysQueryVariables>(RuleMissingKeysDocument, options);
      }
export function useRuleMissingKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.RuleMissingKeysQuery, Types.RuleMissingKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.RuleMissingKeysQuery, Types.RuleMissingKeysQueryVariables>(RuleMissingKeysDocument, options);
        }
export type RuleMissingKeysQueryHookResult = ReturnType<typeof useRuleMissingKeysQuery>;
export type RuleMissingKeysLazyQueryHookResult = ReturnType<typeof useRuleMissingKeysLazyQuery>;
export type RuleMissingKeysQueryResult = Apollo.QueryResult<Types.RuleMissingKeysQuery, Types.RuleMissingKeysQueryVariables>;
export const SearchIngestionFoldersForValidationDocument = gql`
    query SearchIngestionFoldersForValidation($filters: IngestionFolderValidationFiltersInput!) {
  searchIngestionFoldersForValidation(filters: $filters) {
    folders {
      uuid
      folderName
      organizationId
      organizationName
      transactionPipelineId
      transactionPipelineName
      platform
      metadataFolderId
      lastValidationDate
      lastUpdatedAt
      createdAt
      stage
      normalizedStatus
      transactionSide
    }
    totalCount
    cappedToLimit
  }
}
    `;

/**
 * __useSearchIngestionFoldersForValidationQuery__
 *
 * To run a query within a React component, call `useSearchIngestionFoldersForValidationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchIngestionFoldersForValidationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchIngestionFoldersForValidationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSearchIngestionFoldersForValidationQuery(baseOptions: Apollo.QueryHookOptions<Types.SearchIngestionFoldersForValidationQuery, Types.SearchIngestionFoldersForValidationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SearchIngestionFoldersForValidationQuery, Types.SearchIngestionFoldersForValidationQueryVariables>(SearchIngestionFoldersForValidationDocument, options);
      }
export function useSearchIngestionFoldersForValidationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SearchIngestionFoldersForValidationQuery, Types.SearchIngestionFoldersForValidationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SearchIngestionFoldersForValidationQuery, Types.SearchIngestionFoldersForValidationQueryVariables>(SearchIngestionFoldersForValidationDocument, options);
        }
export type SearchIngestionFoldersForValidationQueryHookResult = ReturnType<typeof useSearchIngestionFoldersForValidationQuery>;
export type SearchIngestionFoldersForValidationLazyQueryHookResult = ReturnType<typeof useSearchIngestionFoldersForValidationLazyQuery>;
export type SearchIngestionFoldersForValidationQueryResult = Apollo.QueryResult<Types.SearchIngestionFoldersForValidationQuery, Types.SearchIngestionFoldersForValidationQueryVariables>;
export const SignatureInitialDatasetFilesDocument = gql`
    query signatureInitialDatasetFiles {
  signatureInitialDatasetFiles {
    draft {
      key
    }
    active {
      key
    }
    original {
      key
    }
    invalid {
      key
    }
    validations {
      key
    }
  }
}
    `;

/**
 * __useSignatureInitialDatasetFilesQuery__
 *
 * To run a query within a React component, call `useSignatureInitialDatasetFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignatureInitialDatasetFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignatureInitialDatasetFilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSignatureInitialDatasetFilesQuery(baseOptions?: Apollo.QueryHookOptions<Types.SignatureInitialDatasetFilesQuery, Types.SignatureInitialDatasetFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SignatureInitialDatasetFilesQuery, Types.SignatureInitialDatasetFilesQueryVariables>(SignatureInitialDatasetFilesDocument, options);
      }
export function useSignatureInitialDatasetFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SignatureInitialDatasetFilesQuery, Types.SignatureInitialDatasetFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SignatureInitialDatasetFilesQuery, Types.SignatureInitialDatasetFilesQueryVariables>(SignatureInitialDatasetFilesDocument, options);
        }
export type SignatureInitialDatasetFilesQueryHookResult = ReturnType<typeof useSignatureInitialDatasetFilesQuery>;
export type SignatureInitialDatasetFilesLazyQueryHookResult = ReturnType<typeof useSignatureInitialDatasetFilesLazyQuery>;
export type SignatureInitialDatasetFilesQueryResult = Apollo.QueryResult<Types.SignatureInitialDatasetFilesQuery, Types.SignatureInitialDatasetFilesQueryVariables>;
export const SignatureInitialsDatasetMetricsDocument = gql`
    query signatureInitialsDatasetMetrics($input: SignatureInitialsDatasetMetricsInput!) {
  signatureInitialsDatasetMetrics(input: $input) {
    draft {
      usState
      formName
      count
    }
    final {
      usState
      formName
      count
    }
  }
}
    `;

/**
 * __useSignatureInitialsDatasetMetricsQuery__
 *
 * To run a query within a React component, call `useSignatureInitialsDatasetMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSignatureInitialsDatasetMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSignatureInitialsDatasetMetricsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignatureInitialsDatasetMetricsQuery(baseOptions: Apollo.QueryHookOptions<Types.SignatureInitialsDatasetMetricsQuery, Types.SignatureInitialsDatasetMetricsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.SignatureInitialsDatasetMetricsQuery, Types.SignatureInitialsDatasetMetricsQueryVariables>(SignatureInitialsDatasetMetricsDocument, options);
      }
export function useSignatureInitialsDatasetMetricsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.SignatureInitialsDatasetMetricsQuery, Types.SignatureInitialsDatasetMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.SignatureInitialsDatasetMetricsQuery, Types.SignatureInitialsDatasetMetricsQueryVariables>(SignatureInitialsDatasetMetricsDocument, options);
        }
export type SignatureInitialsDatasetMetricsQueryHookResult = ReturnType<typeof useSignatureInitialsDatasetMetricsQuery>;
export type SignatureInitialsDatasetMetricsLazyQueryHookResult = ReturnType<typeof useSignatureInitialsDatasetMetricsLazyQuery>;
export type SignatureInitialsDatasetMetricsQueryResult = Apollo.QueryResult<Types.SignatureInitialsDatasetMetricsQuery, Types.SignatureInitialsDatasetMetricsQueryVariables>;
export const TransactionPipelineListDocument = gql`
    query transactionPipelineList($filters: TransactionPipelineListFilterArgs!, $includeRule: Boolean! = false, $includeStages: Boolean! = false, $includeTransactionRules: Boolean! = false) {
  transactionPipelineList(filters: $filters) {
    ...TransactionPipelineList
  }
}
    ${TransactionPipelineListFragmentDoc}`;

/**
 * __useTransactionPipelineListQuery__
 *
 * To run a query within a React component, call `useTransactionPipelineListQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionPipelineListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionPipelineListQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      includeRule: // value for 'includeRule'
 *      includeStages: // value for 'includeStages'
 *      includeTransactionRules: // value for 'includeTransactionRules'
 *   },
 * });
 */
export function useTransactionPipelineListQuery(baseOptions: Apollo.QueryHookOptions<Types.TransactionPipelineListQuery, Types.TransactionPipelineListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TransactionPipelineListQuery, Types.TransactionPipelineListQueryVariables>(TransactionPipelineListDocument, options);
      }
export function useTransactionPipelineListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TransactionPipelineListQuery, Types.TransactionPipelineListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TransactionPipelineListQuery, Types.TransactionPipelineListQueryVariables>(TransactionPipelineListDocument, options);
        }
export type TransactionPipelineListQueryHookResult = ReturnType<typeof useTransactionPipelineListQuery>;
export type TransactionPipelineListLazyQueryHookResult = ReturnType<typeof useTransactionPipelineListLazyQuery>;
export type TransactionPipelineListQueryResult = Apollo.QueryResult<Types.TransactionPipelineListQuery, Types.TransactionPipelineListQueryVariables>;
export const TransactionPipelineUsStatesDocument = gql`
    query transactionPipelineUsStates {
  transactionPipelineUsStates
}
    `;

/**
 * __useTransactionPipelineUsStatesQuery__
 *
 * To run a query within a React component, call `useTransactionPipelineUsStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionPipelineUsStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionPipelineUsStatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTransactionPipelineUsStatesQuery(baseOptions?: Apollo.QueryHookOptions<Types.TransactionPipelineUsStatesQuery, Types.TransactionPipelineUsStatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TransactionPipelineUsStatesQuery, Types.TransactionPipelineUsStatesQueryVariables>(TransactionPipelineUsStatesDocument, options);
      }
export function useTransactionPipelineUsStatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TransactionPipelineUsStatesQuery, Types.TransactionPipelineUsStatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TransactionPipelineUsStatesQuery, Types.TransactionPipelineUsStatesQueryVariables>(TransactionPipelineUsStatesDocument, options);
        }
export type TransactionPipelineUsStatesQueryHookResult = ReturnType<typeof useTransactionPipelineUsStatesQuery>;
export type TransactionPipelineUsStatesLazyQueryHookResult = ReturnType<typeof useTransactionPipelineUsStatesLazyQuery>;
export type TransactionPipelineUsStatesQueryResult = Apollo.QueryResult<Types.TransactionPipelineUsStatesQuery, Types.TransactionPipelineUsStatesQueryVariables>;
export const TransactionRuleMissingKeysDocument = gql`
    query TransactionRuleMissingKeys($transactionRuleId: ID!) {
  transactionRuleMissingKeys(transactionRuleId: $transactionRuleId) {
    transactionRuleId
    documentVersionsMissingKeys {
      documentId
      documentVersionId
      version
      searchRegex
      missingMappingKeys
    }
  }
}
    `;

/**
 * __useTransactionRuleMissingKeysQuery__
 *
 * To run a query within a React component, call `useTransactionRuleMissingKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionRuleMissingKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionRuleMissingKeysQuery({
 *   variables: {
 *      transactionRuleId: // value for 'transactionRuleId'
 *   },
 * });
 */
export function useTransactionRuleMissingKeysQuery(baseOptions: Apollo.QueryHookOptions<Types.TransactionRuleMissingKeysQuery, Types.TransactionRuleMissingKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<Types.TransactionRuleMissingKeysQuery, Types.TransactionRuleMissingKeysQueryVariables>(TransactionRuleMissingKeysDocument, options);
      }
export function useTransactionRuleMissingKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<Types.TransactionRuleMissingKeysQuery, Types.TransactionRuleMissingKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<Types.TransactionRuleMissingKeysQuery, Types.TransactionRuleMissingKeysQueryVariables>(TransactionRuleMissingKeysDocument, options);
        }
export type TransactionRuleMissingKeysQueryHookResult = ReturnType<typeof useTransactionRuleMissingKeysQuery>;
export type TransactionRuleMissingKeysLazyQueryHookResult = ReturnType<typeof useTransactionRuleMissingKeysLazyQuery>;
export type TransactionRuleMissingKeysQueryResult = Apollo.QueryResult<Types.TransactionRuleMissingKeysQuery, Types.TransactionRuleMissingKeysQueryVariables>;